export const VALIDGUESSES = [
  'ameba',
  'amebe',
  'amebo',
  'ameri',
  'amiǆa',
  'amila',
  'amile',
  'amili',
  'amilu',
  'amina',
  'amine',
  'amini',
  'amino',
  'aminu',
  'amper',
  'ampir',
  'amuri',
  'amuru',
  'anala',
  'anale',
  'anali',
  'analu',
  'anata',
  'anati',
  'anđel',
  'anđeo',
  'aneks',
  'angel',
  'angie',
  'angus',
  'anica',
  'anime',
  'anion',
  'anisa',
  'anise',
  'anisi',
  'anita',
  'anker',
  'anoda',
  'anode',
  'anodi',
  'anodu',
  'antić',
  'antom',
  'anton',
  'antun',
  'anusa',
  'anusi',
  'anusu',
  'aorta',
  'aorte',
  'aorti',
  'aortu',
  'apeks',
  'apela',
  'apele',
  'apeli',
  'apelu',
  'apoen',
  'apolo',
  'april',
  'araka',
  'arama',
  'arapa',
  'arape',
  'arapi',
  'arbor',
  'arbun',
  'arden',
  'areal',
  'arena',
  'arene',
  'areni',
  'arenu',
  'argon',
  'arhiv',
  'ariel',
  'arija',
  'arije',
  'ariji',
  'ariju',
  'ariǉe',
  'arima',
  'arina',
  'arini',
  'arino',
  'arinu',
  'ariša',
  'ariši',
  'arišu',
  'arkom',
  'aroma',
  'arome',
  'aromi',
  'aromu',
  'arpad',
  'arsen',
  'aršin',
  'artur',
  'asean',
  'asker',
  'asket',
  'aslan',
  'asova',
  'asove',
  'asovi',
  'asovu',
  'astat',
  'aston',
  'astor',
  'asura',
  'asure',
  'asuri',
  'asuru',
  'ataci',
  'ataka',
  'atake',
  'atara',
  'ataru',
  'ataše',
  'ateǉe',
  'atena',
  'atest',
  'atila',
  'atile',
  'atili',
  'atilo',
  'atilu',
  'atina',
  'atine',
  'atini',
  'atinu',
  'atlas',
  'atlet',
  'atola',
  'atole',
  'atoli',
  'atolu',
  'atoma',
  'atome',
  'atomi',
  'atomu',
  'atona',
  'atoni',
  'atonu',
  'atrij',
  'audio',
  'augur',
  'aulom',
  'aurom',
  'autić',
  'autom',
  'autor',
  'avala',
  'avale',
  'avana',
  'avani',
  'avans',
  'avanu',
  'avara',
  'avari',
  'avers',
  'aveti',
  'avion',
  'aviva',
  'avivu',
  'avnoj',
  'avram',
  'azija',
  'azije',
  'aziji',
  'aziju',
  'azila',
  'azili',
  'azilu',
  'azoik',
  'azola',
  'azole',
  'azoli',
  'azota',
  'azote',
  'azura',
  'azuri',
  'azuru',
  'babac',
  'babić',
  'babin',
  'babǉa',
  'babǉe',
  'babǉi',
  'babom',
  'babun',
  'bacač',
  'bacam',
  'bacan',
  'bacao',
  'bacat',
  'bačen',
  'bačić',
  'bacil',
  'bacio',
  'bacit',
  'bačka',
  'bačke',
  'bački',
  'bačko',
  'bačku',
  'bačva',
  'bačve',
  'bačvi',
  'bačvu',
  'badaǌ',
  'badem',
  'baden',
  'badǌa',
  'badǌe',
  'badǌi',
  'badǌu',
  'bager',
  'bagra',
  'bagri',
  'bahat',
  'bajaj',
  'bajam',
  'bajan',
  'bajat',
  'bajci',
  'bajer',
  'bajić',
  'bajin',
  'bajka',
  'bajke',
  'bajki',
  'bajko',
  'bajku',
  'bajna',
  'bajne',
  'bajni',
  'bajno',
  'bajnu',
  'bajta',
  'bajte',
  'bajti',
  'bajtu',
  'bakar',
  'baker',
  'bakić',
  'bakin',
  'bakǉa',
  'bakǉe',
  'bakǉi',
  'bakǉu',
  'bakom',
  'bakra',
  'bakre',
  'bakri',
  'bakru',
  'balet',
  'balim',
  'balio',
  'balom',
  'balon',
  'balša',
  'balun',
  'bambi',
  'banak',
  'banat',
  'banci',
  'banči',
  'banda',
  'bande',
  'bandi',
  'bando',
  'bandu',
  'banem',
  'banja',
  'banje',
  'banji',
  'banjo',
  'baǌoj',
  'baǌom',
  'banju',
  'banka',
  'banke',
  'banki',
  'banko',
  'banku',
  'banom',
  'banov',
  'bantu',
  'banuh',
  'banuo',
  'banut',
  'barak',
  'baran',
  'baraž',
  'barba',
  'barbe',
  'barbi',
  'barbo',
  'barbu',
  'barci',
  'barda',
  'barde',
  'bardi',
  'bardu',
  'barel',
  'barem',
  'barić',
  'barij',
  'barit',
  'barka',
  'barke',
  'barku',
  'barok',
  'barom',
  'baron',
  'barta',
  'barun',
  'barut',
  'bašča',
  'bašče',
  'bašči',
  'bašču',
  'based',
  'basen',
  'basic',
  'bašić',
  'baška',
  'basma',
  'basna',
  'basne',
  'basni',
  'basnu',
  'basom',
  'basov',
  'bašta',
  'bašte',
  'bašti',
  'baštu',
  'batak',
  'batat',
  'bates',
  'batić',
  'batik',
  'batom',
  'baton',
  'bauci',
  'bauka',
  'bauke',
  'bavim',
  'bavio',
  'baviš',
  'bavit',
  'bazar',
  'bazen',
  'bazga',
  'bazgi',
  'bazgu',
  'bazna',
  'bazne',
  'bazni',
  'bazno',
  'baznu',
  'bazom',
  'bdeǌe',
  'bdije',
  'bdiju',
  'bebin',
  'bebom',
  'bećar',
  'bečej',
  'bečka',
  'bečke',
  'bečki',
  'bečko',
  'bečku',
  'bedak',
  'bedar',
  'bedem',
  'bedra',
  'bedro',
  'bedru',
  'bedža',
  'bedžu',
  'begom',
  'begov',
  'behar',
  'being',
  'beker',
  'bekom',
  'belaj',
  'belci',
  'beleg',
  'belić',
  'belih',
  'belim',
  'belin',
  'belje',
  'belji',
  'belog',
  'beloj',
  'belom',
  'belot',
  'benda',
  'bendu',
  'benǆa',
  'benǆo',
  'benǆu',
  'benet',
  'benin',
  'benom',
  'berač',
  'berba',
  'berbe',
  'berbi',
  'berbu',
  'berem',
  'beril',
  'bernu',
  'berta',
  'berza',
  'berze',
  'berzi',
  'berzu',
  'besan',
  'besni',
  'besom',
  'betom',
  'beton',
  'bezub',
  'bibac',
  'bibao',
  'biber',
  'bićem',
  'bičem',
  'bićeš',
  'bičić',
  'bičje',
  'bičuj',
  'bidea',
  'bidei',
  'bideu',
  'bifea',
  'bifei',
  'bifeu',
  'bigot',
  'bihać',
  'bijah',
  'bijeg',
  'bijel',
  'bijem',
  'bijes',
  'bijte',
  'bikom',
  'bikov',
  'bilbo',
  'bilić',
  'bilin',
  'bilja',
  'biǉar',
  'biǉci',
  'bilje',
  'biǉeg',
  'biǉem',
  'biǉka',
  'biǉke',
  'biǉki',
  'biǉku',
  'biǉna',
  'biǉne',
  'biǉni',
  'biǉno',
  'biǉnu',
  'bilju',
  'bilom',
  'binar',
  'bingo',
  'binom',
  'biped',
  'birac',
  'birač',
  'biraj',
  'biram',
  'biran',
  'birao',
  'biroa',
  'biroe',
  'biroi',
  'birou',
  'biser',
  'bismo',
  'bista',
  'biste',
  'bisti',
  'bistu',
  'bitak',
  'bitan',
  'bitci',
  'bitef',
  'bitka',
  'bitke',
  'bitki',
  'bitku',
  'bitna',
  'bitne',
  'bitni',
  'bitno',
  'bitnu',
  'bitoǉ',
  'bitom',
  'bivak',
  'bivao',
  'bivol',
  'bivša',
  'bivše',
  'bivši',
  'bivšu',
  'bizon',
  'bjaše',
  'bjehu',
  'bjeǉa',
  'bjeǉi',
  'bješe',
  'bježe',
  'bježi',
  'blace',
  'black',
  'blade',
  'blaga',
  'blage',
  'blagi',
  'blago',
  'blagu',
  'blair',
  'blake',
  'blaǌa',
  'blaǌe',
  'blata',
  'blate',
  'blati',
  'blato',
  'blatu',
  'blaža',
  'blaze',
  'blaže',
  'blaži',
  'blažo',
  'blažu',
  'bleda',
  'bledi',
  'bledo',
  'bledu',
  'bleje',
  'bleji',
  'blenu',
  'blica',
  'blicu',
  'bliža',
  'bliže',
  'bliži',
  'blizu',
  'bližu',
  'bǉeđa',
  'bǉeđe',
  'bǉeđi',
  'bǉuje',
  'bǉuva',
  'block',
  'bloga',
  'blogu',
  'bloka',
  'bloku',
  'bluda',
  'bludi',
  'bludu',
  'blues',
  'bluna',
  'bluni',
  'blunt',
  'blunu',
  'bluza',
  'bluze',
  'bluzu',
  'board',
  'bobak',
  'boban',
  'bobić',
  'bobom',
  'boćan',
  'bocka',
  'boćna',
  'bočna',
  'bocne',
  'bočne',
  'bocni',
  'boćni',
  'bočni',
  'boćno',
  'bočno',
  'bocnu',
  'bočnu',
  'bocom',
  'bodac',
  'bodar',
  'bodem',
  'boden',
  'bodež',
  'bodin',
  'bodǉa',
  'bodǉe',
  'bodǉi',
  'bodǉu',
  'bodom',
  'bodra',
  'bodre',
  'bodri',
  'bodru',
  'bodul',
  'boema',
  'boemi',
  'bogac',
  'bogaǉ',
  'bogat',
  'bogme',
  'bogom',
  'boing',
  'boini',
  'bojah',
  'bojan',
  'bojao',
  'bojat',
  'bojem',
  'bojen',
  'bojić',
  'bojim',
  'bojio',
  'bojiš',
  'bojmo',
  'bojna',
  'bojne',
  'bojni',
  'bojno',
  'bojnu',
  'bojom',
  'bojte',
  'bokal',
  'bokca',
  'bokci',
  'bokcu',
  'bokom',
  'bokor',
  'boksa',
  'boksu',
  'bolan',
  'bolid',
  'bolio',
  'boliš',
  'bolja',
  'boǉar',
  'bolje',
  'boǉeg',
  'boǉem',
  'bolji',
  'boǉih',
  'boǉim',
  'boǉka',
  'boǉke',
  'boǉoj',
  'boǉom',
  'bolju',
  'bolna',
  'bolne',
  'bolni',
  'bolno',
  'bolnu',
  'bolom',
  'bolta',
  'bolte',
  'bolto',
  'boltu',
  'bomba',
  'bombe',
  'bombi',
  'bombo',
  'bombu',
  'bonda',
  'boner',
  'bones',
  'bongo',
  'bonom',
  'bonus',
  'borac',
  'borah',
  'borak',
  'boran',
  'borat',
  'borba',
  'borbe',
  'borbi',
  'borbu',
  'borca',
  'borce',
  'borče',
  'borci',
  'borcu',
  'borda',
  'bordo',
  'borer',
  'borić',
  'borik',
  'borim',
  'borio',
  'boris',
  'boriš',
  'borit',
  'borja',
  'borje',
  'borju',
  'borka',
  'borke',
  'borko',
  'borku',
  'borna',
  'borni',
  'borno',
  'bornu',
  'borom',
  'borov',
  'boršč',
  'bosco',
  'bosih',
  'boška',
  'boško',
  'bosna',
  'bosne',
  'bosni',
  'bosnu',
  'bosog',
  'bosoj',
  'bosom',
  'bosti',
  'bovom',
  'božić',
  'božja',
  'božje',
  'božji',
  'božju',
  'bozom',
  'bozon',
  'božur',
  'braca',
  'braća',
  'brace',
  'braće',
  'braci',
  'braći',
  'braco',
  'braćo',
  'bracu',
  'braću',
  'braču',
  'brada',
  'brade',
  'bradi',
  'bradu',
  'braka',
  'braku',
  'brala',
  'brale',
  'brali',
  'bralo',
  'brana',
  'brand',
  'brane',
  'brani',
  'braǌa',
  'braǌe',
  'braǌu',
  'brano',
  'brant',
  'branu',
  'braon',
  'brata',
  'brate',
  'brati',
  'bratu',
  'braun',
  'brava',
  'brave',
  'bravi',
  'bravo',
  'bravu',
  'brčić',
  'brčka',
  'brčko',
  'break',
  'breče',
  'breči',
  'breda',
  'bređa',
  'brega',
  'bregu',
  'breka',
  'breme',
  'brena',
  'brend',
  'brent',
  'brest',
  'breta',
  'breza',
  'breze',
  'brezi',
  'brezo',
  'brezu',
  'brian',
  'brica',
  'brice',
  'brick',
  'brico',
  'brida',
  'bridi',
  'bridu',
  'bridž',
  'briǆa',
  'briǆu',
  'briga',
  'brige',
  'brigo',
  'brigu',
  'brije',
  'briju',
  'brine',
  'brini',
  'brinu',
  'brisa',
  'brise',
  'briše',
  'briši',
  'brisu',
  'brišu',
  'brizi',
  'brock',
  'broda',
  'brode',
  'brodi',
  'brodu',
  'broja',
  'broje',
  'broji',
  'broju',
  'broma',
  'bromu',
  'bronh',
  'broša',
  'broza',
  'bruce',
  'bruha',
  'bruja',
  'bruji',
  'bruju',
  'bruka',
  'bruku',
  'bruna',
  'bruno',
  'brusa',
  'bruse',
  'brusi',
  'brusu',
  'bruto',
  'bržeg',
  'bržem',
  'bržih',
  'bržim',
  'bržoj',
  'bržom',
  'bubam',
  'bubaǌ',
  'bubne',
  'bubni',
  'bubǌa',
  'bubǌi',
  'bubǌu',
  'bubnu',
  'bubom',
  'bubre',
  'bubri',
  'bučah',
  'bučan',
  'bučja',
  'bučje',
  'bučju',
  'bučna',
  'bučne',
  'bučni',
  'bučno',
  'bučnu',
  'bucom',
  'budak',
  'budan',
  'budem',
  'budeš',
  'budim',
  'budio',
  'budiš',
  'budna',
  'budne',
  'budni',
  'budno',
  'budnu',
  'budva',
  'budve',
  'budvi',
  'buǆak',
  'buǆet',
  'bugar',
  'buhač',
  'buhom',
  'bujad',
  'bujan',
  'bujao',
  'bujna',
  'bujne',
  'bujni',
  'bujno',
  'bujnu',
  'bujon',
  'bukač',
  'buket',
  'bukne',
  'bukni',
  'buknu',
  'bukom',
  'bukov',
  'bukta',
  'bukti',
  'bukva',
  'bukve',
  'bukvi',
  'bukvu',
  'bulić',
  'bulje',
  'bulji',
  'buǉim',
  'buǉio',
  'bulka',
  'bulom',
  'bunar',
  'bunca',
  'bunda',
  'bunde',
  'bundi',
  'bundo',
  'bundu',
  'bunio',
  'bunja',
  'bunje',
  'bunji',
  'bunjo',
  'bunju',
  'bunom',
  'bunta',
  'bunte',
  'buntu',
  'burad',
  'burag',
  'buran',
  'buraz',
  'burek',
  'burić',
  'burin',
  'burka',
  'burke',
  'burma',
  'burme',
  'burmi',
  'burmu',
  'burna',
  'burne',
  'burni',
  'burno',
  'burnu',
  'burom',
  'bursa',
  'burse',
  'bursi',
  'bursu',
  'burza',
  'burze',
  'burzi',
  'bušač',
  'busam',
  'bušel',
  'busen',
  'bušen',
  'busha',
  'busom',
  'bušom',
  'butan',
  'butik',
  'butna',
  'butne',
  'butni',
  'čabar',
  'cable',
  'cabot',
  'čabra',
  'čabru',
  'čačak',
  'čačić',
  'čačka',
  'čačku',
  'čađav',
  'čador',
  'čagaǉ',
  'čagǉu',
  'caine',
  'čajem',
  'čajna',
  'čajne',
  'čajni',
  'čajno',
  'čajnu',
  'cakli',
  'čakǉa',
  'čakǉi',
  'cakom',
  'čakra',
  'čakri',
  'čakru',
  'čalma',
  'čalmi',
  'čalmu',
  'čamac',
  'čamca',
  'čamce',
  'čamci',
  'čamcu',
  'čamio',
  'čanak',
  'čanci',
  'čanka',
  'canon',
  'čapǉa',
  'čapǉe',
  'čapǉi',
  'čapǉu',
  'čarda',
  'čarde',
  'carem',
  'carev',
  'carić',
  'čarka',
  'čarke',
  'čarki',
  'carla',
  'čarli',
  'carlo',
  'carlu',
  'carol',
  'carov',
  'časak',
  'čašću',
  'ćaska',
  'časka',
  'čaška',
  'časke',
  'čaške',
  'čaški',
  'čašku',
  'časna',
  'časne',
  'časni',
  'časno',
  'časnu',
  'časom',
  'čašom',
  'časte',
  'časti',
  'cause',
  'čavao',
  'čavić',
  'čavka',
  'čavke',
  'čavki',
  'čavla',
  'čavle',
  'čavli',
  'čavlu',
  'cazin',
  'ćebad',
  'cecil',
  'čedan',
  'cedar',
  'čedar',
  'čedna',
  'čedni',
  'čednu',
  'čedom',
  'cedra',
  'cedri',
  'ceger',
  'cehom',
  'čehov',
  'čehra',
  'čekaj',
  'čekam',
  'čekao',
  'čekaš',
  'čekat',
  'ceker',
  'čekić',
  'cekin',
  'cekum',
  'ćelav',
  'celer',
  'celia',
  'celih',
  'celik',
  'čelik',
  'celim',
  'čeǉad',
  'celju',
  'čelna',
  'čelne',
  'čelni',
  'čelno',
  'čelnu',
  'celog',
  'celoj',
  'celom',
  'čelom',
  'čemer',
  'cener',
  'ceǌen',
  'centa',
  'cente',
  'centi',
  'centu',
  'čeona',
  'čeone',
  'čeoni',
  'čeono',
  'čeonu',
  'čepić',
  'cepin',
  'čepom',
  'cepte',
  'cepti',
  'cerak',
  'cerek',
  'čerga',
  'čerge',
  'cerij',
  'cerit',
  'cerja',
  'cerje',
  'cerju',
  'ćerka',
  'ćerke',
  'ćerki',
  'ćerku',
  'cerom',
  'cerov',
  'česaǉ',
  'češaǉ',
  'češao',
  'cesar',
  'češća',
  'češće',
  'češći',
  'češću',
  'češem',
  'češer',
  'češka',
  'češke',
  'češki',
  'češko',
  'češku',
  'češǉa',
  'češǉu',
  'česma',
  'česme',
  'česmi',
  'česmu',
  'cesna',
  'češǌa',
  'cesta',
  'česta',
  'ceste',
  'česte',
  'cesti',
  'česti',
  'cesto',
  'često',
  'cestu',
  'čestu',
  'četin',
  'četka',
  'četke',
  'četki',
  'četku',
  'četni',
  'četom',
  'četri',
  'ćevap',
  'cezar',
  'cezij',
  'čezne',
  'čežǌa',
  'čežǌe',
  'čežǌi',
  'čežǌu',
  'čeznu',
  'cibet',
  'čibuk',
  'čičak',
  'cicao',
  'čičci',
  'čička',
  'čičke',
  'čičku',
  'cicom',
  'cifra',
  'cifre',
  'cifri',
  'cifru',
  'cigan',
  'cigla',
  'cigle',
  'cigli',
  'ciglo',
  'ciglu',
  'čigoč',
  'čigra',
  'čigre',
  'čigru',
  'cijan',
  'cijeđ',
  'čijeg',
  'cijel',
  'čijem',
  'cijev',
  'čijih',
  'čijim',
  'čijoj',
  'čijom',
  'cijuk',
  'cikla',
  'cikle',
  'cikli',
  'ciklo',
  'čikma',
  'cikne',
  'cikni',
  'ciknu',
  'cikot',
  'čilea',
  'čileu',
  'cilik',
  'ćilim',
  'cilja',
  'ciǉam',
  'ciǉan',
  'ciǉao',
  'ciǉaš',
  'ciǉem',
  'ciǉna',
  'ciǉne',
  'ciǉni',
  'ciǉno',
  'ciǉnu',
  'cilju',
  'ciman',
  'cimer',
  'cimet',
  'cimom',
  'cinik',
  'činim',
  'činio',
  'činiš',
  'činit',
  'cinka',
  'cinku',
  'činom',
  'čioda',
  'čiode',
  'cipal',
  'čipka',
  'čipke',
  'čipki',
  'čipku',
  'cipla',
  'ciple',
  'cipli',
  'ciplu',
  'čipom',
  'čipsa',
  'čipsu',
  'ćirić',
  'čirić',
  'cirih',
  'cirka',
  'čirom',
  'cirus',
  'čišća',
  'čišće',
  'čišći',
  'cisco',
  'cista',
  'čista',
  'ciste',
  'čiste',
  'cisti',
  'čisti',
  'cisto',
  'čisto',
  'cistu',
  'čistu',
  'ćitab',
  'čitač',
  'čitaj',
  'čitak',
  'čitam',
  'čitan',
  'čitao',
  'čitaš',
  'citat',
  'čitat',
  'čitav',
  'čitka',
  'čitki',
  'čitko',
  'citra',
  'citre',
  'citri',
  'citro',
  'citru',
  'civil',
  'čizma',
  'čizme',
  'čizmo',
  'čizmu',
  'clair',
  'člana',
  'člane',
  'članu',
  'clara',
  'clare',
  'clark',
  'clear',
  'click',
  'clint',
  'clive',
  'close',
  'cloud',
  'cmari',
  'coban',
  'čoban',
  'cobra',
  'cohen',
  'čohom',
  'čokot',
  'čolić',
  'colin',
  'colom',
  'color',
  'ćopav',
  'čoper',
  'ćopić',
  'čopor',
  'copra',
  'ćorav',
  'čorba',
  'čorbe',
  'čorbi',
  'čorbo',
  'čorbu',
  'ćorci',
  'ćorda',
  'ćorka',
  'ćošak',
  'ćosić',
  'ćoška',
  'ćošku',
  'costa',
  'could',
  'court',
  'covek',
  'čovek',
  'čović',
  'craig',
  'crane',
  'crash',
  'cream',
  'creva',
  'crevo',
  'crevu',
  'crǌak',
  'cucla',
  'čučǌa',
  'čučǌu',
  'čučnu',
  'čudak',
  'čudan',
  'čudim',
  'čudio',
  'čudiš',
  'čudna',
  'čudne',
  'čudni',
  'čudno',
  'čudnu',
  'čudom',
  'cugaj',
  'čujan',
  'čujem',
  'čuješ',
  'čujni',
  'čujno',
  'čujte',
  'čulan',
  'čulna',
  'čulne',
  'čulni',
  'čulno',
  'čulnu',
  'čulom',
  'ćumur',
  'čunak',
  'cunja',
  'cunje',
  'cunji',
  'čuǌić',
  'cuǌom',
  'cunju',
  'čunom',
  'čupao',
  'čupav',
  'ćupić',
  'cupka',
  'čupka',
  'curak',
  'ćuran',
  'curci',
  'curio',
  'curit',
  'ćurka',
  'curke',
  'ćurke',
  'ćurki',
  'curom',
  'ćušci',
  'ćuška',
  'čuste',
  'ćutao',
  'ćutim',
  'ćutke',
  'ćutuk',
  'čuvaj',
  'čuvam',
  'čuvan',
  'čuvao',
  'čuvar',
  'čuvaš',
  'čuvat',
  'čuven',
  'čuvši',
  'cvala',
  'cvale',
  'cvali',
  'cvalo',
  'cvast',
  'cvata',
  'cvate',
  'cvati',
  'cvatu',
  'cveća',
  'cvece',
  'cveće',
  'cveta',
  'cvili',
  'čvora',
  'čvoru',
  'dabar',
  'dabra',
  'dabru',
  'đačić',
  'đačka',
  'đačke',
  'đački',
  'đačko',
  'đačku',
  'dadem',
  'dadne',
  'dadoh',
  'dagǌa',
  'dagǌe',
  'dagǌi',
  'dahau',
  'dahne',
  'dahnu',
  'dahom',
  'daira',
  'daire',
  'dajǆa',
  'dajem',
  'daješ',
  'dajmo',
  'dajte',
  'dakle',
  'đakom',
  'đakon',
  'đakov',
  'dalaj',
  'dalas',
  'dalek',
  'dalih',
  'dalim',
  'dalja',
  'dalje',
  'daǉeg',
  'daǉem',
  'dalji',
  'daǉih',
  'daǉim',
  'daǉǌa',
  'daǉǌe',
  'daǉǌi',
  'daǉǌo',
  'daǉǌu',
  'daǉoj',
  'daǉom',
  'dalju',
  'daloj',
  'dalom',
  'damin',
  'damir',
  'damom',
  'damon',
  'danak',
  'danas',
  'dance',
  'danče',
  'danci',
  'danih',
  'danim',
  'danin',
  'danio',
  'danja',
  'danje',
  'daǌeg',
  'daǌem',
  'danji',
  'daǌih',
  'danju',
  'danka',
  'danke',
  'danko',
  'danku',
  'danog',
  'danoj',
  'danom',
  'dante',
  'daria',
  'dario',
  'daris',
  'darja',
  'darka',
  'darke',
  'darko',
  'darku',
  'darne',
  'darni',
  'darnu',
  'darom',
  'daruj',
  'dašak',
  'dasci',
  'daska',
  'daška',
  'daske',
  'daške',
  'daski',
  'dasku',
  'dasmo',
  'daste',
  'dašto',
  'datih',
  'datim',
  'dativ',
  'datog',
  'datoj',
  'datom',
  'datum',
  'davan',
  'davao',
  'đavao',
  'davat',
  'davea',
  'david',
  'davim',
  'davio',
  'davis',
  'davit',
  'đavla',
  'davna',
  'davne',
  'davni',
  'davno',
  'davnu',
  'đavol',
  'davor',
  'davši',
  'deana',
  'death',
  'debeo',
  'debil',
  'debla',
  'debǉa',
  'debǉe',
  'debǉi',
  'debǉu',
  'deblo',
  'deblu',
  'debra',
  'dečak',
  'dečja',
  'dečje',
  'dečji',
  'dečka',
  'dečke',
  'dečki',
  'dečko',
  'dečku',
  'decom',
  'dedić',
  'dedom',
  'deist',
  'dejan',
  'dejli',
  'dekan',
  'dekom',
  'dekor',
  'delfi',
  'delhi',
  'delia',
  'delić',
  'delim',
  'delio',
  'deǉiv',
  'delom',
  'delta',
  'delte',
  'delti',
  'deltu',
  'demir',
  'demon',
  'denar',
  'dendi',
  'denga',
  'denge',
  'dengi',
  'denić',
  'denis',
  'denta',
  'deobe',
  'depoa',
  'depoe',
  'depoi',
  'depou',
  'derač',
  'đeram',
  'deran',
  'derao',
  'derat',
  'derbi',
  'derek',
  'derem',
  'đerma',
  'deset',
  'desio',
  'desiš',
  'desit',
  'desna',
  'desne',
  'desni',
  'desno',
  'desnu',
  'detaǉ',
  'dever',
  'devet',
  'devil',
  'devin',
  'devom',
  'devon',
  'diana',
  'diane',
  'dičan',
  'dicka',
  'dična',
  'diega',
  'diego',
  'diegu',
  'digao',
  'digla',
  'digle',
  'digli',
  'diglo',
  'digne',
  'digni',
  'dignu',
  'digoh',
  'dikom',
  'dilan',
  'đilas',
  'dildo',
  'diler',
  'diǉem',
  'diǉka',
  'dimić',
  'dimna',
  'dimne',
  'dimni',
  'dimno',
  'dimnu',
  'dimom',
  'dinar',
  'dinga',
  'dingo',
  'dingu',
  'dinić',
  'dinja',
  'dinje',
  'diǌom',
  'dinju',
  'dinka',
  'dinko',
  'dinom',
  'dioba',
  'diobe',
  'diobi',
  'diobu',
  'dioda',
  'diode',
  'diodi',
  'diodu',
  'diona',
  'dione',
  'dioni',
  'dionu',
  'dipol',
  'diraj',
  'diram',
  'diran',
  'dirao',
  'dirka',
  'dirne',
  'dirni',
  'dirnu',
  'disao',
  'disat',
  'disco',
  'dišem',
  'diska',
  'disko',
  'disku',
  'dišna',
  'dišne',
  'dišni',
  'divac',
  'divan',
  'divim',
  'divin',
  'divio',
  'diviš',
  'divit',
  'divka',
  'divǉa',
  'divǉe',
  'divǉi',
  'divǉu',
  'divna',
  'divne',
  'divni',
  'divno',
  'divnu',
  'divom',
  'divov',
  'dizač',
  'dizah',
  'dizao',
  'dizat',
  'dizel',
  'dižem',
  'dizni',
  'djeca',
  'djece',
  'djeci',
  'djeco',
  'djecu',
  'djeda',
  'djede',
  'djedu',
  'djela',
  'djele',
  'djeli',
  'djelo',
  'djelu',
  'djene',
  'djeni',
  'djenu',
  'djeva',
  'djeve',
  'djevi',
  'djevo',
  'dlaci',
  'dlaka',
  'dlake',
  'dlako',
  'dlaku',
  'dlana',
  'dlanu',
  'dnima',
  'dobar',
  'dobij',
  'dobio',
  'dobit',
  'dobna',
  'dobne',
  'dobni',
  'dobno',
  'dobnu',
  'doboj',
  'dobom',
  'dobos',
  'dobra',
  'dobre',
  'dobri',
  'dobro',
  'dobru',
  'dobuj',
  'doček',
  'dočim',
  'dodah',
  'dodaj',
  'dodam',
  'dodan',
  'dodao',
  'dodaš',
  'dodat',
  'dođem',
  'dođeš',
  'dodge',
  'dodik',
  'dodir',
  'dodje',
  'dođoh',
  'đogat',
  'dogma',
  'dogme',
  'dogmi',
  'dogmu',
  'dogom',
  'doima',
  'dojam',
  'dojci',
  'dojka',
  'dojke',
  'dojki',
  'dojku',
  'dojma',
  'dojmi',
  'dojmu',
  'dokad',
  'dokaz',
  'đokić',
  'dokle',
  'dokom',
  'dokon',
  'dolac',
  'dolaf',
  'dolap',
  'dolar',
  'dolca',
  'dolce',
  'dolče',
  'dolci',
  'dolcu',
  'dolet',
  'dolih',
  'dolja',
  'dolje',
  'doǉǌa',
  'doǉǌi',
  'dolma',
  'dolom',
  'domak',
  'domar',
  'domen',
  'domet',
  'domom',
  'donde',
  'doneo',
  'doner',
  'donet',
  'donio',
  'donja',
  'donje',
  'doǌeg',
  'doǌem',
  'donji',
  'doǌih',
  'doǌim',
  'donjo',
  'doǌoj',
  'doǌom',
  'donju',
  'donom',
  'đonom',
  'donor',
  'donos',
  'donov',
  'dopao',
  'dopis',
  'dopre',
  'dopri',
  'dopro',
  'dopru',
  'đorđa',
  'đorđe',
  'đorđu',
  'doris',
  'dosad',
  'došao',
  'doseg',
  'došen',
  'dosje',
  'došla',
  'došle',
  'došli',
  'došlo',
  'dospe',
  'dospi',
  'dosta',
  'dotad',
  'dotle',
  'dotok',
  'doume',
  'dovde',
  'doveo',
  'dover',
  'dovle',
  'dovod',
  'dovoz',
  'doziv',
  'dozna',
  'dozom',
  'dozre',
  'drača',
  'drače',
  'draco',
  'draču',
  'draga',
  'drage',
  'dragi',
  'drago',
  'dragu',
  'drajv',
  'drake',
  'drama',
  'drame',
  'drami',
  'dramu',
  'drapa',
  'drave',
  'draža',
  'draže',
  'draži',
  'dražo',
  'dražu',
  'dream',
  'dreka',
  'dreke',
  'drena',
  'dresa',
  'dresu',
  'drila',
  'drilu',
  'drima',
  'drina',
  'drine',
  'drini',
  'driǌa',
  'drinu',
  'drive',
  'drobe',
  'drobi',
  'droga',
  'droge',
  'drogi',
  'drogo',
  'drogu',
  'droǉa',
  'droǉu',
  'drona',
  'drozd',
  'dršće',
  'dršci',
  'dršću',
  'drška',
  'drške',
  'drški',
  'dršku',
  'druga',
  'druge',
  'drugi',
  'drugo',
  'drugu',
  'druid',
  'druma',
  'drume',
  'drumu',
  'druže',
  'druži',
  'držač',
  'držak',
  'držan',
  'držao',
  'držat',
  'držić',
  'držim',
  'držiš',
  'duane',
  'dubai',
  'dubao',
  'dubio',
  'dubiš',
  'dubla',
  'duble',
  'dubli',
  'dubǉa',
  'dubǉe',
  'dubǉi',
  'dubǉu',
  'dubok',
  'dubom',
  'dubov',
  'đubra',
  'đubre',
  'đubri',
  'dućan',
  'dučić',
  'dudaš',
  'dudom',
  'dudov',
  'duela',
  'duele',
  'dueli',
  'duelu',
  'dueta',
  'duete',
  'dueti',
  'duetu',
  'dugan',
  'dugih',
  'dugim',
  'dugin',
  'dugme',
  'dugog',
  'dugoj',
  'dugom',
  'duhan',
  'duhom',
  'duima',
  'dukat',
  'dukić',
  'đukić',
  'dukǉe',
  'dukom',
  'dulja',
  'dulje',
  'duǉeg',
  'duǉem',
  'dulji',
  'duǉim',
  'duǉoj',
  'dulju',
  'dulum',
  'dunav',
  'dunja',
  'dunje',
  'dunji',
  'dunjo',
  'duǌom',
  'dunju',
  'dunum',
  'dupin',
  'dupke',
  'dupla',
  'duple',
  'dupli',
  'dupǉa',
  'dupǉe',
  'dupǉi',
  'dupǉu',
  'duplo',
  'duplu',
  'đurađ',
  'durah',
  'duram',
  'duran',
  'đurđa',
  'đurđe',
  'đurđu',
  'đurić',
  'durio',
  'dušah',
  'dušak',
  'dušan',
  'dušče',
  'dušek',
  'dušik',
  'duška',
  'duške',
  'duško',
  'dušku',
  'dušni',
  'dušom',
  'duval',
  'duvan',
  'duvao',
  'duvar',
  'đuveč',
  'dužan',
  'dužda',
  'duždu',
  'dužeg',
  'dužem',
  'dužih',
  'dužim',
  'dužio',
  'dužna',
  'dužne',
  'dužni',
  'dužno',
  'dužnu',
  'dužoj',
  'dužom',
  'dvaju',
  'dvama',
  'dveju',
  'dvema',
  'dvera',
  'dveri',
  'dvica',
  'dvici',
  'dvije',
  'dviju',
  'dvoga',
  'dvoja',
  'dvoje',
  'dvoji',
  'dvoju',
  'dvoma',
  'dvora',
  'dvore',
  'dvori',
  'dvoru',
  'džaba',
  'džabe',
  'džaka',
  'ǆakom',
  'džbun',
  'džejn',
  'džeka',
  'džeki',
  'ǆelat',
  'džema',
  'ǆemre',
  'džemu',
  'dženi',
  'džepa',
  'ǆepna',
  'ǆepne',
  'ǆepni',
  'ǆepno',
  'ǆepnu',
  'ǆepom',
  'džepu',
  'džeri',
  'ǆerzi',
  'džeza',
  'ǆezom',
  'džezu',
  'ǆezva',
  'ǆezve',
  'ǆezvi',
  'ǆezvu',
  'ǆihad',
  'džima',
  'džimi',
  'džina',
  'džine',
  'ǆinom',
  'džipa',
  'ǆipom',
  'ǆokej',
  'ǆoker',
  'džona',
  'džoni',
  'ǆonom',
  'džons',
  'džonu',
  'ǆorǆa',
  'ǆozef',
  'džuda',
  'džudi',
  'džudo',
  'ǆudom',
  'džudu',
  'džula',
  'džuli',
  'ǆunka',
  'eagle',
  'earla',
  'earle',
  'edema',
  'edeme',
  'edemi',
  'edemu',
  'edena',
  'edene',
  'edenu',
  'edgar',
  'edija',
  'edikt',
  'edita',
  'edith',
  'editu',
  'efekt',
  'efesu',
  'egidi',
  'egido',
  'egzil',
  'ehima',
  'ekcem',
  'ekipa',
  'ekipe',
  'ekipi',
  'ekipo',
  'ekipu',
  'ekran',
  'eksaj',
  'ekser',
  'elana',
  'elane',
  'elani',
  'elena',
  'elias',
  'eliot',
  'elisa',
  'elise',
  'elisi',
  'eliso',
  'elisu',
  'elita',
  'elite',
  'eliti',
  'elito',
  'elitu',
  'eliza',
  'elmer',
  'elsie',
  'elton',
  'elvis',
  'email',
  'emajl',
  'emila',
  'emile',
  'emili',
  'emina',
  'emira',
  'emire',
  'emiri',
  'emiru',
  'endem',
  'enter',
  'enver',
  'enzim',
  'eonom',
  'eparh',
  'epici',
  'epika',
  'epike',
  'epiko',
  'epiku',
  'epira',
  'epoha',
  'epohe',
  'epohi',
  'epohu',
  'eposi',
  'epova',
  'epove',
  'epovi',
  'eprom',
  'erama',
  'erara',
  'eraru',
  'erato',
  'erbij',
  'erica',
  'erika',
  'ernie',
  'erosa',
  'erosu',
  'ervin',
  'eseja',
  'eseje',
  'eseji',
  'eseju',
  'esena',
  'eseni',
  'esnaf',
  'ester',
  'estet',
  'etana',
  'etani',
  'etapa',
  'etape',
  'etapi',
  'etapu',
  'etara',
  'etaža',
  'etaže',
  'etaži',
  'etažu',
  'etera',
  'etere',
  'eteri',
  'eteru',
  'ethan',
  'ethel',
  'etici',
  'etida',
  'etide',
  'etidi',
  'etidu',
  'etika',
  'etike',
  'etiku',
  'etile',
  'etnik',
  'etnos',
  'etosa',
  'etosi',
  'etosu',
  'eugen',
  'eunuh',
  'eurom',
  'evans',
  'event',
  'fabio',
  'facom',
  'facto',
  'fagot',
  'faith',
  'fajla',
  'fajlu',
  'fakat',
  'fakin',
  'fakir',
  'faksa',
  'fakse',
  'fakta',
  'fakte',
  'fakti',
  'fakto',
  'falim',
  'falio',
  'false',
  'falus',
  'famom',
  'fanom',
  'farba',
  'farbe',
  'farbi',
  'farbu',
  'fargo',
  'faris',
  'farma',
  'farme',
  'farmi',
  'farmu',
  'farsa',
  'farse',
  'farsi',
  'farsu',
  'fatal',
  'fatum',
  'fauna',
  'faune',
  'fauni',
  'faunu',
  'faust',
  'fazan',
  'fazna',
  'fazne',
  'fazni',
  'fazno',
  'faznu',
  'fazom',
  'fazon',
  'feces',
  'feder',
  'feler',
  'felga',
  'felge',
  'felgi',
  'feǌer',
  'fenol',
  'fenom',
  'fensi',
  'fesom',
  'festa',
  'fešta',
  'fešte',
  'fešti',
  'feštu',
  'fetiš',
  'fetus',
  'fetva',
  'fetve',
  'fetvi',
  'fetvu',
  'feuda',
  'feude',
  'fidel',
  'field',
  'figom',
  'fijuk',
  'fikus',
  'filca',
  'files',
  'filip',
  'filir',
  'filma',
  'filme',
  'filmu',
  'filom',
  'final',
  'finci',
  'finih',
  'finim',
  'finiš',
  'finog',
  'finoj',
  'finom',
  'finta',
  'finte',
  'finti',
  'finto',
  'fioka',
  'fioke',
  'fiona',
  'firer',
  'firma',
  'firme',
  'firmi',
  'firmo',
  'firmu',
  'fišek',
  'fišer',
  'fitiǉ',
  'fjord',
  'flaka',
  'flaša',
  'flaše',
  'flash',
  'flaši',
  'flašu',
  'fleka',
  'fleke',
  'fleku',
  'flert',
  'fleša',
  'flint',
  'flirt',
  'floem',
  'flopi',
  'flora',
  'flore',
  'flori',
  'floro',
  'floru',
  'flota',
  'flote',
  'floti',
  'floto',
  'flotu',
  'fluid',
  'fluks',
  'fluor',
  'foaje',
  'focus',
  'fokin',
  'fokom',
  'fokus',
  'fonda',
  'fonde',
  'fondi',
  'fondu',
  'fonem',
  'fonta',
  'fonte',
  'fontu',
  'force',
  'forda',
  'forde',
  'fordi',
  'fordu',
  'forge',
  'forma',
  'forme',
  'formi',
  'formo',
  'formu',
  'forom',
  'forte',
  'forum',
  'fosil',
  'fotka',
  'foton',
  'fotos',
  'fraka',
  'fraku',
  'frame',
  'franc',
  'frane',
  'fraǌa',
  'fraǌe',
  'fraǌi',
  'fraǌo',
  'fraǌu',
  'frank',
  'frano',
  'frans',
  'franz',
  'frape',
  'fraza',
  'fraze',
  'frazi',
  'frazu',
  'freda',
  'frede',
  'fredi',
  'frend',
  'frenk',
  'freon',
  'freud',
  'freza',
  'frida',
  'friza',
  'frizu',
  'frojd',
  'front',
  'frost',
  'frula',
  'frule',
  'fruli',
  'frulu',
  'fucaj',
  'fugom',
  'fukao',
  'funta',
  'funte',
  'funti',
  'funtu',
  'furaj',
  'furam',
  'furao',
  'furat',
  'furka',
  'futog',
  'futur',
  'gabor',
  'gacka',
  'gacko',
  'gadan',
  'gađan',
  'gađao',
  'gadiš',
  'gadna',
  'gadne',
  'gadno',
  'gadnu',
  'gadom',
  'gaǆin',
  'gaeta',
  'gajah',
  'gajba',
  'gajbi',
  'gajbu',
  'gajde',
  'gajdi',
  'gajem',
  'gajen',
  'gajev',
  'gajić',
  'gajio',
  'galeb',
  'galić',
  'galij',
  'galin',
  'galom',
  'galon',
  'galop',
  'gamad',
  'games',
  'gamom',
  'gandi',
  'ganem',
  'ganeš',
  'ganga',
  'gangu',
  'ganja',
  'gaǌam',
  'gaǌao',
  'gaǌaš',
  'ganut',
  'garav',
  'garda',
  'garde',
  'gardi',
  'gardu',
  'garež',
  'garib',
  'garza',
  'gašen',
  'gasio',
  'gasna',
  'gasne',
  'gasni',
  'gasno',
  'gasnu',
  'gasom',
  'gatar',
  'gatat',
  'gates',
  'gatka',
  'gatke',
  'gaučo',
  'gauda',
  'gavan',
  'gavez',
  'gavin',
  'gavro',
  'gavun',
  'gazda',
  'gazde',
  'gazdi',
  'gazdu',
  'gažen',
  'gazio',
  'gazit',
  'gazom',
  'gđica',
  'gđice',
  'gđici',
  'gđicu',
  'gegaj',
  'gegom',
  'gejša',
  'gejše',
  'gejši',
  'gejšu',
  'geler',
  'gelom',
  'gemom',
  'genij',
  'genom',
  'georg',
  'gepek',
  'gerda',
  'germa',
  'germe',
  'germi',
  'germu',
  'gesla',
  'geslo',
  'geslu',
  'gesta',
  'geste',
  'gesti',
  'gesto',
  'gestu',
  'getom',
  'ghost',
  'gibak',
  'gibon',
  'gihta',
  'gilda',
  'gilde',
  'gildi',
  'gildo',
  'gildu',
  'giles',
  'ginem',
  'gipka',
  'gipki',
  'gipku',
  'gipsa',
  'gipsu',
  'gizda',
  'gizdi',
  'gizdu',
  'glađa',
  'glade',
  'glađe',
  'gladi',
  'glađi',
  'glađu',
  'glanc',
  'glasa',
  'glase',
  'glasi',
  'glasu',
  'glava',
  'glave',
  'glavi',
  'glavo',
  'glavu',
  'gleda',
  'glede',
  'gleđi',
  'gleđu',
  'gliba',
  'glina',
  'gline',
  'glini',
  'glinu',
  'gǉiva',
  'gǉive',
  'gǉivi',
  'gǉivu',
  'globa',
  'globe',
  'globi',
  'globo',
  'globu',
  'glođu',
  'gloga',
  'glogu',
  'glosa',
  'glose',
  'glosi',
  'glosu',
  'gluha',
  'gluhe',
  'gluhi',
  'gluho',
  'gluma',
  'glume',
  'glumi',
  'glumu',
  'gluon',
  'glupa',
  'glupe',
  'glupi',
  'glupo',
  'gluvi',
  'gmižu',
  'gneva',
  'gǌave',
  'gǌavi',
  'gǌeče',
  'gǌeči',
  'gǌeva',
  'gǌevu',
  'gǌida',
  'gǌide',
  'gǌila',
  'gǌili',
  'gǌilo',
  'gǌiti',
  'gnoja',
  'gnoji',
  'gnoma',
  'gnome',
  'gnomi',
  'gnoza',
  'gnoze',
  'gnozi',
  'gnozu',
  'godit',
  'godom',
  'gogoǉ',
  'going',
  'gojan',
  'gojka',
  'gojko',
  'gojna',
  'gojni',
  'gojnu',
  'golać',
  'golem',
  'golet',
  'golfa',
  'golfe',
  'golfu',
  'golih',
  'golim',
  'golja',
  'goǉak',
  'golji',
  'golju',
  'golog',
  'goloj',
  'golom',
  'golub',
  'gomez',
  'gomoǉ',
  'gonga',
  'gonič',
  'gonim',
  'gonio',
  'gonja',
  'goǌen',
  'gonzo',
  'gorah',
  'gorak',
  'goran',
  'gorča',
  'gorče',
  'gorda',
  'gorde',
  'gordi',
  'gordo',
  'goreg',
  'gorem',
  'gorih',
  'gorim',
  'gorio',
  'goriš',
  'goriv',
  'gorja',
  'gorje',
  'gorju',
  'gorka',
  'gorke',
  'gorki',
  'gorko',
  'gorku',
  'gorǌa',
  'gorǌe',
  'gorǌi',
  'gorǌo',
  'gorǌu',
  'goroj',
  'gorom',
  'gošća',
  'gošće',
  'gospa',
  'gospe',
  'gospi',
  'gospo',
  'gospu',
  'gosta',
  'goste',
  'gosti',
  'gosto',
  'gostu',
  'gotov',
  'gould',
  'govna',
  'govno',
  'govnu',
  'govor',
  'gozba',
  'gozbe',
  'gozbi',
  'gozbu',
  'graba',
  'grabe',
  'grabi',
  'grabo',
  'grabu',
  'grace',
  'gracu',
  'grada',
  'građa',
  'grade',
  'građe',
  'gradi',
  'građi',
  'gradu',
  'građu',
  'grafa',
  'grafe',
  'grafu',
  'graha',
  'grahu',
  'graja',
  'graju',
  'grala',
  'gralu',
  'grama',
  'grame',
  'grami',
  'gramu',
  'grana',
  'grand',
  'grane',
  'grani',
  'graǌa',
  'graǌe',
  'graǌu',
  'grano',
  'grant',
  'granu',
  'graše',
  'grčem',
  'grčić',
  'grčka',
  'grčke',
  'grčki',
  'grčko',
  'grčku',
  'great',
  'grebe',
  'grebi',
  'grebu',
  'greda',
  'grede',
  'gredi',
  'gredu',
  'greha',
  'grehe',
  'greje',
  'grejp',
  'grejs',
  'gremi',
  'gresi',
  'greta',
  'grije',
  'griju',
  'grila',
  'grile',
  'grilu',
  'griǌa',
  'griǌe',
  'gripa',
  'gripe',
  'gripi',
  'gripu',
  'grist',
  'griva',
  'grive',
  'grivi',
  'grivu',
  'griza',
  'griža',
  'grize',
  'griže',
  'grizi',
  'grizu',
  'groba',
  'grobu',
  'grofa',
  'grofe',
  'grofu',
  'groga',
  'grogu',
  'groma',
  'grome',
  'gromu',
  'groša',
  'group',
  'grove',
  'groza',
  'grozd',
  'groze',
  'grozi',
  'gruba',
  'grube',
  'grubi',
  'grubo',
  'grubu',
  'gruda',
  'grude',
  'grudi',
  'grudu',
  'grune',
  'gruni',
  'grunt',
  'grunu',
  'grupa',
  'grupe',
  'grupi',
  'grupo',
  'grupu',
  'gruša',
  'gubac',
  'gubav',
  'guber',
  'gubim',
  'gubin',
  'gubio',
  'gubiš',
  'gubit',
  'gubom',
  'gucne',
  'gucni',
  'gucnu',
  'gudač',
  'gudim',
  'gudio',
  'gugut',
  'guide',
  'guido',
  'gujin',
  'gujom',
  'gukao',
  'guknu',
  'gulag',
  'gulaš',
  'gumba',
  'gumen',
  'gumna',
  'gumno',
  'gumnu',
  'gumom',
  'gunđa',
  'gunja',
  'guǌak',
  'gunje',
  'gunji',
  'gunju',
  'gupca',
  'gupcu',
  'gupta',
  'guraj',
  'guram',
  'guran',
  'gurao',
  'gurat',
  'gurka',
  'gurke',
  'gurki',
  'gurku',
  'gurne',
  'gurni',
  'gurnu',
  'gurua',
  'gurue',
  'gurui',
  'gusak',
  'gusan',
  'gusar',
  'gušća',
  'gušće',
  'gušći',
  'gušću',
  'gušio',
  'guska',
  'guske',
  'guski',
  'gusla',
  'gusle',
  'gusli',
  'gušom',
  'gusta',
  'guste',
  'gusti',
  'gusto',
  'gustu',
  'gutam',
  'gutan',
  'gutao',
  'gutne',
  'gutni',
  'gutnu',
  'guvno',
  'guzom',
  'guzva',
  'gužva',
  'gužve',
  'gužvi',
  'gužvu',
  'gverc',
  'gvirc',
  'gviri',
  'habah',
  'habaj',
  'haber',
  'hadom',
  'hadža',
  'hadži',
  'haǆić',
  'hadžu',
  'hafiz',
  'hagen',
  'hahar',
  'haiku',
  'haiti',
  'hajao',
  'hajat',
  'hajci',
  'hajda',
  'hajde',
  'hajdi',
  'hajdu',
  'hajem',
  'hajka',
  'hajke',
  'hajku',
  'hajmo',
  'hajte',
  'haker',
  'hakim',
  'halal',
  'halid',
  'halka',
  'halke',
  'halku',
  'halom',
  'halon',
  'halva',
  'halve',
  'halvu',
  'hamal',
  'hamam',
  'hamas',
  'hanka',
  'hanom',
  'hansa',
  'haosa',
  'haosu',
  'hapse',
  'hapsi',
  'harač',
  'haram',
  'haran',
  'harao',
  'hardi',
  'harem',
  'harfa',
  'harfe',
  'harfi',
  'harfo',
  'harfu',
  'haris',
  'harvi',
  'hasan',
  'hasij',
  'hašim',
  'hašiš',
  'haška',
  'haške',
  'haški',
  'haško',
  'hašku',
  'hasta',
  'hatma',
  'hauba',
  'haube',
  'haubi',
  'haubu',
  'havan',
  'havaz',
  'haven',
  'hazel',
  'hazna',
  'heart',
  'heath',
  'hefta',
  'hegel',
  'heidi',
  'hekla',
  'helen',
  'helga',
  'helij',
  'heǉda',
  'heǉde',
  'heǉdi',
  'heǉdu',
  'henri',
  'herca',
  'heroj',
  'hicem',
  'hidra',
  'hidre',
  'hidri',
  'hidro',
  'hidru',
  'hiǆab',
  'hiǆra',
  'hiǆre',
  'hiǆri',
  'hiǆru',
  'hihot',
  'hilda',
  'himba',
  'himen',
  'himna',
  'himne',
  'himni',
  'himno',
  'himnu',
  'hindi',
  'hindu',
  'hinit',
  'hiǌah',
  'hiper',
  'hipik',
  'hisar',
  'hitac',
  'hitam',
  'hitan',
  'hitao',
  'hitar',
  'hitin',
  'hitiš',
  'hitit',
  'hitna',
  'hitne',
  'hitni',
  'hitǌa',
  'hitno',
  'hitnu',
  'hitom',
  'hitra',
  'hitre',
  'hitri',
  'hitro',
  'hitru',
  'hlača',
  'hlače',
  'hlada',
  'hlade',
  'hladi',
  'hladu',
  'hlapa',
  'hlape',
  'hlapu',
  'hleba',
  'hǉeba',
  'hǉebu',
  'hlora',
  'hloru',
  'hmelj',
  'hmeǉa',
  'hmeǉu',
  'hober',
  'hobit',
  'hoćeš',
  'hodač',
  'hodaj',
  'hodam',
  'hodao',
  'hodaš',
  'hodge',
  'hodim',
  'hodio',
  'hodit',
  'hodǌa',
  'hodǌi',
  'hodom',
  'hodža',
  'hodže',
  'hodži',
  'hoǆić',
  'hoǆin',
  'hoǆom',
  'hodžu',
  'hogan',
  'hokej',
  'holom',
  'homer',
  'homić',
  'honda',
  'honde',
  'hondi',
  'hondo',
  'hondu',
  'horan',
  'horda',
  'horde',
  'hordi',
  'hordu',
  'horom',
  'horor',
  'horoz',
  'horse',
  'hošaf',
  'hotel',
  'house',
  'hrama',
  'hrame',
  'hramu',
  'hrana',
  'hrane',
  'hrani',
  'hranu',
  'hrast',
  'hrčak',
  'hrčci',
  'hrčem',
  'hrčka',
  'hrčke',
  'hrđao',
  'hrđav',
  'hrđom',
  'hrena',
  'hrene',
  'hrenu',
  'hridi',
  'hrist',
  'hroma',
  'hromi',
  'hromo',
  'hromu',
  'hrušt',
  'htela',
  'hteli',
  'htelo',
  'huana',
  'huang',
  'hučan',
  'hudih',
  'hudim',
  'hudja',
  'hudoj',
  'hudom',
  'hujim',
  'hukao',
  'hukni',
  'hukom',
  'hulio',
  'hulja',
  'humak',
  'human',
  'humci',
  'humka',
  'humke',
  'humku',
  'humom',
  'humor',
  'humus',
  'hunta',
  'hunte',
  'hunti',
  'huntu',
  'hurma',
  'husar',
  'huška',
  'hutba',
  'hvala',
  'hvale',
  'hvali',
  'hvalu',
  'hvaru',
  'hvata',
  'hvati',
  'ibisa',
  'ibisi',
  'ibisu',
  'ibrik',
  'ičega',
  'ičemu',
  'ičije',
  'ičiji',
  'idama',
  'ideal',
  'ideas',
  'ideja',
  'ideje',
  'ideji',
  'ideju',
  'idemo',
  'idete',
  'idila',
  'idile',
  'idili',
  'idilu',
  'idimo',
  'idiom',
  'idiot',
  'idite',
  'idola',
  'idole',
  'idoli',
  'idolu',
  'iduća',
  'iduće',
  'idući',
  'iduću',
  'iftar',
  'igala',
  'igalo',
  'igalu',
  'igara',
  'iglom',
  'iglun',
  'igǌat',
  'igora',
  'igrač',
  'igraj',
  'igram',
  'igran',
  'igrao',
  'igraš',
  'igrat',
  'igrom',
  'ikada',
  'ikako',
  'ikamo',
  'ikbal',
  'ikoga',
  'ikoja',
  'ikoji',
  'ikoju',
  'ikome',
  'ikomu',
  'ikona',
  'ikone',
  'ikoni',
  'ikono',
  'ikonu',
  'ikrah',
  'ikrom',
  'ilića',
  'iliǆa',
  'ilija',
  'ilije',
  'iliju',
  'ilira',
  'iliri',
  'iliti',
  'imaće',
  'imaću',
  'imade',
  'image',
  'imaju',
  'imala',
  'imale',
  'imali',
  'imalo',
  'imama',
  'imame',
  'imami',
  'imamo',
  'imamu',
  'imaǌa',
  'imaǌe',
  'imaǌu',
  'imate',
  'imati',
  'imeci',
  'imela',
  'imele',
  'imena',
  'imenu',
  'imidž',
  'imiǆa',
  'imiǆu',
  'imuna',
  'imune',
  'imuni',
  'imuno',
  'imunu',
  'inače',
  'inata',
  'inati',
  'inćun',
  'inčun',
  'india',
  'indij',
  'ingot',
  'inima',
  'injem',
  'inoča',
  'inoga',
  'inomu',
  'input',
  'insan',
  'intel',
  'inter',
  'ionom',
  'iraka',
  'iraku',
  'irana',
  'iranu',
  'irena',
  'irene',
  'irina',
  'irisa',
  'irisi',
  'irisu',
  'irvas',
  'isaka',
  'išara',
  'isele',
  'iseli',
  'ishod',
  'išiba',
  'isisa',
  'iskaz',
  'iskon',
  'iskop',
  'islam',
  'ismet',
  'ismij',
  'ispad',
  'ispao',
  'ispio',
  'ispis',
  'ispit',
  'ispod',
  'ispuh',
  'istek',
  'istih',
  'istim',
  'istog',
  'istoj',
  'istok',
  'istom',
  'istup',
  'isula',
  'isuli',
  'isusa',
  'isuse',
  'isuše',
  'isuši',
  'isusu',
  'isuti',
  'itrij',
  'ivama',
  'ivana',
  'ivane',
  'ivanu',
  'ivera',
  'iveri',
  'ivica',
  'ivice',
  'ivici',
  'ivicu',
  'ivina',
  'ivini',
  'izaći',
  'izađe',
  'izađi',
  'izađu',
  'izasu',
  'izbih',
  'izbio',
  'izboj',
  'izbom',
  'izbor',
  'izdah',
  'izdam',
  'izdan',
  'izdao',
  'izdaš',
  'izdat',
  'izgon',
  'izići',
  'iziđe',
  'iziđi',
  'iziđu',
  'izjeo',
  'izlaz',
  'izlet',
  'izlio',
  'izlit',
  'izliv',
  'izǉev',
  'izlog',
  'izlov',
  'izmak',
  'izmeo',
  'izmet',
  'iznad',
  'izneo',
  'iznio',
  'iznos',
  'izora',
  'izraz',
  'izrez',
  'izrod',
  'izuje',
  'izuju',
  'izuma',
  'izume',
  'izumi',
  'izumu',
  'izuta',
  'izute',
  'izuti',
  'izuze',
  'izvan',
  'izveo',
  'izvit',
  'izvod',
  'izvor',
  'izvoz',
  'jačao',
  'jačeg',
  'jačem',
  'jačih',
  'jačim',
  'jacka',
  'jacku',
  'jacob',
  'jačoj',
  'jačom',
  'jadan',
  'jadit',
  'jadna',
  'jadne',
  'jadni',
  'jadno',
  'jadnu',
  'jadom',
  'jagma',
  'jagme',
  'jagmi',
  'jagmu',
  'jagǌe',
  'jahač',
  'jahan',
  'jahao',
  'jahta',
  'jahte',
  'jahti',
  'jahtu',
  'jahve',
  'jaime',
  'jajca',
  'jajce',
  'jajcu',
  'jajna',
  'jajne',
  'jajni',
  'jajnu',
  'jakih',
  'jakim',
  'jakna',
  'jakne',
  'jakni',
  'jakno',
  'jaknu',
  'jakob',
  'jakog',
  'jakoj',
  'jakom',
  'jakov',
  'jakša',
  'jalan',
  'jalne',
  'jalni',
  'jalom',
  'jalov',
  'jamac',
  'jamal',
  'jamba',
  'jambe',
  'jamca',
  'jamče',
  'jamci',
  'jamči',
  'jamcu',
  'james',
  'jamie',
  'jamim',
  'jamna',
  'jamne',
  'jamni',
  'jamno',
  'jamnu',
  'jamom',
  'janet',
  'janga',
  'jangu',
  'janić',
  'janis',
  'janja',
  'jaǌac',
  'jaǌad',
  'jaǌca',
  'jaǌce',
  'jaǌci',
  'janje',
  'janji',
  'jaǌić',
  'janka',
  'janko',
  'janoš',
  'janus',
  'japan',
  'jarac',
  'jarad',
  'jarak',
  'jaram',
  'jaran',
  'jarca',
  'jarče',
  'jarci',
  'jarcu',
  'jardi',
  'jared',
  'jarić',
  'jarih',
  'jarka',
  'jarke',
  'jarki',
  'jarko',
  'jarku',
  'jarma',
  'jarmu',
  'jarog',
  'jaroj',
  'jarom',
  'jasan',
  'jašem',
  'jasen',
  'jašeš',
  'jasla',
  'jasle',
  'jasli',
  'jasna',
  'jasne',
  'jasni',
  'jasno',
  'jasnu',
  'jason',
  'jatak',
  'jatim',
  'jatom',
  'jauci',
  'jauka',
  'jauku',
  'javan',
  'javim',
  'javio',
  'javiš',
  'javit',
  'javǉa',
  'javna',
  'javne',
  'javni',
  'javno',
  'javnu',
  'javom',
  'javor',
  'jazom',
  'jebat',
  'jebem',
  'jecaj',
  'jecam',
  'ječam',
  'jecao',
  'ječma',
  'ječmu',
  'jedak',
  'jedan',
  'jedar',
  'jedem',
  'jeden',
  'jedeš',
  'jedim',
  'jedna',
  'jedne',
  'jedni',
  'jedno',
  'jednu',
  'jedom',
  'jedra',
  'jedre',
  'jedri',
  'jedro',
  'jedru',
  'jedva',
  'jekne',
  'jekni',
  'jeknu',
  'jelek',
  'jelen',
  'jelić',
  'jelin',
  'jelka',
  'jelke',
  'jelki',
  'jelko',
  'jelku',
  'jelom',
  'jelov',
  'jemac',
  'jemci',
  'jemen',
  'jenja',
  'jenki',
  'jenom',
  'jerej',
  'jeres',
  'jesam',
  'jesen',
  'jesmo',
  'jeste',
  'jesti',
  'jesus',
  'jetka',
  'jetke',
  'jetki',
  'jetku',
  'jetra',
  'jetre',
  'jetri',
  'jetro',
  'jetru',
  'jezda',
  'jezde',
  'jezdi',
  'jezdu',
  'ježev',
  'ježić',
  'jezik',
  'ježim',
  'jeziv',
  'ježǌa',
  'jezom',
  'jidiš',
  'jinom',
  'jocić',
  'jodid',
  'jodie',
  'jodna',
  'jodne',
  'jodni',
  'jodno',
  'jodnu',
  'jodom',
  'jodov',
  'jogom',
  'johan',
  'johna',
  'johnu',
  'johom',
  'joint',
  'joker',
  'jokić',
  'jonah',
  'jonas',
  'jones',
  'jorge',
  'josef',
  'josif',
  'josip',
  'joško',
  'jovan',
  'jović',
  'jozef',
  'jožef',
  'juana',
  'jučer',
  'judeo',
  'jufka',
  'jugom',
  'juhom',
  'jukić',
  'jules',
  'julia',
  'julie',
  'julio',
  'julom',
  'jumbo',
  'junac',
  'junad',
  'junak',
  'junom',
  'juraj',
  'jurca',
  'juren',
  'jurić',
  'jurij',
  'jurim',
  'jurio',
  'juriš',
  'jurja',
  'jurne',
  'jurni',
  'jurnu',
  'jurta',
  'jurte',
  'jurti',
  'jurto',
  'jusuf',
  'jutom',
  'jutra',
  'jutro',
  'jutru',
  'južna',
  'južne',
  'južni',
  'južno',
  'južnu',
  'kabao',
  'kabel',
  'kabla',
  'kablu',
  'kačio',
  'kacom',
  'kaćun',
  'kadar',
  'kadet',
  'kadim',
  'kadiš',
  'kadom',
  'kadra',
  'kadre',
  'kadri',
  'kadro',
  'kadru',
  'kafea',
  'kafeu',
  'kafez',
  'kafić',
  'kafka',
  'kafom',
  'kagan',
  'kahar',
  'kahva',
  'kaida',
  'kaide',
  'kaira',
  'kairo',
  'kairu',
  'kaiša',
  'kaišu',
  'kajah',
  'kajak',
  'kajao',
  'kajat',
  'kajde',
  'kajdu',
  'kajem',
  'kajiš',
  'kajla',
  'kajli',
  'kakaǌ',
  'kakao',
  'kakau',
  'kakav',
  'kakva',
  'kakve',
  'kakvi',
  'kakvo',
  'kakvu',
  'kalah',
  'kalaj',
  'kalam',
  'kalan',
  'kalao',
  'kalaš',
  'kalat',
  'kalem',
  'kalen',
  'kalež',
  'kalfa',
  'kalif',
  'kalij',
  'kalim',
  'kalio',
  'kališ',
  'kalja',
  'kaǉen',
  'kalju',
  'kalom',
  'kalup',
  'kamen',
  'kamil',
  'kamin',
  'kamom',
  'kampa',
  'kampu',
  'kanal',
  'kanap',
  'kanat',
  'kanda',
  'kanǆa',
  'kanǆe',
  'kanǆi',
  'kanǆu',
  'kanem',
  'kanio',
  'kaniš',
  'kanit',
  'kaǌon',
  'kanom',
  'kanon',
  'kanov',
  'kanta',
  'kante',
  'kanti',
  'kanto',
  'kantu',
  'kanua',
  'kanue',
  'kanui',
  'kaosa',
  'kaosi',
  'kaosu',
  'kapak',
  'kapan',
  'kapao',
  'kapar',
  'kapci',
  'kapka',
  'kapke',
  'kapku',
  'kapǉa',
  'kapǉe',
  'kapǉi',
  'kapǉu',
  'kapom',
  'kapor',
  'kaput',
  'karaj',
  'karam',
  'karan',
  'karao',
  'karaš',
  'karat',
  'karen',
  'karga',
  'kargo',
  'kargu',
  'karić',
  'karin',
  'karla',
  'karlo',
  'karlu',
  'karma',
  'karme',
  'karmi',
  'karmu',
  'karol',
  'karta',
  'karte',
  'karti',
  'kartu',
  'kasaj',
  'kašaǉ',
  'kasan',
  'kasap',
  'kasaš',
  'kaska',
  'kašǉa',
  'kašǉe',
  'kašǉu',
  'kasna',
  'kasne',
  'kasni',
  'kasno',
  'kasnu',
  'kasom',
  'kašom',
  'kasta',
  'kaste',
  'kasti',
  'kasto',
  'kastu',
  'katar',
  'katić',
  'katie',
  'katil',
  'katja',
  'katna',
  'katne',
  'katni',
  'katnu',
  'katom',
  'katun',
  'kauča',
  'kauči',
  'kauču',
  'kaula',
  'kavez',
  'kavga',
  'kavin',
  'kavom',
  'kazah',
  'kazan',
  'kazao',
  'kazat',
  'kažem',
  'kažeš',
  'kazna',
  'kazne',
  'kazni',
  'kaznu',
  'kazuj',
  'kćeri',
  'kebab',
  'kečap',
  'kečke',
  'kefir',
  'kefom',
  'kegla',
  'kegle',
  'kegli',
  'keiko',
  'keith',
  'kejom',
  'keksa',
  'keksi',
  'kelja',
  'kelju',
  'kelnu',
  'kelta',
  'kelti',
  'kemal',
  'kenet',
  'kenja',
  'keǌac',
  'keǌah',
  'kenta',
  'kentu',
  'kepec',
  'kesom',
  'keson',
  'kevin',
  'khana',
  'kibla',
  'kible',
  'kibli',
  'kiblu',
  'kićen',
  'kičma',
  'kičme',
  'kičmi',
  'kičmu',
  'kicoš',
  'kidaj',
  'kidam',
  'kidaš',
  'kifla',
  'kifle',
  'kifli',
  'kiflu',
  'kihao',
  'kihne',
  'kihni',
  'kihnu',
  'kihot',
  'kijev',
  'kikom',
  'kikot',
  'kilav',
  'kilom',
  'kilta',
  'kimom',
  'kinez',
  'kinga',
  'kinin',
  'kinje',
  'kinji',
  'kinom',
  'kiosk',
  'kipar',
  'kiper',
  'kipić',
  'kipio',
  'kipom',
  'kipra',
  'kipru',
  'kirbi',
  'kiril',
  'kirka',
  'kirǌa',
  'kišan',
  'kiseo',
  'kisik',
  'kisko',
  'kišna',
  'kišne',
  'kisni',
  'kišni',
  'kišno',
  'kisnu',
  'kišnu',
  'kišom',
  'kista',
  'kitom',
  'kitov',
  'kivan',
  'kivna',
  'klada',
  'klade',
  'kladi',
  'kladu',
  'klajn',
  'klala',
  'klale',
  'klali',
  'klana',
  'klane',
  'klani',
  'klaǌa',
  'klaǌe',
  'klaǌu',
  'klanu',
  'klapa',
  'klape',
  'klapi',
  'klapu',
  'klara',
  'klark',
  'klasa',
  'klase',
  'klasi',
  'klasu',
  'klate',
  'klati',
  'klaun',
  'klaus',
  'kleče',
  'kleči',
  'klein',
  'kleka',
  'klela',
  'kleli',
  'klelo',
  'klena',
  'klera',
  'kleri',
  'kleru',
  'klešu',
  'kleta',
  'klete',
  'kleti',
  'kleto',
  'kletu',
  'klica',
  'klice',
  'kliče',
  'klicu',
  'klifa',
  'klija',
  'klika',
  'klike',
  'kliki',
  'kliko',
  'kliku',
  'klima',
  'klime',
  'klimi',
  'klimu',
  'klina',
  'kline',
  'klini',
  'klipa',
  'klipu',
  'klisa',
  'kliše',
  'klize',
  'kliže',
  'klizi',
  'kližu',
  'kǉova',
  'kǉove',
  'kǉovi',
  'kǉovu',
  'kǉuca',
  'kǉuča',
  'kǉuču',
  'kǉuka',
  'kǉuna',
  'kǉunu',
  'kǉuse',
  'klona',
  'klone',
  'kloni',
  'klonu',
  'klora',
  'klovn',
  'kluba',
  'klube',
  'klubu',
  'klupa',
  'klupe',
  'klupi',
  'klupu',
  'kmeta',
  'kmetu',
  'kneza',
  'kneže',
  'knezu',
  'knina',
  'kninu',
  'kǌaza',
  'kǌiga',
  'kǌige',
  'kǌigu',
  'kǌizi',
  'kǌiži',
  'knock',
  'koala',
  'koale',
  'kobac',
  'koban',
  'kobna',
  'kobne',
  'kobni',
  'kobno',
  'kobnu',
  'kobra',
  'kobre',
  'kobri',
  'kobru',
  'kocem',
  'kočić',
  'kočio',
  'kočiš',
  'kocka',
  'kocke',
  'kocki',
  'kocku',
  'kočna',
  'kočni',
  'kočno',
  'kodna',
  'kodne',
  'kodni',
  'kodno',
  'kodnu',
  'kodom',
  'kodon',
  'kofer',
  'kojeg',
  'kojem',
  'kojić',
  'kojih',
  'kojim',
  'kojoj',
  'kojom',
  'kojot',
  'kokin',
  'kokom',
  'kokos',
  'kokoš',
  'kokot',
  'koksa',
  'kokse',
  'koksu',
  'kolac',
  'kolač',
  'kolam',
  'kolan',
  'kolar',
  'kolat',
  'kolaž',
  'kolca',
  'kolce',
  'kolci',
  'kolcu',
  'koleǆ',
  'kolim',
  'kolin',
  'kolio',
  'kolja',
  'koǉač',
  'kolje',
  'koǉem',
  'koǉen',
  'kolji',
  'kolju',
  'kolko',
  'kolna',
  'kolni',
  'kolnu',
  'kolom',
  'kolor',
  'kolos',
  'kolta',
  'kolut',
  'komad',
  'kombi',
  'komet',
  'komom',
  'konac',
  'konak',
  'konca',
  'konča',
  'konce',
  'konče',
  'konci',
  'koncu',
  'konec',
  'konga',
  'kongo',
  'kongu',
  'konja',
  'koǌak',
  'konje',
  'koǌem',
  'koǌev',
  'konji',
  'koǌic',
  'koǌić',
  'konju',
  'konop',
  'konta',
  'konte',
  'konto',
  'kontu',
  'konus',
  'kopač',
  'kopan',
  'kopao',
  'kopar',
  'kopat',
  'kopča',
  'kopče',
  'kopci',
  'kopči',
  'kopču',
  'koper',
  'kopir',
  'kopka',
  'kopǉa',
  'kopǉe',
  'kopǉu',
  'kopna',
  'kopni',
  'kopno',
  'kopnu',
  'kopom',
  'kopra',
  'kopre',
  'kopru',
  'kopun',
  'korać',
  'korah',
  'korak',
  'koral',
  'koraǉ',
  'koren',
  'korin',
  'korio',
  'koriš',
  'korom',
  'korov',
  'korpa',
  'korpe',
  'korpi',
  'korpu',
  'korza',
  'korzo',
  'korzu',
  'kosac',
  'kosač',
  'kosan',
  'kosca',
  'kosci',
  'koscu',
  'košću',
  'košem',
  'košer',
  'košić',
  'kosih',
  'kosim',
  'kosin',
  'kosio',
  'kosir',
  'kosit',
  'koska',
  'koška',
  'kosna',
  'kosne',
  'kosni',
  'košǌa',
  'košǌu',
  'kosno',
  'kosnu',
  'kosog',
  'kosoj',
  'kosom',
  'kosor',
  'kosov',
  'košpa',
  'kosta',
  'košta',
  'koste',
  'kosti',
  'kotac',
  'kotač',
  'kotao',
  'kotar',
  'kotla',
  'kotle',
  'kotli',
  'kotlu',
  'kotom',
  'kotor',
  'kotur',
  'kotva',
  'kotvi',
  'kotvu',
  'kovač',
  'kovan',
  'kovao',
  'kovid',
  'kovin',
  'kozak',
  'kozar',
  'kožar',
  'kozer',
  'kozin',
  'kozja',
  'kozje',
  'kozji',
  'kozju',
  'kozle',
  'kozma',
  'kožna',
  'kožne',
  'kožni',
  'kožno',
  'kožnu',
  'kozom',
  'kožom',
  'kožuh',
  'kraba',
  'krabe',
  'krabi',
  'kraća',
  'kraće',
  'krače',
  'kraci',
  'kraći',
  'kraću',
  'krađa',
  'krade',
  'krađe',
  'kradi',
  'krađi',
  'kradu',
  'krađu',
  'kraha',
  'krahu',
  'kraja',
  'kraju',
  'kraka',
  'krake',
  'kraku',
  'krala',
  'krale',
  'krali',
  'kralj',
  'kraǉa',
  'kraǉe',
  'kraǉi',
  'kraǉu',
  'kralo',
  'krama',
  'krami',
  'kramp',
  'kramu',
  'krana',
  'krane',
  'krasa',
  'krase',
  'kraše',
  'krasi',
  'krast',
  'krasu',
  'krate',
  'krati',
  'kraul',
  'kraus',
  'krava',
  'krave',
  'kravi',
  'kravu',
  'krčag',
  'krčat',
  'krčio',
  'krčka',
  'krčki',
  'krčma',
  'krčme',
  'krčmi',
  'krčmu',
  'kreča',
  'kreće',
  'kreče',
  'kreći',
  'kreću',
  'kreču',
  'kreda',
  'krede',
  'kredi',
  'kredo',
  'kredu',
  'kreja',
  'krema',
  'kreme',
  'kremǉ',
  'kremu',
  'krene',
  'kreni',
  'krenu',
  'kreše',
  'kreši',
  'krici',
  'krije',
  'kriju',
  'krika',
  'krike',
  'kriku',
  'krila',
  'krile',
  'krili',
  'krilo',
  'krilu',
  'krima',
  'krimi',
  'krimu',
  'krina',
  'krinu',
  'krisa',
  'krist',
  'krita',
  'kriti',
  'kritu',
  'kriva',
  'krive',
  'krivi',
  'krivo',
  'krivu',
  'kriza',
  'križa',
  'krize',
  'krizi',
  'krizu',
  'križu',
  'krǌak',
  'krǌeg',
  'krǌem',
  'krǌih',
  'krǌim',
  'krǌoj',
  'kroče',
  'kroči',
  'kroja',
  'kroje',
  'kroji',
  'kroju',
  'kroki',
  'krome',
  'krosa',
  'kroše',
  'krosu',
  'kroti',
  'krova',
  'krovu',
  'kroza',
  'kršan',
  'kršem',
  'kršim',
  'kršio',
  'kršiš',
  'krška',
  'krške',
  'krški',
  'krško',
  'kršku',
  'kršna',
  'kršne',
  'kršni',
  'kršno',
  'kruće',
  'krući',
  'kruga',
  'krugu',
  'kruha',
  'kruhu',
  'krule',
  'kruli',
  'kruna',
  'krune',
  'kruni',
  'kruno',
  'krunu',
  'krupa',
  'krupe',
  'krupi',
  'krupu',
  'kruta',
  'krute',
  'kruti',
  'kruto',
  'krutu',
  'kruže',
  'kruži',
  'kubik',
  'kubna',
  'kubne',
  'kubni',
  'kubno',
  'kubnu',
  'kubom',
  'kubus',
  'kucaj',
  'kučak',
  'kucam',
  'kucan',
  'kucao',
  'kučić',
  'kućio',
  'kucka',
  'kučka',
  'kučke',
  'kučki',
  'kučko',
  'kučku',
  'kućna',
  'kucne',
  'kućne',
  'kucni',
  'kućni',
  'kućno',
  'kucnu',
  'kućnu',
  'kućom',
  'kufer',
  'kugla',
  'kugle',
  'kugli',
  'kuglo',
  'kuglu',
  'kugom',
  'kuhan',
  'kuhao',
  'kuhar',
  'kujem',
  'kuješ',
  'kujin',
  'kujom',
  'kukac',
  'kukca',
  'kukce',
  'kukci',
  'kukcu',
  'kukoǉ',
  'kukom',
  'kulak',
  'kulen',
  'kulja',
  'kulje',
  'kulji',
  'kuljo',
  'kulju',
  'kulom',
  'kulta',
  'kultu',
  'kuluk',
  'kumar',
  'kumče',
  'kumin',
  'kumir',
  'kumis',
  'kumiš',
  'kumom',
  'kumov',
  'kunem',
  'kunić',
  'kunin',
  'kunja',
  'kunom',
  'kupac',
  'kupač',
  'kupao',
  'kupca',
  'kupce',
  'kupci',
  'kupcu',
  'kupea',
  'kupei',
  'kupeǉ',
  'kuper',
  'kupeu',
  'kupim',
  'kupio',
  'kupit',
  'kupka',
  'kupke',
  'kupki',
  'kupku',
  'kupǌa',
  'kupǌe',
  'kupǌi',
  'kupǌu',
  'kupom',
  'kupon',
  'kupuj',
  'kupus',
  'kurah',
  'kuran',
  'kurca',
  'kurci',
  'kurcu',
  'kurda',
  'kurdi',
  'kuren',
  'kurij',
  'kurir',
  'kurit',
  'kurja',
  'kurji',
  'kurjo',
  'kurju',
  'kurom',
  'kursa',
  'kursu',
  'kurta',
  'kušač',
  'kusaj',
  'kusam',
  'kušan',
  'kusao',
  'kušao',
  'kušǌa',
  'kušǌe',
  'kušǌi',
  'kušǌu',
  'kusur',
  'kutak',
  'kutić',
  'kutka',
  'kutku',
  'kutna',
  'kutne',
  'kutni',
  'kutno',
  'kutom',
  'kutre',
  'kutri',
  'kuvan',
  'kuvar',
  'kužan',
  'kužim',
  'kužiš',
  'kužna',
  'kužni',
  'kužno',
  'kvaka',
  'kvake',
  'kvaku',
  'kvant',
  'kvara',
  'kvarc',
  'kvare',
  'kvari',
  'kvark',
  'kvart',
  'kvaru',
  'kvasa',
  'kvase',
  'kvasi',
  'kvasu',
  'kvazi',
  'kviza',
  'kvizu',
  'kvota',
  'kvote',
  'kvotu',
  'labav',
  'labir',
  'labud',
  'lađar',
  'laden',
  'lađom',
  'lafet',
  'lagan',
  'lagao',
  'lagat',
  'lager',
  'lagum',
  'lagva',
  'lagvi',
  'lagvu',
  'lahor',
  'laici',
  'laika',
  'laike',
  'lajav',
  'lajem',
  'lajoš',
  'lajte',
  'lakaj',
  'lakat',
  'lakej',
  'lakih',
  'lakim',
  'lakog',
  'lakoj',
  'lakom',
  'lakša',
  'lakše',
  'lakši',
  'lakšu',
  'lakta',
  'lakti',
  'laktu',
  'lalić',
  'lamam',
  'laman',
  'lamar',
  'lamat',
  'lamin',
  'lamom',
  'lampa',
  'lampe',
  'lampi',
  'lampo',
  'lampu',
  'lanac',
  'lanad',
  'lanca',
  'lance',
  'lanci',
  'lancu',
  'lando',
  'lanen',
  'lanka',
  'lanke',
  'lanom',
  'lanuo',
  'lapis',
  'lapor',
  'larga',
  'large',
  'largo',
  'larma',
  'larmi',
  'larmu',
  'larva',
  'larve',
  'larvi',
  'larvu',
  'lašče',
  'lasci',
  'lašci',
  'laser',
  'lasju',
  'laska',
  'laski',
  'lasko',
  'laslo',
  'lasom',
  'lasta',
  'laste',
  'lasti',
  'lasto',
  'lastu',
  'latin',
  'latio',
  'latiš',
  'latit',
  'lauda',
  'laude',
  'laudi',
  'laudu',
  'laura',
  'laure',
  'lavež',
  'lavić',
  'lavǉa',
  'lavǉe',
  'lavǉi',
  'lavǉu',
  'lavom',
  'lavor',
  'lavov',
  'lavra',
  'lažac',
  'lažan',
  'lazar',
  'lažem',
  'lažeš',
  'lazić',
  'lažna',
  'lažne',
  'lažni',
  'lažno',
  'lažnu',
  'lažov',
  'leave',
  'lebde',
  'lebdi',
  'lecne',
  'lecni',
  'lecnu',
  'lećom',
  'leden',
  'leđna',
  'leđne',
  'leđni',
  'leđno',
  'leđnu',
  'ledom',
  'legal',
  'legao',
  'legat',
  'legla',
  'legle',
  'legli',
  'leglo',
  'leglu',
  'legne',
  'legni',
  'legnu',
  'legoh',
  'leigh',
  'lejdi',
  'lejla',
  'lekar',
  'lekić',
  'lelek',
  'leman',
  'lemeš',
  'lemio',
  'lemon',
  'lemur',
  'leǌin',
  'leǌir',
  'lenka',
  'lenom',
  'lenta',
  'lente',
  'lenti',
  'lento',
  'lentu',
  'leona',
  'leone',
  'leoni',
  'lepih',
  'lepog',
  'lepoj',
  'lepom',
  'lepra',
  'lepre',
  'lepru',
  'lepša',
  'lepše',
  'lesom',
  'lešom',
  'letač',
  'letaj',
  'letak',
  'letat',
  'letci',
  'leteo',
  'letim',
  'letio',
  'letiš',
  'letka',
  'letke',
  'letku',
  'letna',
  'letne',
  'letni',
  'letǌa',
  'letǌe',
  'letǌi',
  'letno',
  'letnu',
  'letom',
  'letva',
  'letve',
  'letvi',
  'letvu',
  'leuta',
  'leute',
  'leuti',
  'levak',
  'level',
  'levha',
  'levin',
  'levog',
  'levoj',
  'levom',
  'ležah',
  'ležaj',
  'ležao',
  'ležim',
  'ležiš',
  'liang',
  'liban',
  'libar',
  'liber',
  'libio',
  'libor',
  'libra',
  'libre',
  'libri',
  'libro',
  'libru',
  'ličan',
  'licej',
  'licem',
  'ličen',
  'ličim',
  'ličio',
  'ličiš',
  'licka',
  'lička',
  'ličke',
  'lički',
  'ličko',
  'ličku',
  'lična',
  'lične',
  'lični',
  'lično',
  'ličnu',
  'lider',
  'lifta',
  'liftu',
  'ligǌa',
  'ligǌe',
  'ligǌi',
  'ligǌu',
  'ligom',
  'lihva',
  'lihve',
  'lihvi',
  'lijek',
  'lijem',
  'lijen',
  'lijep',
  'lijes',
  'lijev',
  'lijom',
  'liker',
  'likom',
  'liman',
  'limar',
  'limba',
  'limbe',
  'limbo',
  'limbu',
  'limen',
  'limes',
  'limfa',
  'limfe',
  'limfi',
  'limfo',
  'limfu',
  'limit',
  'limom',
  'limun',
  'linča',
  'linču',
  'linda',
  'linde',
  'linja',
  'liǌak',
  'linka',
  'linku',
  'linus',
  'lionu',
  'lipaǌ',
  'lipid',
  'lipik',
  'lipǌa',
  'lipǌu',
  'lipom',
  'lipov',
  'lipsa',
  'lirik',
  'lirom',
  'lisac',
  'lišaj',
  'lisca',
  'lišća',
  'lisce',
  'lišće',
  'lisci',
  'liscu',
  'lišću',
  'lišen',
  'lišio',
  'liska',
  'liske',
  'liski',
  'lisko',
  'lisku',
  'lisna',
  'lisne',
  'lisni',
  'lisno',
  'lisnu',
  'lista',
  'liste',
  'listi',
  'listo',
  'listu',
  'litar',
  'litij',
  'litra',
  'litre',
  'litri',
  'litru',
  'livac',
  'livca',
  'liven',
  'livna',
  'livno',
  'livnu',
  'livom',
  'lizat',
  'ližem',
  'lizin',
  'lizne',
  'lizni',
  'liznu',
  'lizol',
  'lizom',
  'ljaga',
  'ljage',
  'ljago',
  'ljagu',
  'ljama',
  'ljame',
  'ljazi',
  'ǉekar',
  'ǉeniv',
  'ǉeǌem',
  'ǉepak',
  'ǉepku',
  'ǉepša',
  'ǉepše',
  'ǉepši',
  'ǉepšu',
  'ǉeska',
  'ljeta',
  'ljeti',
  'ǉetna',
  'ǉetne',
  'ǉetni',
  'ǉetǌa',
  'ǉetǌe',
  'ǉetǌi',
  'ǉetǌu',
  'ǉetno',
  'ǉetnu',
  'ljeto',
  'ǉetom',
  'ǉetos',
  'ljetu',
  'ǉevač',
  'ǉevak',
  'ǉevan',
  'ǉigav',
  'ǉiǉak',
  'ǉiǉan',
  'ǉiǉci',
  'ǉotić',
  'ljuba',
  'ǉubak',
  'ǉubav',
  'ljube',
  'ljubi',
  'ǉubić',
  'ǉubim',
  'ǉubio',
  'ǉubiš',
  'ǉubit',
  'ljubo',
  'ǉubom',
  'ljubu',
  'ljuća',
  'ljuće',
  'ljući',
  'ljude',
  'ljudi',
  'ljulj',
  'ǉuǉaj',
  'ǉuǉam',
  'ǉuǉao',
  'ǉupka',
  'ǉupke',
  'ǉupki',
  'ǉupko',
  'ǉupku',
  'ǉusci',
  'ǉuska',
  'ǉuske',
  'ǉuski',
  'ǉusku',
  'ǉušte',
  'ǉušti',
  'ljuta',
  'ljute',
  'ljuti',
  'ǉutić',
  'ǉutih',
  'ǉutim',
  'ǉutio',
  'ǉutiš',
  'ǉutit',
  'ǉutko',
  'ǉutǌa',
  'ǉutǌe',
  'ǉutǌi',
  'ǉutǌu',
  'ljuto',
  'ǉutog',
  'ǉutoj',
  'ǉutom',
  'ljutu',
  'local',
  'locke',
  'logan',
  'logoa',
  'logoe',
  'logoi',
  'logom',
  'logor',
  'logos',
  'logou',
  'lojem',
  'lojna',
  'lojne',
  'lojni',
  'lojnu',
  'lokal',
  'lokne',
  'lokot',
  'lokum',
  'lokva',
  'lokve',
  'lokvi',
  'lokvu',
  'lolin',
  'lolom',
  'loman',
  'lomio',
  'lomiš',
  'lomna',
  'lomne',
  'lomni',
  'lomno',
  'lomnu',
  'lomom',
  'lonac',
  'lonca',
  'lonce',
  'lonci',
  'loncu',
  'lopez',
  'lopoč',
  'lopov',
  'lopta',
  'lopte',
  'lopti',
  'loptu',
  'lorda',
  'lorde',
  'lordu',
  'loren',
  'lošeg',
  'lošem',
  'loših',
  'lošim',
  'lošiǌ',
  'lošoj',
  'losom',
  'lošom',
  'losos',
  'lotan',
  'lotom',
  'lotos',
  'lotus',
  'lovac',
  'lovca',
  'lovce',
  'lovče',
  'lovci',
  'lovcu',
  'lovio',
  'loviš',
  'lovit',
  'lovna',
  'lovne',
  'lovni',
  'lovno',
  'lovnu',
  'lovom',
  'lovor',
  'lovre',
  'ložač',
  'ložio',
  'loživ',
  'lozom',
  'ložom',
  'lozov',
  'lubin',
  'lučac',
  'lučan',
  'lucas',
  'lučca',
  'lučcu',
  'lucia',
  'lučić',
  'lučio',
  'lučka',
  'lučke',
  'lučki',
  'lučko',
  'lučku',
  'lučna',
  'lučne',
  'lučni',
  'lučno',
  'lučnu',
  'ludak',
  'luđak',
  'ludih',
  'ludim',
  'ludog',
  'ludoj',
  'ludom',
  'luduj',
  'lugar',
  'luger',
  'lugom',
  'lugov',
  'luigi',
  'luisa',
  'luise',
  'lukač',
  'lukas',
  'lukav',
  'lukić',
  'lukin',
  'lukom',
  'lukov',
  'lulom',
  'lumen',
  'lumpa',
  'lunja',
  'lunom',
  'lupam',
  'lupan',
  'lupao',
  'lupež',
  'lupne',
  'lupni',
  'lupnu',
  'lupom',
  'lupus',
  'lutaj',
  'lutak',
  'lutam',
  'lutao',
  'luter',
  'lutka',
  'lutke',
  'lutki',
  'lutku',
  'lutǌa',
  'lutǌe',
  'lutǌi',
  'lutǌu',
  'mabel',
  'mačak',
  'macan',
  'maček',
  'mačem',
  'mačić',
  'macin',
  'mačja',
  'mačje',
  'mačji',
  'mačju',
  'macka',
  'mačka',
  'mačke',
  'mački',
  'mačko',
  'mačku',
  'macom',
  'macor',
  'mačor',
  'mačva',
  'mačve',
  'mačvi',
  'mačvu',
  'madam',
  'mađar',
  'madež',
  'madge',
  'magda',
  'magic',
  'magla',
  'magle',
  'magli',
  'maglu',
  'magma',
  'magme',
  'magmi',
  'magmu',
  'magom',
  'mahal',
  'mahao',
  'mahat',
  'mahne',
  'mahni',
  'mahnu',
  'mahom',
  'maila',
  'maine',
  'majci',
  'majem',
  'majer',
  'majin',
  'majka',
  'majke',
  'majki',
  'majko',
  'majku',
  'majni',
  'majom',
  'major',
  'majur',
  'makac',
  'makao',
  'makar',
  'makla',
  'makne',
  'makni',
  'maknu',
  'makoh',
  'makom',
  'makov',
  'makro',
  'maksa',
  'maksi',
  'malca',
  'malče',
  'malci',
  'malen',
  'maler',
  'malih',
  'malik',
  'malim',
  'malja',
  'maǉem',
  'malju',
  'malko',
  'malne',
  'malog',
  'maloj',
  'malom',
  'malta',
  'malte',
  'malti',
  'mamac',
  'mamba',
  'mambo',
  'mamca',
  'mamce',
  'mamci',
  'mamcu',
  'mamin',
  'mamiš',
  'mamit',
  'mamom',
  'mamut',
  'manga',
  'mange',
  'mangi',
  'mango',
  'mangu',
  'manir',
  'manja',
  'maǌak',
  'manje',
  'maǌeg',
  'maǌem',
  'manji',
  'maǌih',
  'maǌim',
  'maǌka',
  'maǌke',
  'maǌku',
  'maǌoj',
  'maǌom',
  'manju',
  'manom',
  'manta',
  'mante',
  'manti',
  'manto',
  'mantu',
  'mapom',
  'marah',
  'maran',
  'marca',
  'marci',
  'marco',
  'marej',
  'marek',
  'marge',
  'margo',
  'maria',
  'marić',
  'marie',
  'marim',
  'marin',
  'mario',
  'maris',
  'marit',
  'marka',
  'marke',
  'marki',
  'marko',
  'marku',
  'marna',
  'marne',
  'marni',
  'marno',
  'marnu',
  'marod',
  'marof',
  'marom',
  'marsa',
  'marša',
  'marsu',
  'maršu',
  'marta',
  'marte',
  'marti',
  'martu',
  'marva',
  'marve',
  'marvo',
  'marvu',
  'marža',
  'maržu',
  'masan',
  'masci',
  'mašću',
  'mašem',
  'maser',
  'mašin',
  'masiv',
  'maska',
  'maske',
  'maski',
  'masku',
  'masla',
  'maslo',
  'maslu',
  'masna',
  'mašna',
  'masne',
  'masni',
  'masno',
  'masnu',
  'mašnu',
  'masom',
  'mason',
  'mašta',
  'maste',
  'mašte',
  'masti',
  'mašti',
  'maštu',
  'matej',
  'mateo',
  'mater',
  'matić',
  'matom',
  'mator',
  'maude',
  'maunt',
  'maura',
  'mavro',
  'mazan',
  'mažem',
  'mažen',
  'mazga',
  'mazge',
  'mazgi',
  'mazgu',
  'mazin',
  'mazna',
  'mazne',
  'mazni',
  'mazno',
  'maznu',
  'mazom',
  'mazut',
  'meade',
  'mećem',
  'mečem',
  'mečka',
  'mečke',
  'mečku',
  'mečom',
  'medar',
  'međaš',
  'meden',
  'media',
  'medij',
  'medju',
  'medna',
  'medne',
  'medni',
  'medno',
  'mednu',
  'medom',
  'međom',
  'megan',
  'mehko',
  'mehur',
  'mekan',
  'meket',
  'mekih',
  'mekim',
  'mekog',
  'mekoj',
  'mekom',
  'mekša',
  'mekše',
  'mekši',
  'mekšu',
  'melek',
  'melem',
  'melez',
  'melje',
  'melji',
  'melju',
  'melos',
  'memle',
  'memli',
  'menja',
  'meǌao',
  'meǌaš',
  'menta',
  'mente',
  'menti',
  'mento',
  'mentu',
  'menza',
  'menze',
  'menzo',
  'menzu',
  'merak',
  'meren',
  'meril',
  'merle',
  'merna',
  'mesar',
  'mesec',
  'mesić',
  'mesna',
  'mesne',
  'mesni',
  'mesno',
  'mesnu',
  'mesom',
  'mesta',
  'mesti',
  'mesto',
  'mestu',
  'metak',
  'metal',
  'metan',
  'metar',
  'metci',
  'metem',
  'metež',
  'metil',
  'metiǉ',
  'metju',
  'metka',
  'metke',
  'metku',
  'metla',
  'metle',
  'metli',
  'metlu',
  'metne',
  'metni',
  'metnu',
  'metod',
  'metom',
  'metra',
  'metri',
  'metro',
  'metru',
  'mezar',
  'mezij',
  'mezon',
  'miami',
  'micah',
  'mican',
  'micao',
  'mičem',
  'mićić',
  'mider',
  'migaš',
  'migel',
  'migne',
  'migni',
  'mignu',
  'migom',
  'mihaǉ',
  'mihić',
  'mijat',
  'mijeh',
  'mikea',
  'mikić',
  'mikro',
  'milan',
  'miler',
  'miles',
  'milić',
  'milih',
  'milit',
  'milja',
  'miǉan',
  'milje',
  'miǉea',
  'miǉeu',
  'milji',
  'miljo',
  'miǉom',
  'milju',
  'milka',
  'milko',
  'milog',
  'miloj',
  'milom',
  'miloš',
  'miluj',
  'minas',
  'mineš',
  'minić',
  'minja',
  'miǌon',
  'minom',
  'minuh',
  'minus',
  'minut',
  'mioma',
  'miomi',
  'miona',
  'mione',
  'mioni',
  'mirah',
  'miran',
  'miraz',
  'miren',
  'mirhe',
  'mirim',
  'mirio',
  'miris',
  'mirka',
  'mirko',
  'mirna',
  'mirne',
  'mirni',
  'mirno',
  'mirnu',
  'mirom',
  'mirta',
  'mirte',
  'mirti',
  'mirto',
  'miruj',
  'mirza',
  'mirze',
  'mirzi',
  'mirzo',
  'mirzu',
  'misal',
  'misao',
  'mišar',
  'mišel',
  'mišem',
  'mišić',
  'mišja',
  'mišje',
  'mišji',
  'mišju',
  'miško',
  'misle',
  'misli',
  'mišǉu',
  'misna',
  'misne',
  'misni',
  'misno',
  'misnu',
  'misom',
  'mitar',
  'mitić',
  'mitom',
  'mitra',
  'mitre',
  'mitri',
  'mitro',
  'mitru',
  'mjedi',
  'mjeǌa',
  'mjera',
  'mjere',
  'mjeri',
  'mjeru',
  'mlače',
  'mlaci',
  'mlači',
  'mlada',
  'mlađa',
  'mlade',
  'mlađe',
  'mladi',
  'mlađi',
  'mlado',
  'mlađo',
  'mladu',
  'mlađu',
  'mlaka',
  'mlake',
  'mlaki',
  'mlako',
  'mlaku',
  'mlata',
  'mlate',
  'mlati',
  'mlavi',
  'mlaza',
  'mlazu',
  'mleka',
  'mleko',
  'mlina',
  'mline',
  'mlinu',
  'mǉeli',
  'mǉelo',
  'mǉeti',
  'mǌeǌa',
  'mǌeǌe',
  'mǌeǌu',
  'mnoga',
  'mnoge',
  'mnogi',
  'mnogo',
  'mnogu',
  'mnome',
  'množe',
  'množi',
  'mobom',
  'mocan',
  'moćan',
  'moćna',
  'moćne',
  'moćni',
  'moćno',
  'moćnu',
  'modar',
  'model',
  'modem',
  'modna',
  'modne',
  'modni',
  'modno',
  'modnu',
  'modom',
  'modra',
  'modre',
  'modri',
  'modro',
  'modru',
  'modul',
  'modus',
  'mogah',
  'mogao',
  'mogla',
  'mogle',
  'mogli',
  'moglo',
  'mogoh',
  'moguć',
  'mogul',
  'moher',
  'moira',
  'mojeg',
  'mojem',
  'mojih',
  'mojim',
  'mojoj',
  'mojom',
  'mokar',
  'mokra',
  'mokre',
  'mokri',
  'mokro',
  'mokru',
  'molba',
  'molbe',
  'molbi',
  'molbu',
  'moler',
  'molim',
  'molio',
  'molit',
  'moǉac',
  'moǉca',
  'moǉce',
  'moǉci',
  'moǉcu',
  'molom',
  'momak',
  'momče',
  'momci',
  'momir',
  'momka',
  'momke',
  'momku',
  'monah',
  'monro',
  'monte',
  'monti',
  'moped',
  'moral',
  'moram',
  'moran',
  'morao',
  'moras',
  'moraš',
  'morat',
  'morem',
  'moren',
  'morin',
  'morio',
  'moris',
  'moriš',
  'morom',
  'moron',
  'morse',
  'morta',
  'morte',
  'mortu',
  'morža',
  'moses',
  'mosna',
  'mosni',
  'mošǌa',
  'mošǌe',
  'mošǌi',
  'mosta',
  'mošta',
  'moste',
  'mošti',
  'mostu',
  'mošus',
  'motel',
  'motet',
  'motiv',
  'motka',
  'motke',
  'motki',
  'motku',
  'motom',
  'motor',
  'motre',
  'motri',
  'mount',
  'mouse',
  'movie',
  'mozak',
  'mozda',
  'možda',
  'možeš',
  'mozga',
  'mozgu',
  'mozka',
  'mrače',
  'mraka',
  'mraku',
  'mrava',
  'mrave',
  'mravi',
  'mravu',
  'mraza',
  'mrazu',
  'mrena',
  'mrene',
  'mrenu',
  'mreža',
  'mreže',
  'mreži',
  'mrežu',
  'mrǉan',
  'mrǉom',
  'mršav',
  'mržǌa',
  'mržǌe',
  'mržǌi',
  'mržǌu',
  'mućak',
  'mučan',
  'mucao',
  'mučen',
  'mučim',
  'mučio',
  'mućka',
  'mućke',
  'mučke',
  'mućki',
  'mučki',
  'mučna',
  'mučne',
  'mućni',
  'mučno',
  'mučnu',
  'mudar',
  'mudra',
  'mudre',
  'mudri',
  'mudro',
  'mudru',
  'muhin',
  'muhom',
  'muhur',
  'mukao',
  'mukat',
  'mukla',
  'mukle',
  'mukli',
  'muklo',
  'mukom',
  'mukte',
  'mulac',
  'mulat',
  'mulca',
  'mulci',
  'mulcu',
  'mulja',
  'muǉem',
  'mulju',
  'mulom',
  'multi',
  'mundi',
  'munga',
  'mungo',
  'mungu',
  'munja',
  'munje',
  'munji',
  'munjo',
  'muǌom',
  'munju',
  'muona',
  'muone',
  'muoni',
  'mural',
  'murat',
  'murva',
  'murvi',
  'murvu',
  'music',
  'muška',
  'muške',
  'muški',
  'muško',
  'mušku',
  'musti',
  'mutan',
  'mutav',
  'mutio',
  'mutna',
  'mutne',
  'mutni',
  'mutno',
  'mutnu',
  'muvom',
  'muzao',
  'mužar',
  'muzej',
  'muzem',
  'mužem',
  'mužen',
  'mužev',
  'muzga',
  'mužić',
  'muzla',
  'muzli',
  'mužǌi',
  'mužǌu',
  'muzom',
  'mužom',
  'nabih',
  'nabio',
  'naboj',
  'nabor',
  'nabra',
  'načas',
  'načeo',
  'načet',
  'nacin',
  'način',
  'načni',
  'načnu',
  'načuo',
  'naćve',
  'nadaj',
  'nadal',
  'nadam',
  'nadao',
  'nađem',
  'nađen',
  'nađeš',
  'nadia',
  'nadin',
  'nadme',
  'nadno',
  'nađoh',
  'nadom',
  'nadri',
  'nadro',
  'nadru',
  'nadut',
  'nafta',
  'nafte',
  'nafti',
  'naftu',
  'nagao',
  'nagib',
  'nagih',
  'nagla',
  'nagle',
  'nagli',
  'naglo',
  'naglu',
  'nagna',
  'nagne',
  'nagni',
  'nagnu',
  'nagog',
  'nagon',
  'nahod',
  'naići',
  'naiđe',
  'naiđu',
  'naime',
  'najam',
  'najeo',
  'najma',
  'najmi',
  'najmu',
  'nakit',
  'nakon',
  'nakot',
  'nakuj',
  'nalaz',
  'nalet',
  'nalič',
  'nalik',
  'naliv',
  'nalog',
  'namah',
  'namaz',
  'namet',
  'namot',
  'namre',
  'namri',
  'namro',
  'namru',
  'naneo',
  'nanio',
  'nanos',
  'naoko',
  'naomi',
  'naora',
  'naoru',
  'naosa',
  'napad',
  'napao',
  'napeh',
  'napeo',
  'napet',
  'napih',
  'napij',
  'napio',
  'napis',
  'napne',
  'napni',
  'napnu',
  'napoj',
  'napol',
  'napon',
  'napor',
  'napuǉ',
  'narav',
  'narev',
  'narko',
  'narod',
  'narom',
  'nasad',
  'našao',
  'našeg',
  'našem',
  'naser',
  'naših',
  'našim',
  'nasip',
  'nasla',
  'našla',
  'našle',
  'našli',
  'našlo',
  'našoj',
  'našom',
  'naspe',
  'nasuh',
  'nasuo',
  'nasut',
  'natom',
  'natru',
  'nauče',
  'nauci',
  'nauči',
  'naude',
  'naudi',
  'nauka',
  'nauke',
  'nauko',
  'nauku',
  'nauma',
  'naume',
  'naumu',
  'navek',
  'naveo',
  'navih',
  'navio',
  'navod',
  'navoj',
  'navre',
  'nazad',
  'nazal',
  'nažao',
  'naziv',
  'nazor',
  'nazre',
  'nazri',
  'nazuj',
  'nazva',
  'nebom',
  'nećak',
  'nečeg',
  'nečem',
  'nećeš',
  'nečim',
  'nećka',
  'nedić',
  'negda',
  'negde',
  'nehaj',
  'nehat',
  'neila',
  'nejač',
  'nejak',
  'nekad',
  'nekih',
  'nekim',
  'nekoć',
  'nekog',
  'nekoj',
  'nekom',
  'nekud',
  'nemac',
  'nemam',
  'neman',
  'nemao',
  'nemar',
  'nemaš',
  'nemat',
  'nemce',
  'nemci',
  'nemio',
  'nemir',
  'nemoć',
  'nemoj',
  'nenad',
  'nensi',
  'neona',
  'neoni',
  'neonu',
  'nepal',
  'nepar',
  'nepca',
  'nepce',
  'nepcu',
  'nepun',
  'nerad',
  'nerca',
  'nered',
  'neron',
  'nerva',
  'nerve',
  'nervi',
  'nervu',
  'nešić',
  'nesle',
  'nesti',
  'nesto',
  'nešto',
  'netko',
  'netom',
  'neuka',
  'neuke',
  'neuki',
  'neuko',
  'neuku',
  'neven',
  'never',
  'nevin',
  'nezna',
  'nežna',
  'nežne',
  'nežno',
  'nicao',
  'nicat',
  'ničeg',
  'ničem',
  'ničeš',
  'ničim',
  'nicka',
  'nigda',
  'nigde',
  'nigel',
  'niger',
  'nijem',
  'nijet',
  'nikad',
  'nikal',
  'nikao',
  'nikim',
  'nikla',
  'nikle',
  'nikli',
  'niklo',
  'niklu',
  'nikne',
  'nikni',
  'niknu',
  'nikog',
  'nikol',
  'nikom',
  'nikos',
  'nikša',
  'nikud',
  'nimet',
  'nimfa',
  'nimfe',
  'nimfi',
  'nimfu',
  'ninǆa',
  'ninǆe',
  'ninǆi',
  'ninǆu',
  'ninja',
  'nisam',
  'nišan',
  'niska',
  'niška',
  'niske',
  'niške',
  'niski',
  'niški',
  'nisko',
  'nisku',
  'nišku',
  'nismo',
  'nišom',
  'nista',
  'ništa',
  'niste',
  'nište',
  'nitko',
  'nitna',
  'nitni',
  'nitro',
  'nivoa',
  'nivoe',
  'nivoi',
  'nivou',
  'nizah',
  'nizak',
  'nizao',
  'nižeg',
  'nižem',
  'nižih',
  'nižim',
  'nižoj',
  'nizom',
  'nižom',
  'njače',
  'ǌedra',
  'ǌedro',
  'njega',
  'njege',
  'njego',
  'ǌegom',
  'ǌegoš',
  'ǌegov',
  'njegu',
  'ǌemac',
  'njemu',
  'njena',
  'njene',
  'njeni',
  'ǌenih',
  'ǌenim',
  'njeno',
  'ǌenog',
  'ǌenoj',
  'ǌenom',
  'njenu',
  'ǌežan',
  'njezi',
  'ǌezin',
  'ǌežna',
  'ǌežne',
  'ǌežni',
  'ǌežno',
  'ǌežnu',
  'ǌihaj',
  'ǌihov',
  'njima',
  'njime',
  'njiše',
  'ǌišem',
  'njišu',
  'njiva',
  'njive',
  'njivi',
  'njivu',
  'njoka',
  'njoki',
  'njoku',
  'njome',
  'njuha',
  'njuhe',
  'ǌuhom',
  'njuhu',
  'ǌušci',
  'njuši',
  'ǌuška',
  'ǌuške',
  'ǌuški',
  'ǌuško',
  'ǌušku',
  'njutn',
  'noble',
  'noćas',
  'noćio',
  'noćiš',
  'noćna',
  'noćne',
  'noćni',
  'noćno',
  'noćnu',
  'nogar',
  'nogat',
  'nogom',
  'nojem',
  'nokat',
  'nokia',
  'nokta',
  'nokte',
  'nokti',
  'noktu',
  'nolan',
  'nolit',
  'nomad',
  'norma',
  'norme',
  'normi',
  'normo',
  'normu',
  'nosač',
  'nošen',
  'nosić',
  'nosim',
  'nosio',
  'nosiš',
  'nosit',
  'nosiv',
  'nosna',
  'nosne',
  'nosni',
  'nošǌa',
  'nošǌe',
  'nošǌi',
  'nošǌu',
  'nosno',
  'nosnu',
  'nosom',
  'notar',
  'notes',
  'notna',
  'notne',
  'notni',
  'notno',
  'notnu',
  'notom',
  'notre',
  'novac',
  'novak',
  'novca',
  'novce',
  'novci',
  'novcu',
  'novih',
  'novim',
  'novog',
  'novoj',
  'novom',
  'nožem',
  'nožić',
  'nožna',
  'nožne',
  'nožni',
  'nožno',
  'nožnu',
  'nsaid',
  'nuđen',
  'nudio',
  'nudit',
  'nukan',
  'nukat',
  'nulom',
  'nulta',
  'nulte',
  'nulti',
  'nulto',
  'nultu',
  'nušić',
  'nutka',
  'nužan',
  'nužda',
  'nužde',
  'nuždi',
  'nuždu',
  'nužna',
  'nužne',
  'nužni',
  'nužno',
  'nužnu',
  'oazom',
  'obada',
  'obadi',
  'obaju',
  'obala',
  'obale',
  'obali',
  'obalo',
  'obalu',
  'obama',
  'obame',
  'obara',
  'obasu',
  'obave',
  'obavi',
  'obdan',
  'obeća',
  'obere',
  'oberi',
  'obići',
  'obiđe',
  'obiđu',
  'obija',
  'obije',
  'obiju',
  'obili',
  'obiǉa',
  'obiǉe',
  'obiǉu',
  'obilo',
  'obima',
  'obimi',
  'obimu',
  'obiri',
  'obiti',
  'objed',
  'oblak',
  'oblih',
  'oblij',
  'oblik',
  'oblim',
  'oblog',
  'obloj',
  'oblom',
  'obnoć',
  'oboda',
  'obode',
  'obodi',
  'obodu',
  'oboje',
  'oboji',
  'obole',
  'oboli',
  'obolo',
  'oboma',
  'obora',
  'obore',
  'obori',
  'oboru',
  'obrad',
  'obran',
  'obrat',
  'obraz',
  'obrće',
  'obrću',
  'obred',
  'obris',
  'obrok',
  'obrub',
  'obruč',
  'obuca',
  'obuća',
  'obuće',
  'obuče',
  'obuci',
  'obući',
  'obuči',
  'obuću',
  'obuje',
  'obuka',
  'obuke',
  'obuko',
  'obuku',
  'obuti',
  'obuva',
  'obuze',
  'obzir',
  'obzor',
  'očaja',
  'očaju',
  'ocala',
  'ocale',
  'očara',
  'ocean',
  'ocena',
  'ocene',
  'oceni',
  'ocenu',
  'očeva',
  'očeve',
  'očevi',
  'očevo',
  'očevu',
  'očicu',
  'očiju',
  'ocima',
  'očima',
  'očita',
  'očite',
  'očiti',
  'očito',
  'očitu',
  'očnih',
  'očnim',
  'očǌak',
  'očnog',
  'očnoj',
  'očnom',
  'octim',
  'octom',
  'očuha',
  'očuhu',
  'očuva',
  'ocvao',
  'odaja',
  'odaje',
  'odaji',
  'odaju',
  'odala',
  'odale',
  'odali',
  'odaǉi',
  'odalo',
  'odama',
  'odamo',
  'odana',
  'odane',
  'odani',
  'odano',
  'odanu',
  'odape',
  'odara',
  'odati',
  'odbij',
  'odbio',
  'odbir',
  'odbor',
  'odeća',
  'odeće',
  'odeći',
  'odeću',
  'odelo',
  'odelu',
  'odemo',
  'odera',
  'oderi',
  'oderu',
  'odesa',
  'odesi',
  'odete',
  'odgoj',
  'odiše',
  'odišu',
  'odiže',
  'odjek',
  'odjel',
  'odlih',
  'odlij',
  'odǉev',
  'odmah',
  'odmak',
  'odmet',
  'odmor',
  'odnio',
  'odnos',
  'odoka',
  'odole',
  'odoli',
  'odora',
  'odore',
  'odori',
  'odoru',
  'odoše',
  'odpor',
  'odraz',
  'odred',
  'odrod',
  'odrom',
  'odron',
  'održa',
  'održe',
  'održi',
  'odsad',
  'odsek',
  'oduka',
  'oduku',
  'oduze',
  'oduže',
  'oduži',
  'odveć',
  'odveo',
  'odvih',
  'odvij',
  'odvio',
  'odvod',
  'odvoz',
  'oǆaci',
  'odžak',
  'oǆaka',
  'oǆake',
  'oǆaku',
  'odziv',
  'ofset',
  'ofuri',
  'oganj',
  'ogden',
  'ogiba',
  'oglas',
  'ogled',
  'ogǌem',
  'ogǌen',
  'ogole',
  'ogoli',
  'ogrij',
  'ogule',
  'oguli',
  'ohaja',
  'ohajo',
  'ohaju',
  'ohola',
  'ohole',
  'oholi',
  'oholo',
  'oholu',
  'ohrid',
  'ojača',
  'ojadi',
  'ojkao',
  'okači',
  'okaja',
  'okaju',
  'okana',
  'okane',
  'okani',
  'okapa',
  'okata',
  'okati',
  'okatu',
  'okcem',
  'okean',
  'okere',
  'okeru',
  'okica',
  'okice',
  'okida',
  'okinu',
  'okite',
  'okiti',
  'okiva',
  'oklop',
  'oknom',
  'okole',
  'okoli',
  'okolo',
  'okome',
  'okomi',
  'okopa',
  'okore',
  'okose',
  'okota',
  'okote',
  'okoti',
  'okotu',
  'okova',
  'okove',
  'okovi',
  'okret',
  'okrug',
  'oksid',
  'oktan',
  'oktet',
  'okuci',
  'okuje',
  'okuju',
  'okuka',
  'okuke',
  'okuku',
  'okupa',
  'okupe',
  'okupi',
  'okupu',
  'okusa',
  'okuša',
  'okuse',
  'okusi',
  'okusu',
  'okvir',
  'olako',
  'olimp',
  'olive',
  'ološa',
  'olova',
  'olovo',
  'olovu',
  'olsen',
  'olson',
  'oltar',
  'oluci',
  'oluja',
  'oluje',
  'oluji',
  'oluju',
  'oluka',
  'olupi',
  'omaci',
  'omaći',
  'omaha',
  'omama',
  'omami',
  'omaǌa',
  'omaǌe',
  'omaǌi',
  'omaǌu',
  'omara',
  'omari',
  'omaru',
  'omata',
  'omaza',
  'omčom',
  'omeđe',
  'omega',
  'omege',
  'omela',
  'omele',
  'omeli',
  'omelo',
  'omeni',
  'omera',
  'omere',
  'omeru',
  'omest',
  'ometa',
  'omete',
  'ometi',
  'ometu',
  'omili',
  'omima',
  'omiša',
  'omjer',
  'omlet',
  'omora',
  'omota',
  'omote',
  'omoti',
  'omotu',
  'onako',
  'onamo',
  'oniks',
  'onima',
  'onime',
  'onoga',
  'onome',
  'onomu',
  'onuda',
  'opada',
  'opaka',
  'opake',
  'opaki',
  'opaku',
  'opala',
  'opale',
  'opali',
  'opalo',
  'opara',
  'opare',
  'opasa',
  'opaše',
  'opata',
  'opate',
  'opati',
  'opaža',
  'opazi',
  'općeg',
  'općem',
  'općen',
  'općih',
  'općim',
  'općoj',
  'općom',
  'opeče',
  'opeci',
  'opeći',
  'opeka',
  'opeke',
  'opeko',
  'opeku',
  'opela',
  'opelo',
  'opelu',
  'opena',
  'openu',
  'opera',
  'opere',
  'operi',
  'operu',
  'ophod',
  'opija',
  'opije',
  'opiju',
  'opile',
  'opili',
  'opipa',
  'opipi',
  'opire',
  'opiru',
  'opisa',
  'opise',
  'opiše',
  'opisi',
  'opisu',
  'opišu',
  'opita',
  'opite',
  'opiti',
  'opitu',
  'opium',
  'opkop',
  'opleo',
  'opnom',
  'opole',
  'opolu',
  'opora',
  'opore',
  'opori',
  'oporo',
  'oporu',
  'opran',
  'oprao',
  'oprat',
  'oprem',
  'oprez',
  'oprže',
  'opšav',
  'opseg',
  'opšta',
  'opšte',
  'opšti',
  'opštu',
  'opsuj',
  'optok',
  'opusa',
  'opusi',
  'opusu',
  'opute',
  'oputu',
  'oraća',
  'orača',
  'orači',
  'orada',
  'oraha',
  'orahe',
  'orahu',
  'orala',
  'orale',
  'orali',
  'oralo',
  'orana',
  'orane',
  'orani',
  'oraǌa',
  'oraǌe',
  'oraǌu',
  'oranu',
  'oraše',
  'orasi',
  'orati',
  'orden',
  'order',
  'oremo',
  'oreol',
  'orete',
  'orfej',
  'organ',
  'orila',
  'orilo',
  'orimo',
  'orion',
  'orisa',
  'orisi',
  'oriti',
  'orkan',
  'orlić',
  'orlom',
  'orlov',
  'orman',
  'ormar',
  'ormom',
  'ornoj',
  'ornom',
  'orobi',
  'orosi',
  'orozi',
  'orozu',
  'orson',
  'ortak',
  'ortiz',
  'oruđa',
  'oruđe',
  'oruđu',
  'osaka',
  'osala',
  'osama',
  'osame',
  'osami',
  'osamu',
  'oscar',
  'oseća',
  'oseka',
  'oseke',
  'oseko',
  'oseku',
  'oseti',
  'osica',
  'osici',
  'osicu',
  'osili',
  'osima',
  'osina',
  'osini',
  'ošini',
  'osiǌa',
  'osiǌi',
  'osinu',
  'osipa',
  'osipe',
  'osipi',
  'osjet',
  'oskar',
  'oslić',
  'oslom',
  'oslon',
  'osman',
  'osmeh',
  'osmih',
  'osmij',
  'osmim',
  'osmog',
  'osmoj',
  'osmom',
  'osnih',
  'osnim',
  'osnoj',
  'osnom',
  'osnov',
  'osnuj',
  'osoba',
  'osobe',
  'osobi',
  'osobu',
  'osovi',
  'ospem',
  'ostaj',
  'ostao',
  'oštar',
  'ostat',
  'oštra',
  'oštre',
  'oštri',
  'oštro',
  'oštru',
  'osuda',
  'osude',
  'osudi',
  'osudu',
  'osula',
  'osuli',
  'osuše',
  'osuši',
  'osvit',
  'otaca',
  'otada',
  'otale',
  'otamo',
  'otapa',
  'otare',
  'otari',
  'otaru',
  'otava',
  'otave',
  'otavi',
  'otavu',
  'oteče',
  'oteci',
  'oteći',
  'oteku',
  'otela',
  'otele',
  'oteli',
  'otelo',
  'otepe',
  'otepi',
  'otepu',
  'otera',
  'otesa',
  'oteše',
  'oteta',
  'otete',
  'oteti',
  'oteto',
  'otetu',
  'oteža',
  'oteže',
  'other',
  'otiče',
  'otići',
  'otiču',
  'otiđe',
  'otiđi',
  'otiđu',
  'otima',
  'otire',
  'otkad',
  'otkaz',
  'otkos',
  'otkud',
  'otkuj',
  'otkup',
  'otmem',
  'otmen',
  'otoče',
  'otoci',
  'otoka',
  'otoke',
  'otoku',
  'otona',
  'otope',
  'otopi',
  'otpad',
  'otpao',
  'otpio',
  'otpis',
  'otpor',
  'otrče',
  'otrči',
  'otrem',
  'otrov',
  'otruj',
  'otuda',
  'otupi',
  'otvor',
  'ovaca',
  'ovako',
  'ovala',
  'ovale',
  'ovali',
  'ovalu',
  'ovamo',
  'ovčar',
  'ovčja',
  'ovčje',
  'ovčji',
  'ovčju',
  'ovcom',
  'oveća',
  'oveće',
  'oveći',
  'ovija',
  'oviju',
  'ovilo',
  'ovima',
  'ovime',
  'ovine',
  'ovise',
  'ovisi',
  'ovita',
  'ovite',
  'oviti',
  'ovito',
  'ovjes',
  'ovlaš',
  'ovnom',
  'ovoga',
  'ovoja',
  'ovoji',
  'ovoju',
  'ovome',
  'ovomu',
  'ovsen',
  'ovuda',
  'ozada',
  'ožali',
  'ozare',
  'ozdol',
  'ozebe',
  'ozebi',
  'ozebu',
  'ožeći',
  'ožene',
  'oženi',
  'ožeti',
  'ozima',
  'ozime',
  'ožive',
  'oživi',
  'ozona',
  'ozoni',
  'ozonu',
  'ozren',
  'pabla',
  'pablo',
  'pacer',
  'pačić',
  'pačja',
  'pačje',
  'pačji',
  'packa',
  'packi',
  'packu',
  'pacom',
  'pacov',
  'padaj',
  'padam',
  'padao',
  'padez',
  'padež',
  'padne',
  'padni',
  'padnu',
  'padom',
  'padre',
  'paige',
  'pajac',
  'pajić',
  'pakao',
  'paket',
  'pakla',
  'pakli',
  'paklu',
  'pakne',
  'pakta',
  'paktu',
  'palac',
  'palca',
  'palce',
  'palci',
  'palcu',
  'palež',
  'palić',
  'palih',
  'palim',
  'palio',
  'palit',
  'paǉba',
  'paǉbe',
  'paǉbi',
  'paǉbu',
  'paǉen',
  'palma',
  'palme',
  'palmi',
  'palmo',
  'palmu',
  'palog',
  'paloj',
  'palom',
  'pamet',
  'pampa',
  'pampe',
  'pampi',
  'pamte',
  'pamti',
  'pamuk',
  'panda',
  'pande',
  'pandi',
  'pando',
  'pandu',
  'panǆa',
  'panǆe',
  'panǆi',
  'panǆo',
  'panel',
  'panić',
  'panja',
  'panju',
  'panoa',
  'panoe',
  'panoi',
  'panom',
  'panou',
  'panta',
  'panti',
  'pantu',
  'paola',
  'paolo',
  'papak',
  'papar',
  'papci',
  'paper',
  'papić',
  'papin',
  'papir',
  'papka',
  'papke',
  'papku',
  'papom',
  'papra',
  'papri',
  'papru',
  'papua',
  'paraf',
  'param',
  'paran',
  'parat',
  'parba',
  'parbi',
  'parbu',
  'parče',
  'paren',
  'parić',
  'pario',
  'parip',
  'paris',
  'parit',
  'pariz',
  'parka',
  'parku',
  'parna',
  'parne',
  'parni',
  'parno',
  'parnu',
  'paroh',
  'parom',
  'parti',
  'pasah',
  'pasan',
  'pasao',
  'pasat',
  'pasaž',
  'pašče',
  'pasci',
  'pasem',
  'pašem',
  'pasha',
  'pashe',
  'pašić',
  'pašin',
  'pasiv',
  'pasja',
  'pasje',
  'pasji',
  'pasju',
  'paska',
  'paška',
  'paski',
  'paški',
  'pasko',
  'paško',
  'pasku',
  'pašku',
  'pasla',
  'pasli',
  'paslo',
  'pasom',
  'pašom',
  'pasoš',
  'pasta',
  'paste',
  'pasti',
  'pašti',
  'pasto',
  'pašto',
  'pastu',
  'paštu',
  'pasuǉ',
  'pasus',
  'patak',
  'patci',
  'pater',
  'patim',
  'patio',
  'patka',
  'patke',
  'patki',
  'patku',
  'patǌa',
  'patǌe',
  'patǌi',
  'patǌu',
  'patom',
  'patos',
  'pauče',
  'pauci',
  'pauka',
  'pauke',
  'pauku',
  'paula',
  'paulo',
  'paulu',
  'pauna',
  'paune',
  'pauni',
  'pauza',
  'pauze',
  'pauzi',
  'pauzu',
  'pavao',
  'pavel',
  'pavić',
  'pavla',
  'pavle',
  'pavlu',
  'pazar',
  'pažem',
  'pazim',
  'pazin',
  'pazio',
  'pazit',
  'pažǌa',
  'pažǌe',
  'pažǌi',
  'pažǌu',
  'pazuh',
  'pčela',
  'pčele',
  'pčeli',
  'pčelu',
  'peace',
  'pearl',
  'pecah',
  'pecam',
  'pecan',
  'pecao',
  'pecar',
  'pecaš',
  'pecat',
  'pečat',
  'pečem',
  'pečen',
  'pecka',
  'pećka',
  'pećke',
  'pećki',
  'pećko',
  'pećku',
  'pecne',
  'pecni',
  'pecnu',
  'pedal',
  'pedaǉ',
  'peder',
  'pedǉa',
  'pedǉu',
  'pedra',
  'pedro',
  'pegaz',
  'pegla',
  'pehar',
  'pehom',
  'pekao',
  'pekar',
  'pekić',
  'pekla',
  'pekle',
  'pekli',
  'peklo',
  'pekom',
  'pelat',
  'pelet',
  'pelin',
  'peǉar',
  'pelud',
  'penal',
  'penis',
  'peǌač',
  'peǌao',
  'penje',
  'peǌem',
  'peǌeš',
  'penju',
  'penta',
  'pepeo',
  'perač',
  'perad',
  'perca',
  'perce',
  'percu',
  'perda',
  'perec',
  'perem',
  'perez',
  'perić',
  'periš',
  'perja',
  'perje',
  'perju',
  'perla',
  'perle',
  'perli',
  'perlo',
  'perlu',
  'perom',
  'peron',
  'perua',
  'perun',
  'perut',
  'pesah',
  'pesak',
  'pešća',
  'pešić',
  'peska',
  'peške',
  'pesku',
  'pesma',
  'pesme',
  'pesmi',
  'pesmu',
  'pesos',
  'pesta',
  'peste',
  'pešte',
  'pesti',
  'pešti',
  'petak',
  'petao',
  'petar',
  'petci',
  'peter',
  'petim',
  'petit',
  'petka',
  'petke',
  'petko',
  'petku',
  'petla',
  'petǉa',
  'petǉe',
  'petǉi',
  'petǉu',
  'petna',
  'petne',
  'petni',
  'petnu',
  'petog',
  'petoj',
  'petom',
  'petra',
  'petre',
  'petro',
  'petru',
  'pevač',
  'pevam',
  'pevao',
  'phila',
  'phone',
  'photo',
  'piano',
  'pićem',
  'pijan',
  'pijem',
  'piješ',
  'pijmo',
  'pijte',
  'pijuk',
  'pijun',
  'pikaj',
  'pikan',
  'pikne',
  'pikǌa',
  'pikom',
  'pikov',
  'pilad',
  'pilar',
  'pilat',
  'pilav',
  'pilić',
  'piǉak',
  'piǉar',
  'pilji',
  'piǉka',
  'pilom',
  'pilon',
  'pilot',
  'piǌol',
  'piǌon',
  'pinki',
  'pinta',
  'pinte',
  'pinti',
  'pinto',
  'pintu',
  'piona',
  'pione',
  'pioni',
  'pipac',
  'pipak',
  'pipan',
  'pipav',
  'pipca',
  'pipci',
  'pipcu',
  'piper',
  'pipin',
  'pipka',
  'pipke',
  'pipom',
  'piran',
  'pirat',
  'pirea',
  'pireu',
  'pirim',
  'pirit',
  'pirja',
  'pirka',
  'pirne',
  'pirni',
  'pirom',
  'pirot',
  'pirov',
  'pisac',
  'pisač',
  'pisah',
  'pisak',
  'pisan',
  'pisao',
  'pisar',
  'pisat',
  'pisca',
  'pisce',
  'pišče',
  'pisci',
  'piscu',
  'pišem',
  'pišeš',
  'piska',
  'pisku',
  'pisma',
  'pismo',
  'pismu',
  'pisne',
  'pisni',
  'pisnu',
  'pista',
  'pišta',
  'piste',
  'pisti',
  'pistu',
  'pitah',
  'pitaj',
  'pitak',
  'pitam',
  'pitan',
  'pitao',
  'pitaš',
  'pitat',
  'piter',
  'pitka',
  'pitke',
  'pitki',
  'pitko',
  'pitku',
  'pitom',
  'piton',
  'pivar',
  'pivom',
  'pivot',
  'pizda',
  'pizdi',
  'pizdu',
  'pizma',
  'pjega',
  'pjege',
  'pjegi',
  'pjego',
  'pjegu',
  'pjena',
  'pjene',
  'pjeni',
  'pjenu',
  'pjera',
  'pjeva',
  'pjevu',
  'placa',
  'plaća',
  'plača',
  'place',
  'plaće',
  'plače',
  'plaći',
  'plači',
  'placu',
  'plaću',
  'plaču',
  'plaha',
  'plahe',
  'plahi',
  'plaho',
  'plame',
  'plana',
  'plane',
  'plani',
  'plant',
  'planu',
  'plaše',
  'plaši',
  'plast',
  'plašt',
  'plata',
  'plate',
  'plati',
  'plato',
  'platu',
  'plava',
  'plave',
  'plavi',
  'plavo',
  'plavu',
  'plaza',
  'plaža',
  'plaze',
  'plaže',
  'plazi',
  'plaži',
  'plažu',
  'pleća',
  'pleći',
  'pleha',
  'plehu',
  'plela',
  'pleli',
  'plelo',
  'pleme',
  'plena',
  'plenu',
  'plesa',
  'plese',
  'pleše',
  'pleši',
  'plest',
  'plesu',
  'plešu',
  'plete',
  'pleti',
  'pletu',
  'plića',
  'pliće',
  'plići',
  'pliću',
  'plika',
  'plima',
  'plime',
  'plimi',
  'plimu',
  'plina',
  'plinu',
  'pliša',
  'pliva',
  'pǉeva',
  'pǉeve',
  'pǉevi',
  'pǉevu',
  'pǉuga',
  'pǉuje',
  'pǉuju',
  'pǉune',
  'pǉuni',
  'ploča',
  'ploče',
  'ploči',
  'pločo',
  'ploču',
  'ploda',
  'plodi',
  'plodu',
  'ploha',
  'plohe',
  'plohi',
  'plohu',
  'plota',
  'plotu',
  'plove',
  'plovi',
  'pluca',
  'pluća',
  'pluga',
  'plugu',
  'plusa',
  'pluse',
  'plusu',
  'pluta',
  'plute',
  'pluto',
  'plutu',
  'pobij',
  'pobio',
  'pobra',
  'poček',
  'počeo',
  'počet',
  'počev',
  'počne',
  'počni',
  'počnu',
  'podaj',
  'podam',
  'podao',
  'podat',
  'pođem',
  'pođeš',
  'podij',
  'podla',
  'podle',
  'podli',
  'podlo',
  'podna',
  'podne',
  'podni',
  'podno',
  'podnu',
  'pođoh',
  'podom',
  'poema',
  'poeme',
  'poemi',
  'poemu',
  'poena',
  'poene',
  'poeni',
  'poeta',
  'poete',
  'poeti',
  'poetu',
  'pogan',
  'pogna',
  'pogni',
  'pognu',
  'pogon',
  'pohod',
  'poima',
  'point',
  'pojac',
  'pojam',
  'pojas',
  'pojat',
  'pojem',
  'pojeo',
  'pojma',
  'pojmi',
  'pojmu',
  'pokal',
  'pokaz',
  'poker',
  'pokla',
  'pokoj',
  'pokoǉ',
  'pokop',
  'pokos',
  'pokri',
  'pokus',
  'polak',
  'polen',
  'polet',
  'polić',
  'polih',
  'polij',
  'polio',
  'polip',
  'polis',
  'polit',
  'polja',
  'poǉak',
  'polje',
  'poǉem',
  'polju',
  'polka',
  'polke',
  'polki',
  'polko',
  'polku',
  'polna',
  'polne',
  'polni',
  'polno',
  'polnu',
  'polog',
  'polom',
  'pomak',
  'poman',
  'pomen',
  'pomeo',
  'pomet',
  'pomna',
  'pomne',
  'pomni',
  'pomǌa',
  'pomǌe',
  'pomno',
  'pomnu',
  'pomoc',
  'pomoć',
  'pomol',
  'pomor',
  'pompa',
  'pompe',
  'pompo',
  'pompu',
  'pomru',
  'ponad',
  'poneo',
  'ponio',
  'ponoć',
  'ponor',
  'ponos',
  'ponte',
  'popeh',
  'popeo',
  'popet',
  'popih',
  'popij',
  'popio',
  'popis',
  'popit',
  'popne',
  'popni',
  'popnu',
  'popom',
  'popov',
  'popra',
  'poput',
  'porat',
  'poraz',
  'poreč',
  'pored',
  'poren',
  'porez',
  'porim',
  'poriv',
  'porno',
  'porod',
  'porok',
  'porom',
  'porta',
  'porte',
  'porti',
  'porto',
  'portu',
  'porub',
  'posao',
  'pošao',
  'posed',
  'posij',
  'posla',
  'pošla',
  'posle',
  'pošle',
  'posli',
  'pošli',
  'posǉe',
  'pošlo',
  'poslu',
  'posna',
  'posni',
  'posno',
  'posnu',
  'pospe',
  'pospu',
  'posta',
  'pošta',
  'poste',
  'pošte',
  'posti',
  'pošti',
  'posto',
  'pošto',
  'postu',
  'poštu',
  'posut',
  'posve',
  'poter',
  'potez',
  'potka',
  'potki',
  'potku',
  'potok',
  'potom',
  'potop',
  'potre',
  'pouče',
  'pouci',
  'pouči',
  'pouka',
  'pouke',
  'pouko',
  'pouku',
  'poveo',
  'povez',
  'povih',
  'povik',
  'povod',
  'povoj',
  'površ',
  'pozan',
  'pozar',
  'požar',
  'pozer',
  'poziv',
  'pozna',
  'pozne',
  'pozni',
  'pozno',
  'poznu',
  'pozom',
  'pozor',
  'pozva',
  'prada',
  'praga',
  'pragu',
  'praha',
  'prahu',
  'prala',
  'prale',
  'prali',
  'praǉa',
  'praǉe',
  'pralo',
  'prana',
  'prani',
  'praǌa',
  'praǌe',
  'praǌu',
  'pranu',
  'prasa',
  'prase',
  'praše',
  'prate',
  'prati',
  'prava',
  'prave',
  'pravi',
  'pravo',
  'pravu',
  'preče',
  'preci',
  'preći',
  'preči',
  'prečo',
  'preda',
  'pređa',
  'prede',
  'pređe',
  'predi',
  'pređi',
  'predu',
  'pređu',
  'preko',
  'prela',
  'prele',
  'preli',
  'preǉa',
  'preǉe',
  'prelu',
  'prema',
  'prene',
  'preni',
  'prenu',
  'presa',
  'preša',
  'prese',
  'preše',
  'presi',
  'preso',
  'prešo',
  'prest',
  'presu',
  'prete',
  'preti',
  'previ',
  'preži',
  'prezl',
  'prica',
  'priča',
  'price',
  'priče',
  'prići',
  'priči',
  'priču',
  'pride',
  'priđe',
  'priđi',
  'priđu',
  'prija',
  'prije',
  'prijo',
  'prima',
  'prime',
  'primi',
  'primo',
  'princ',
  'print',
  'prior',
  'prišt',
  'privi',
  'prǉav',
  'proba',
  'probe',
  'probi',
  'probo',
  'probu',
  'proći',
  'proču',
  'proda',
  'prođa',
  'prođe',
  'prođi',
  'prođu',
  'profi',
  'proha',
  'proja',
  'proje',
  'proji',
  'proli',
  'promo',
  'prope',
  'prosa',
  'prosi',
  'proši',
  'proso',
  'prost',
  'prota',
  'prote',
  'proti',
  'proto',
  'protu',
  'prova',
  'provo',
  'proza',
  'proze',
  'prozi',
  'prozu',
  'pršić',
  'pršti',
  'pršut',
  'pruća',
  'pruće',
  'pruda',
  'prude',
  'prudu',
  'pruga',
  'pruge',
  'prugo',
  'prugu',
  'pruta',
  'prute',
  'prutu',
  'pruža',
  'pruže',
  'pruzi',
  'pruži',
  'pržen',
  'pseća',
  'pseće',
  'pseći',
  'pseću',
  'pseta',
  'pseto',
  'psetu',
  'psića',
  'psići',
  'psiha',
  'psihe',
  'psihi',
  'psiho',
  'psihu',
  'psima',
  'psina',
  'psine',
  'psuje',
  'psuju',
  'ptica',
  'ptića',
  'ptice',
  'ptiće',
  'ptiče',
  'ptici',
  'ptići',
  'ptico',
  'pticu',
  'pucač',
  'pucaj',
  'pucam',
  'pucaǌ',
  'pucao',
  'pučem',
  'pucka',
  'pučka',
  'pučke',
  'pučki',
  'pučko',
  'pučku',
  'pućne',
  'pucǌa',
  'pucǌe',
  'pucǌi',
  'pucǌu',
  'pucom',
  'pudar',
  'puder',
  'pudla',
  'pudle',
  'pudli',
  'pudlu',
  'puhan',
  'puhao',
  'puhat',
  'puhne',
  'puhni',
  'puhnu',
  'pukao',
  'pukih',
  'pukim',
  'pukla',
  'pukle',
  'pukli',
  'puklo',
  'pukne',
  'pukni',
  'puknu',
  'pukog',
  'pukom',
  'pulen',
  'pulpa',
  'pulpe',
  'pulpi',
  'pulpo',
  'pulpu',
  'pulsa',
  'pulsu',
  'pulta',
  'pultu',
  'pumom',
  'pumpa',
  'pumpe',
  'pumpi',
  'pumpu',
  'punac',
  'punca',
  'puncu',
  'punđa',
  'punđu',
  'punih',
  'punim',
  'punio',
  'punit',
  'puǌač',
  'puǌen',
  'punog',
  'punoj',
  'punom',
  'punta',
  'pupak',
  'pupci',
  'pupin',
  'pupka',
  'pupke',
  'pupku',
  'puran',
  'purić',
  'purin',
  'purom',
  'pušač',
  'pušci',
  'pušem',
  'pušim',
  'pušio',
  'puska',
  'puška',
  'puške',
  'puški',
  'puško',
  'pušku',
  'pusom',
  'pusta',
  'pušta',
  'puste',
  'pusti',
  'pusto',
  'pustu',
  'putar',
  'putem',
  'puten',
  'puter',
  'putić',
  'putin',
  'putiš',
  'putna',
  'putne',
  'putni',
  'putno',
  'putnu',
  'putom',
  'putra',
  'putri',
  'putuj',
  'puzao',
  'puzav',
  'pužem',
  'pužev',
  'pužić',
  'puzim',
  'pužna',
  'pužni',
  'pužno',
  'puzom',
  'rabat',
  'rabim',
  'rabin',
  'rabio',
  'rabit',
  'rabom',
  'račić',
  'racin',
  'račja',
  'račje',
  'račji',
  'rački',
  'racom',
  'racun',
  'račun',
  'račva',
  'račve',
  'račvi',
  'rađam',
  'radan',
  'rađao',
  'radar',
  'rađen',
  'radia',
  'radić',
  'radič',
  'radij',
  'radim',
  'radin',
  'radio',
  'radiš',
  'radit',
  'radiu',
  'radna',
  'radne',
  'radni',
  'radǌa',
  'radǌe',
  'radǌi',
  'radǌu',
  'radno',
  'radnu',
  'radom',
  'radon',
  'radoš',
  'raduj',
  'radža',
  'radže',
  'raǆin',
  'radžu',
  'rafal',
  'rafom',
  'ragbi',
  'ragom',
  'rahat',
  'rahla',
  'rahli',
  'rahlo',
  'rahlu',
  'rahul',
  'rajan',
  'rajem',
  'rajha',
  'rajhu',
  'rajić',
  'rajin',
  'rajka',
  'rajko',
  'rajna',
  'rajne',
  'rajni',
  'rajom',
  'rajon',
  'rakar',
  'rakić',
  'rakǉa',
  'rakǉe',
  'rakom',
  'rakov',
  'rakun',
  'rališ',
  'ralja',
  'ralje',
  'ralom',
  'rambo',
  'ramiz',
  'ramom',
  'ramon',
  'ramos',
  'rampa',
  'rampe',
  'rampi',
  'rampo',
  'rampu',
  'ranac',
  'ranar',
  'ranca',
  'ranča',
  'rance',
  'ranče',
  'ranču',
  'ranga',
  'rangu',
  'ranih',
  'ranim',
  'ranio',
  'raǌav',
  'raǌen',
  'raǌiv',
  'ranka',
  'ranke',
  'ranki',
  'ranko',
  'ranku',
  'ranog',
  'ranoj',
  'ranom',
  'rapav',
  'rapid',
  'rapir',
  'rarog',
  'rasad',
  'rasan',
  'rasap',
  'rasel',
  'rašid',
  'raška',
  'raške',
  'raški',
  'raško',
  'rašku',
  'rasla',
  'rasle',
  'rasli',
  'rašǉe',
  'rašǉi',
  'rašǉu',
  'raslo',
  'rasna',
  'rasne',
  'rasni',
  'rasno',
  'rasnu',
  'rasol',
  'rasom',
  'raspe',
  'raspi',
  'raspu',
  'rasta',
  'raste',
  'rasti',
  'rastu',
  'rasuo',
  'rasut',
  'ratan',
  'ratar',
  'ratka',
  'ratko',
  'ratna',
  'ratne',
  'ratni',
  'ratno',
  'ratnu',
  'ratom',
  'ravan',
  'raven',
  'ravna',
  'ravne',
  'ravni',
  'ravno',
  'ravnu',
  'ražaǌ',
  'razbi',
  'razda',
  'razli',
  'razna',
  'razne',
  'razni',
  'ražǌa',
  'ražǌu',
  'razno',
  'raznu',
  'razum',
  'razvi',
  'rbina',
  'rđava',
  'rđavo',
  'reala',
  'rebra',
  'rebro',
  'rebru',
  'rebus',
  'rečem',
  'rečen',
  'rečju',
  'rečni',
  'redah',
  'redak',
  'redan',
  'redao',
  'redar',
  'redat',
  'redci',
  'redio',
  'redit',
  'redna',
  'redne',
  'redni',
  'redno',
  'rednu',
  'redom',
  'redov',
  'reful',
  'regal',
  'regan',
  'reisa',
  'reise',
  'reisi',
  'reisu',
  'rejon',
  'rekao',
  'reket',
  'rekla',
  'rekle',
  'rekli',
  'reklo',
  'rekne',
  'rekni',
  'reknu',
  'rekoh',
  'rekom',
  'relej',
  'relja',
  'reǉef',
  'remek',
  'remen',
  'remom',
  'rende',
  'renij',
  'renta',
  'rente',
  'renti',
  'rentu',
  'repat',
  'reper',
  'repić',
  'repin',
  'repna',
  'repne',
  'repni',
  'repno',
  'repnu',
  'repom',
  'rerna',
  'rerni',
  'rernu',
  'rešen',
  'reset',
  'resim',
  'rešim',
  'rešio',
  'resit',
  'reska',
  'reske',
  'reski',
  'resko',
  'resom',
  'resor',
  'retka',
  'retke',
  'retki',
  'retko',
  'retku',
  'retor',
  'retro',
  'reuma',
  'reume',
  'revan',
  'rever',
  'revir',
  'revna',
  'revni',
  'revno',
  'rezač',
  'rezak',
  'rezan',
  'režaǌ',
  'rezao',
  'rezat',
  'režem',
  'rezim',
  'režim',
  'režǌa',
  'režǌe',
  'režǌu',
  'rezom',
  'rezon',
  'rhode',
  'ribam',
  'ribar',
  'ribat',
  'ribić',
  'ribič',
  'ribiz',
  'ribǉa',
  'ribǉe',
  'ribǉi',
  'ribǉu',
  'ribom',
  'ricka',
  'riđan',
  'ridat',
  'riđeg',
  'rider',
  'ridge',
  'riđim',
  'rigat',
  'rijad',
  'rijah',
  'rijec',
  'riječ',
  'rikan',
  'riker',
  'rikne',
  'rikni',
  'riknu',
  'rikom',
  'rikša',
  'rikše',
  'rikši',
  'rilce',
  'rilom',
  'rimac',
  'rimom',
  'rinem',
  'ringa',
  'ringo',
  'ringu',
  'rinuh',
  'risan',
  'risat',
  'risom',
  'rista',
  'risto',
  'ritam',
  'riter',
  'ritma',
  'ritme',
  'ritmu',
  'ritne',
  'ritom',
  'rival',
  'riven',
  'river',
  'rivom',
  'rizik',
  'rižin',
  'rizom',
  'rižom',
  'rjeđa',
  'rjeđe',
  'rjeđi',
  'rjeđu',
  'robin',
  'robǉa',
  'robǉe',
  'robna',
  'robne',
  'robni',
  'robno',
  'robnu',
  'robom',
  'robot',
  'rocka',
  'rodak',
  'rođak',
  'rodan',
  'rodea',
  'rođen',
  'rodeo',
  'rodeu',
  'rodić',
  'rodij',
  'rodim',
  'rodin',
  'rodio',
  'rodiš',
  'rodit',
  'rodna',
  'rodne',
  'rodni',
  'rodno',
  'rodnu',
  'rodom',
  'roǆer',
  'rogač',
  'rogat',
  'roger',
  'rogom',
  'rogoz',
  'rogue',
  'rohav',
  'rojal',
  'rojem',
  'rojta',
  'rojti',
  'rojtu',
  'roker',
  'rokom',
  'rolan',
  'rolne',
  'rolni',
  'rolom',
  'roman',
  'romba',
  'rombu',
  'romea',
  'romeo',
  'romon',
  'romor',
  'ronac',
  'ronca',
  'ronce',
  'ronci',
  'ronda',
  'ronio',
  'ronit',
  'ropac',
  'ropci',
  'ropcu',
  'rosan',
  'rosen',
  'rošen',
  'rosie',
  'rosim',
  'rosit',
  'rosna',
  'rosne',
  'rosni',
  'rosno',
  'rosnu',
  'rosom',
  'rotim',
  'rotor',
  'rouge',
  'rovac',
  'rovah',
  'rovan',
  'rovca',
  'rovci',
  'rovcu',
  'rover',
  'roviǌ',
  'rovit',
  'rovka',
  'rovke',
  'rovki',
  'rovko',
  'rovom',
  'rozga',
  'rozge',
  'rozgi',
  'rozgu',
  'rozin',
  'rozom',
  'rtova',
  'rtovi',
  'rubac',
  'rubaǉ',
  'ruben',
  'rubim',
  'rubin',
  'rubit',
  'rubǉa',
  'rubǉe',
  'rubǉi',
  'rubǉu',
  'rubna',
  'rubne',
  'rubni',
  'rubno',
  'rubnu',
  'rubom',
  'ručak',
  'ručao',
  'rucka',
  'ručka',
  'ručke',
  'ručki',
  'ručku',
  'ručna',
  'ručne',
  'ručni',
  'ručno',
  'ručnu',
  'rudar',
  'ruđer',
  'rudim',
  'rudiš',
  'rudna',
  'rudne',
  'rudni',
  'rudno',
  'rudnu',
  'rudom',
  'rufus',
  'rugao',
  'ruglo',
  'ruglu',
  'ruhom',
  'ruina',
  'ruine',
  'rujan',
  'rujem',
  'rujna',
  'rujni',
  'rujno',
  'rujnu',
  'rukav',
  'rukom',
  'rulet',
  'rulja',
  'rulje',
  'rulji',
  'ruǉom',
  'rulju',
  'rumen',
  'rumom',
  'rumun',
  'runda',
  'runde',
  'rundi',
  'rundo',
  'rundu',
  'runit',
  'runom',
  'rupca',
  'rupce',
  'rupci',
  'rupcu',
  'rupom',
  'rušah',
  'rušen',
  'rusin',
  'rušio',
  'rušit',
  'ruska',
  'ruske',
  'ruski',
  'rusko',
  'rusku',
  'rusom',
  'rutav',
  'ruter',
  'rutin',
  'rutom',
  'ružan',
  'ružem',
  'ružić',
  'ružin',
  'ružna',
  'ružne',
  'ružni',
  'ružno',
  'ružnu',
  'ružom',
  'rvači',
  'rvaǌe',
  'rzati',
  'šabac',
  'sabah',
  'šaban',
  'sabat',
  'sabih',
  'sabij',
  'sabio',
  'sabir',
  'sabit',
  'sabǉa',
  'sabǉe',
  'sabǉi',
  'sabǉu',
  'sabor',
  'sabra',
  'sabur',
  'sačma',
  'sačme',
  'sačmi',
  'sadam',
  'sađem',
  'sađen',
  'sadie',
  'sadio',
  'sadit',
  'sadna',
  'sadni',
  'sadǌa',
  'sadǌe',
  'sadǌi',
  'sadǌu',
  'sadom',
  'sadra',
  'sadre',
  'sadri',
  'sadro',
  'sadru',
  'saǆak',
  'safet',
  'safir',
  'sagne',
  'sagni',
  'sagnu',
  'sagom',
  'sahan',
  'sahat',
  'sahne',
  'sahni',
  'sahnu',
  'šahom',
  'šahov',
  'šahta',
  'šahtu',
  'saint',
  'sajam',
  'šajka',
  'šajke',
  'sajla',
  'sajle',
  'sajli',
  'sajlu',
  'sajma',
  'sajme',
  'sajmu',
  'sajta',
  'sajtu',
  'šakač',
  'šakal',
  'sakat',
  'sakoa',
  'sakoi',
  'šakom',
  'sakou',
  'sakri',
  'salah',
  'salaj',
  'salaš',
  'salda',
  'saldo',
  'saldu',
  'salem',
  'salep',
  'salih',
  'salim',
  'šalim',
  'salio',
  'šalio',
  'šališ',
  'salit',
  'šalje',
  'šaǉem',
  'šaǉeš',
  'šalji',
  'šaǉiv',
  'šalju',
  'salom',
  'šalom',
  'salon',
  'salpa',
  'salpe',
  'salpi',
  'salpu',
  'salsa',
  'salse',
  'salsu',
  'salta',
  'salto',
  'salva',
  'salve',
  'salvi',
  'salvo',
  'salvu',
  'samac',
  'šamac',
  'šaman',
  'samar',
  'šamar',
  'samba',
  'sambe',
  'sambo',
  'sambu',
  'samca',
  'samce',
  'samče',
  'samci',
  'samcu',
  'samih',
  'samim',
  'samir',
  'samit',
  'samog',
  'samoj',
  'samom',
  'šamot',
  'samta',
  'samur',
  'šanac',
  'sanak',
  'šanca',
  'sanče',
  'šance',
  'sanci',
  'šancu',
  'sanda',
  'sanja',
  'saǌah',
  'saǌaj',
  'saǌam',
  'saǌan',
  'saǌao',
  'saǌar',
  'saǌaš',
  'sanje',
  'saǌem',
  'sanji',
  'saǌin',
  'saǌiv',
  'sanjo',
  'saǌom',
  'sanju',
  'sanka',
  'šanka',
  'sanke',
  'sanku',
  'šanku',
  'šansa',
  'šanse',
  'šansi',
  'šansu',
  'santa',
  'sante',
  'santi',
  'santo',
  'santu',
  'šapat',
  'šapca',
  'šapće',
  'šapcu',
  'sapet',
  'šapke',
  'sapne',
  'šapne',
  'sapni',
  'sapnu',
  'šapnu',
  'sapom',
  'šapom',
  'sapun',
  'sarač',
  'šarac',
  'šaraf',
  'sarah',
  'saraj',
  'šaram',
  'šaran',
  'šarca',
  'šarce',
  'šarci',
  'šaren',
  'šarić',
  'sarin',
  'šarka',
  'šarke',
  'šarki',
  'šarko',
  'šarku',
  'šarla',
  'sarma',
  'šarma',
  'sarme',
  'šarmu',
  'sarom',
  'šarom',
  'šarov',
  'šarun',
  'šarži',
  'šašav',
  'sasha',
  'sašio',
  'saska',
  'saske',
  'saski',
  'sasko',
  'sasku',
  'saspe',
  'saspi',
  'saspu',
  'sasuh',
  'satan',
  'saten',
  'satir',
  'satka',
  'šatla',
  'šatlu',
  'satna',
  'satne',
  'satni',
  'satno',
  'satnu',
  'satom',
  'šator',
  'satra',
  'šatra',
  'satre',
  'šatre',
  'satru',
  'sauna',
  'saune',
  'sauni',
  'saunu',
  'savet',
  'savez',
  'savić',
  'savin',
  'savio',
  'savka',
  'savom',
  'šavom',
  'sazda',
  'sažeo',
  'sažet',
  'saziv',
  'sažme',
  'sažmu',
  'sazna',
  'sazre',
  'sazri',
  'sazru',
  'sazva',
  'scena',
  'scene',
  'sceni',
  'scenu',
  'seana',
  'šeboj',
  'sebra',
  'sebri',
  'sebru',
  'sećam',
  'sečaǌ',
  'šećem',
  'šećer',
  'šećeš',
  'sedam',
  'sedan',
  'sedef',
  'sedeo',
  'sedim',
  'sedla',
  'sedlo',
  'sedlu',
  'sedma',
  'sedme',
  'sedmi',
  'sedmo',
  'sedmu',
  'sedne',
  'sedra',
  'sedre',
  'sedri',
  'sedru',
  'seǆda',
  'šefik',
  'šefom',
  'segni',
  'šegom',
  'šeher',
  'šehov',
  'šeici',
  'šeika',
  'šeiku',
  'sejom',
  'šekel',
  'sekom',
  'seksa',
  'seksi',
  'seksu',
  'sekta',
  'sekte',
  'sekti',
  'sektu',
  'selam',
  'selca',
  'selce',
  'selci',
  'selcu',
  'selen',
  'selim',
  'selio',
  'selit',
  'seǉak',
  'selma',
  'selom',
  'semit',
  'šemom',
  'senad',
  'senat',
  'senci',
  'senfa',
  'senfu',
  'senja',
  'senka',
  'senke',
  'senki',
  'senom',
  'senta',
  'sente',
  'seoba',
  'seobe',
  'seobi',
  'seobu',
  'seoca',
  'seoce',
  'šepao',
  'šepav',
  'šeper',
  'sepet',
  'sepsa',
  'sepse',
  'sepsi',
  'sepsu',
  'šerbe',
  'serem',
  'šeret',
  'serge',
  'šerif',
  'serpa',
  'šerpa',
  'šerpe',
  'šerpi',
  'šerpo',
  'šerpu',
  'serum',
  'serva',
  'servo',
  'servu',
  'šešeǉ',
  'šešir',
  'šesta',
  'šeste',
  'sesti',
  'šesti',
  'šesto',
  'šestu',
  'šetač',
  'šetaj',
  'šetao',
  'seter',
  'setim',
  'šetka',
  'setǌa',
  'šetǌa',
  'šetǌe',
  'šetǌi',
  'šetǌu',
  'setom',
  'seulu',
  'sevab',
  'sevap',
  'ševar',
  'sevda',
  'seven',
  'sever',
  'ševiš',
  'sezam',
  'sezan',
  'sezao',
  'sežem',
  'sfera',
  'sfere',
  'sferi',
  'sferu',
  'shake',
  'shane',
  'shang',
  'sharp',
  'shema',
  'sheme',
  'shemi',
  'shemu',
  'shore',
  'short',
  'šibaj',
  'šiban',
  'šibao',
  'šiber',
  'sibir',
  'šibǉa',
  'šibǉe',
  'šibǉu',
  'šibne',
  'šibom',
  'šićar',
  'siđem',
  'sidom',
  'sidra',
  'sidre',
  'sidri',
  'sidro',
  'sidru',
  'sifon',
  'šifra',
  'šifre',
  'šifri',
  'šifru',
  'sigma',
  'sigom',
  'sijač',
  'sijam',
  'sijan',
  'sijao',
  'sijat',
  'sijed',
  'sijem',
  'sijev',
  'sikću',
  'silan',
  'silaz',
  'silim',
  'silio',
  'silit',
  'šiǉak',
  'šiǉat',
  'šiǉci',
  'šiǉka',
  'šiǉke',
  'šiǉku',
  'silna',
  'silne',
  'silni',
  'silno',
  'silnu',
  'silom',
  'silos',
  'šilte',
  'silva',
  'simić',
  'šimić',
  'simon',
  'sinan',
  'sinci',
  'sinem',
  'sinja',
  'šinja',
  'sinje',
  'siǌeg',
  'siǌem',
  'sinji',
  'sinju',
  'sinko',
  'sinku',
  'sinoć',
  'sinod',
  'sinom',
  'šinom',
  'sinov',
  'sinuh',
  'sinus',
  'sinut',
  'sipaj',
  'šipak',
  'sipam',
  'sipan',
  'sipao',
  'šipče',
  'siper',
  'sipin',
  'sipka',
  'šipka',
  'sipke',
  'šipke',
  'sipki',
  'šipki',
  'sipko',
  'sipku',
  'šipku',
  'sipom',
  'sirac',
  'sirač',
  'sirah',
  'sirak',
  'sirca',
  'sirce',
  'sirće',
  'sirče',
  'sirci',
  'sircu',
  'šireg',
  'širem',
  'širih',
  'širim',
  'sirio',
  'širio',
  'širit',
  'sirka',
  'sirke',
  'sirku',
  'široj',
  'širok',
  'sirom',
  'širom',
  'sirot',
  'sirov',
  'sirup',
  'sisak',
  'sisam',
  'šišan',
  'sisao',
  'sišao',
  'sisar',
  'šišić',
  'siska',
  'šiška',
  'siske',
  'šiške',
  'šiški',
  'šiško',
  'sisku',
  'sišla',
  'sišle',
  'sišli',
  'sišlo',
  'sisom',
  'šište',
  'šišti',
  'sitan',
  'sitar',
  'sites',
  'sitih',
  'sitim',
  'sitna',
  'sitne',
  'sitni',
  'sitno',
  'sitnu',
  'sitog',
  'sivac',
  'šivan',
  'sivca',
  'sivci',
  'sivcu',
  'sivih',
  'sivim',
  'sivog',
  'sivoj',
  'sivom',
  'sižea',
  'sižeu',
  'šizma',
  'sjaha',
  'sjaja',
  'sjaje',
  'sjaji',
  'sjaju',
  'sjala',
  'sjalo',
  'sjati',
  'sjeća',
  'sječa',
  'sječe',
  'sjeći',
  'sječi',
  'sječu',
  'sjeda',
  'sjede',
  'sjedi',
  'sjela',
  'sjele',
  'sjeli',
  'sjelo',
  'sjeme',
  'sjena',
  'sjene',
  'sjeni',
  'sjeno',
  'sjenu',
  'sjest',
  'sjeta',
  'sjete',
  'sjeti',
  'sjetu',
  'skače',
  'skaču',
  'škafa',
  'skala',
  'skale',
  'skali',
  'skalo',
  'skalp',
  'skalu',
  'skamp',
  'škamp',
  'skapa',
  'škara',
  'škare',
  'škart',
  'skaut',
  'skeča',
  'skeču',
  'skela',
  'skele',
  'skeli',
  'skelu',
  'skica',
  'skice',
  'skici',
  'skicu',
  'skida',
  'skide',
  'skifu',
  'skija',
  'škija',
  'skije',
  'skiji',
  'skiju',
  'škiǉe',
  'skine',
  'skini',
  'skinu',
  'skita',
  'skiti',
  'skoba',
  'skobe',
  'skoče',
  'skoči',
  'škoda',
  'škode',
  'škodi',
  'škodu',
  'skoka',
  'skoku',
  'skola',
  'škola',
  'škole',
  'školi',
  'školj',
  'škoǉa',
  'škoǉu',
  'školu',
  'skora',
  'skore',
  'skori',
  'skoro',
  'skoru',
  'skota',
  'skote',
  'skova',
  'škrip',
  'škrob',
  'skuca',
  'škuda',
  'skuha',
  'skuje',
  'skuju',
  'škuna',
  'škune',
  'škuni',
  'skupa',
  'skupe',
  'skupi',
  'skupo',
  'skupu',
  'skuša',
  'skuše',
  'skuta',
  'skute',
  'skuti',
  'skutu',
  'škver',
  'slaba',
  'slabe',
  'slabi',
  'slabo',
  'slabu',
  'slaću',
  'slada',
  'slađa',
  'slade',
  'slađe',
  'sladi',
  'slađi',
  'sladu',
  'šlaga',
  'slajd',
  'slala',
  'slale',
  'slali',
  'slalo',
  'slama',
  'slame',
  'slami',
  'slamo',
  'slamu',
  'slana',
  'slane',
  'slani',
  'slaǌa',
  'slaǌe',
  'slaǌu',
  'slano',
  'slanu',
  'slapa',
  'slape',
  'šlape',
  'slapu',
  'slast',
  'slati',
  'šlauf',
  'slava',
  'slave',
  'slavi',
  'slavo',
  'slavu',
  'slaže',
  'slaži',
  'slažu',
  'slede',
  'sledi',
  'sleng',
  'slepe',
  'slepi',
  'slete',
  'sleti',
  'sliče',
  'slici',
  'sliči',
  'slije',
  'sliju',
  'slika',
  'slike',
  'sliko',
  'sliku',
  'slila',
  'slili',
  'slilo',
  'slina',
  'sline',
  'slini',
  'sliti',
  'sliva',
  'slivu',
  'šǉaci',
  'šǉaka',
  'šǉake',
  'šǉaku',
  'šljam',
  'šǉama',
  'šljem',
  'šǉema',
  'sǉeme',
  'šǉeme',
  'šǉemu',
  'sǉeza',
  'šǉiva',
  'šǉive',
  'šǉivo',
  'šǉuka',
  'sloan',
  'sloga',
  'sloge',
  'slogo',
  'slogu',
  'sloja',
  'sloju',
  'sloma',
  'slome',
  'slomi',
  'slomu',
  'slona',
  'slone',
  'slonu',
  'slova',
  'slove',
  'slovi',
  'slovo',
  'slovu',
  'slože',
  'slozi',
  'složi',
  'sluče',
  'sluga',
  'sluge',
  'slugi',
  'slugu',
  'sluha',
  'sluhu',
  'slunj',
  'sluǌa',
  'sluša',
  'sluti',
  'služe',
  'sluzi',
  'služi',
  'smaći',
  'smail',
  'smaka',
  'smaku',
  'smaǌe',
  'smaǌi',
  'smart',
  'smeća',
  'smeča',
  'smece',
  'smeće',
  'smeću',
  'smeđa',
  'smeđe',
  'smeđi',
  'smeđu',
  'smeju',
  'smela',
  'smele',
  'smeli',
  'smemo',
  'smena',
  'smene',
  'smeni',
  'smenu',
  'smera',
  'smeru',
  'smeša',
  'smeše',
  'smest',
  'smešu',
  'smeta',
  'smete',
  'smeti',
  'smetu',
  'smije',
  'smiju',
  'smili',
  'smiǉa',
  'smiǉe',
  'smion',
  'smire',
  'smiri',
  'smita',
  'smith',
  'smoci',
  'smoći',
  'smoga',
  'smogu',
  'smoka',
  'smoki',
  'smoku',
  'smola',
  'smole',
  'smoli',
  'smolu',
  'smota',
  'smoto',
  'smože',
  'smuka',
  'smuku',
  'smuǉa',
  'smuti',
  'snaći',
  'snađe',
  'snađi',
  'snađu',
  'snaga',
  'snage',
  'snago',
  'snagu',
  'snaha',
  'snahe',
  'snahi',
  'snahu',
  'snake',
  'šnala',
  'šnale',
  'snape',
  'snaša',
  'snazi',
  'snaži',
  'snega',
  'snegu',
  'snena',
  'snese',
  'snesi',
  'snesu',
  'snima',
  'snime',
  'snimi',
  'šnita',
  'šnite',
  'šnitu',
  'snizi',
  'snopa',
  'snopu',
  'snose',
  'snosi',
  'snova',
  'snove',
  'snovi',
  'snubi',
  'snuje',
  'snuju',
  'sobar',
  'sobna',
  'sobne',
  'sobni',
  'sobno',
  'sobnu',
  'sobom',
  'sobov',
  'sočan',
  'socio',
  'sočna',
  'sočne',
  'sočni',
  'sočno',
  'sočnu',
  'sodar',
  'sodin',
  'sodom',
  'šofer',
  'sofia',
  'sofom',
  'sofra',
  'sofru',
  'šogor',
  'šogun',
  'sojem',
  'sojin',
  'šojka',
  'šojke',
  'sojom',
  'sojuz',
  'sokak',
  'sokić',
  'sokna',
  'sokni',
  'soknu',
  'sokol',
  'sokom',
  'šokom',
  'solar',
  'solid',
  'solin',
  'solio',
  'solit',
  'šolja',
  'šolje',
  'soǉen',
  'šolji',
  'solju',
  'šolju',
  'solna',
  'solne',
  'solni',
  'solno',
  'solnu',
  'solun',
  'somić',
  'somom',
  'somot',
  'somov',
  'somun',
  'sonar',
  'sonda',
  'sonde',
  'sondi',
  'sondu',
  'sonet',
  'songa',
  'songu',
  'sonia',
  'sonja',
  'sopot',
  'šorom',
  'sorta',
  'sorte',
  'sorti',
  'sortu',
  'sošna',
  'sošno',
  'sosom',
  'sound',
  'south',
  'sovom',
  'space',
  'spada',
  'špade',
  'špaga',
  'špago',
  'špagu',
  'spaja',
  'špajz',
  'spala',
  'spale',
  'spali',
  'spalo',
  'spalu',
  'spari',
  'spasa',
  'spase',
  'spasi',
  'spasu',
  'spava',
  'spaze',
  'spazi',
  'speci',
  'speći',
  'spejs',
  'spens',
  'spere',
  'speru',
  'spica',
  'špica',
  'spice',
  'špice',
  'špici',
  'špicu',
  'špigl',
  'spike',
  'špila',
  'spiǉa',
  'špiǉa',
  'spiǉe',
  'špiǉe',
  'spiǉi',
  'špiǉi',
  'špiǉu',
  'špilu',
  'spina',
  'spinu',
  'spira',
  'spisa',
  'spise',
  'spisi',
  'spisu',
  'spock',
  'spoja',
  'spoje',
  'spoji',
  'spoju',
  'spola',
  'spole',
  'spoǉa',
  'spolu',
  'spona',
  'spone',
  'sponi',
  'spono',
  'sponu',
  'spora',
  'spore',
  'spori',
  'sporo',
  'sport',
  'šport',
  'sporu',
  'spota',
  'spotu',
  'spust',
  'sputa',
  'srama',
  'srame',
  'srami',
  'sramu',
  'srane',
  'sraǌa',
  'sraǌe',
  'sranu',
  'srati',
  'sraza',
  'sraze',
  'srazu',
  'srčan',
  'srčem',
  'srđan',
  'srǆba',
  'srǆbe',
  'srǆbi',
  'srǆbu',
  'sreca',
  'sreća',
  'sreće',
  'sreći',
  'srećo',
  'sreću',
  'sreda',
  'srede',
  'sredi',
  'srela',
  'srele',
  'sreli',
  'srema',
  'sremu',
  'srest',
  'sreta',
  'srete',
  'sreza',
  'sreže',
  'srezu',
  'srǉao',
  'srǌak',
  'srodi',
  'sroka',
  'sroku',
  'sroza',
  'sruče',
  'sruše',
  'sruši',
  'štaba',
  'štabu',
  'stada',
  'stade',
  'stado',
  'stadu',
  'stage',
  'staja',
  'staje',
  'staji',
  'stajo',
  'staju',
  'štaka',
  'štake',
  'stala',
  'štala',
  'stale',
  'štale',
  'stali',
  'štali',
  'stalo',
  'štalu',
  'stana',
  'stand',
  'štand',
  'stane',
  'stani',
  'staǌa',
  'staǌe',
  'staǌi',
  'staǌu',
  'stanu',
  'stapa',
  'štapa',
  'štapu',
  'stara',
  'stare',
  'stari',
  'stark',
  'staro',
  'stars',
  'start',
  'staru',
  'stasa',
  'stasu',
  'state',
  'stati',
  'stava',
  'stave',
  'stavi',
  'stavu',
  'staza',
  'staža',
  'staze',
  'stazi',
  'stazu',
  'stažu',
  'steče',
  'steci',
  'steći',
  'štede',
  'štedi',
  'stega',
  'stege',
  'stego',
  'stegu',
  'stein',
  'stejt',
  'šteka',
  'steku',
  'stela',
  'stele',
  'steli',
  'steǉa',
  'steǉe',
  'steǉi',
  'steǉu',
  'stelu',
  'stena',
  'stene',
  'štene',
  'steni',
  'steǌe',
  'steǌu',
  'stenu',
  'steon',
  'stepa',
  'stepe',
  'stepi',
  'stepu',
  'stera',
  'stere',
  'steri',
  'stern',
  'steru',
  'šteta',
  'štete',
  'šteti',
  'štetu',
  'steve',
  'stevo',
  'steže',
  'stezi',
  'stežu',
  'stiče',
  'stići',
  'stick',
  'stiču',
  'stida',
  'stide',
  'stidi',
  'štift',
  'stiha',
  'štiha',
  'stihu',
  'štihu',
  'stika',
  'stila',
  'stile',
  'stilu',
  'štima',
  'stine',
  'stini',
  'stinu',
  'štipa',
  'stipe',
  'stiša',
  'štita',
  'štite',
  'štiti',
  'štitu',
  'štiva',
  'štivo',
  'stiže',
  'stiži',
  'stižu',
  'stoca',
  'stoci',
  'stoga',
  'stogu',
  'stoik',
  'stoja',
  'stoje',
  'stoji',
  'stoka',
  'štoka',
  'stoke',
  'stoko',
  'stoku',
  'stola',
  'stole',
  'stolu',
  'stoma',
  'stona',
  'stone',
  'stoni',
  'stono',
  'stonu',
  'stopa',
  'štopa',
  'stope',
  'stopi',
  'stopu',
  'stora',
  'store',
  'storm',
  'štose',
  'štosu',
  'stota',
  'stote',
  'stoti',
  'stotu',
  'štrče',
  'štrči',
  'štrik',
  'stuba',
  'stube',
  'stubi',
  'stubo',
  'stubu',
  'štuje',
  'štuju',
  'štuka',
  'štuke',
  'štuki',
  'štuko',
  'štuku',
  'štula',
  'stupa',
  'stupe',
  'stupi',
  'stupu',
  'štura',
  'šture',
  'šturi',
  'šturo',
  'šturu',
  'sucem',
  'sučem',
  'sucre',
  'sućut',
  'sudac',
  'sudan',
  'sudar',
  'sudba',
  'sudbe',
  'sudbi',
  'sudbo',
  'sudbu',
  'suđen',
  'sudim',
  'sudio',
  'sudiš',
  'sudit',
  'sudǌi',
  'sudom',
  'suǆuk',
  'sugar',
  'šugav',
  'suhih',
  'suhim',
  'suhǉa',
  'suhǉe',
  'suhǉi',
  'suhog',
  'suhoj',
  'suhom',
  'suite',
  'sukao',
  'šuker',
  'sukna',
  'sukǌa',
  'sukǌe',
  'sukǌi',
  'sukǌu',
  'sukno',
  'sukob',
  'sukun',
  'sukus',
  'šulja',
  'sulud',
  'šuman',
  'šumar',
  'šumiš',
  'šumke',
  'sumǌa',
  'sumǌe',
  'sumǌi',
  'sumǌu',
  'šumno',
  'sumom',
  'šumom',
  'sunca',
  'sunča',
  'sunce',
  'suncu',
  'šunda',
  'šundu',
  'sunet',
  'sunit',
  'šunka',
  'šunke',
  'šunki',
  'šunku',
  'suoče',
  'suoči',
  'šupak',
  'šupaǉ',
  'super',
  'supka',
  'supke',
  'supki',
  'šupǉa',
  'šupǉe',
  'šupǉi',
  'šupǉu',
  'supom',
  'surci',
  'surfa',
  'surih',
  'surim',
  'surka',
  'surke',
  'surki',
  'surku',
  'surla',
  'surle',
  'surli',
  'surlu',
  'surma',
  'surog',
  'suroj',
  'surom',
  'surov',
  'surva',
  'sušac',
  'susan',
  'sušan',
  'sušaǌ',
  'šušaǌ',
  'sušci',
  'sušcu',
  'sused',
  'sušen',
  'susie',
  'sušim',
  'sušio',
  'šuška',
  'šuško',
  'šušku',
  'sušna',
  'sušne',
  'sušni',
  'sušǌi',
  'šušǌi',
  'sušno',
  'sušnu',
  'sušoj',
  'sušom',
  'sušta',
  'sušte',
  'šušte',
  'sušti',
  'šušti',
  'sušto',
  'suštu',
  'sutin',
  'šutke',
  'šutǌa',
  'šutǌe',
  'šutǌi',
  'šutǌu',
  'šutnu',
  'šutom',
  'suton',
  'sutra',
  'sutre',
  'sutri',
  'sutro',
  'sutru',
  'suvag',
  'suvim',
  'suvǉa',
  'suvǉi',
  'suvǉu',
  'suvog',
  'suvoj',
  'suvom',
  'suzan',
  'sužaǌ',
  'sužen',
  'suzio',
  'suzna',
  'suzne',
  'suzni',
  'sužǌa',
  'sužǌe',
  'sužǌi',
  'sužǌu',
  'suzno',
  'suznu',
  'suzom',
  'švaba',
  'švabe',
  'svađa',
  'svađe',
  'svadi',
  'svađi',
  'svađu',
  'svaka',
  'svake',
  'svaki',
  'svako',
  'svaku',
  'svale',
  'svali',
  'švaǉa',
  'švaǉe',
  'svane',
  'svani',
  'svanu',
  'švarc',
  'svare',
  'svari',
  'svast',
  'svata',
  'svati',
  'sveca',
  'svece',
  'sveci',
  'svecu',
  'svede',
  'svedi',
  'svedu',
  'svega',
  'svela',
  'svele',
  'sveli',
  'šveǉe',
  'svelo',
  'svemu',
  'svenu',
  'šverc',
  'svest',
  'sveta',
  'svete',
  'sveti',
  'sveto',
  'svetu',
  'sveza',
  'sveze',
  'sveže',
  'svezi',
  'sveži',
  'svezo',
  'svezu',
  'svežu',
  'sviće',
  'svici',
  'sviću',
  'sviđa',
  'svide',
  'svidi',
  'svija',
  'svije',
  'sviju',
  'svila',
  'svile',
  'svili',
  'svilu',
  'svima',
  'svime',
  'svine',
  'sviǌa',
  'sviǌe',
  'sviǌi',
  'sviǌu',
  'svinu',
  'svira',
  'sviše',
  'svita',
  'svite',
  'sviti',
  'svitu',
  'svoda',
  'svode',
  'svodi',
  'svodu',
  'svoga',
  'svoja',
  'svoje',
  'svoji',
  'svojo',
  'svoju',
  'svome',
  'svomu',
  'svota',
  'svote',
  'svotu',
  'svuče',
  'svuci',
  'svući',
  'svuda',
  'svuku',
  'tabah',
  'tabak',
  'taban',
  'tabla',
  'table',
  'tabli',
  'tablo',
  'tablu',
  'tabor',
  'tabua',
  'tabue',
  'tabui',
  'tabut',
  'tačan',
  'tačka',
  'tačke',
  'tački',
  'tačku',
  'tacna',
  'tačna',
  'tacne',
  'tačne',
  'tacni',
  'tačni',
  'tacno',
  'tačno',
  'tacnu',
  'tačnu',
  'tacom',
  'tadić',
  'tafta',
  'taftu',
  'tajac',
  'tajan',
  'tajga',
  'tajge',
  'tajgi',
  'tajgu',
  'tajim',
  'tajio',
  'tajna',
  'tajne',
  'tajni',
  'tajno',
  'tajnu',
  'takao',
  'takav',
  'takes',
  'takla',
  'takli',
  'taklo',
  'takne',
  'takni',
  'taknu',
  'takom',
  'taksa',
  'takse',
  'taksi',
  'takso',
  'taksu',
  'takta',
  'taktu',
  'takva',
  'takve',
  'takvi',
  'takvo',
  'takvu',
  'talac',
  'talar',
  'talas',
  'talij',
  'talim',
  'talio',
  'talir',
  'tališ',
  'taǉen',
  'talog',
  'talon',
  'taman',
  'tamna',
  'tamne',
  'tamni',
  'tamno',
  'tamnu',
  'tamom',
  'tanac',
  'tanad',
  'tanak',
  'tanan',
  'tanca',
  'tance',
  'tanga',
  'tange',
  'tangi',
  'tango',
  'tangu',
  'tanin',
  'tanja',
  'tanje',
  'taǌeg',
  'taǌem',
  'tanji',
  'taǌih',
  'taǌim',
  'taǌir',
  'tanjo',
  'taǌom',
  'tanju',
  'taǌur',
  'tanka',
  'tanke',
  'tanki',
  'tanko',
  'tanku',
  'taoca',
  'taoce',
  'taoci',
  'taocu',
  'tapir',
  'tapka',
  'tapše',
  'tapšu',
  'tarac',
  'taras',
  'tarem',
  'tarik',
  'tarno',
  'tarok',
  'tarom',
  'tarot',
  'tasić',
  'tašna',
  'tašne',
  'tašni',
  'tašnu',
  'tasom',
  'tasta',
  'tašta',
  'tašte',
  'tašti',
  'tatić',
  'tatin',
  'tatom',
  'tavan',
  'tavla',
  'tavom',
  'tečaj',
  'tečan',
  'tečem',
  'tečna',
  'tečne',
  'tečni',
  'tečno',
  'tečnu',
  'teget',
  'tegla',
  'tegle',
  'tegli',
  'teglu',
  'tegom',
  'tehno',
  'tekao',
  'tekla',
  'tekle',
  'tekli',
  'teklo',
  'tekma',
  'telac',
  'telad',
  'telal',
  'telče',
  'telom',
  'telur',
  'temeǉ',
  'temom',
  'tempa',
  'tempo',
  'tempu',
  'tenda',
  'tendo',
  'tenis',
  'tenka',
  'tenku',
  'tenom',
  'tenor',
  'tepen',
  'tepih',
  'terao',
  'terca',
  'terce',
  'terci',
  'tercu',
  'teren',
  'teret',
  'terme',
  'termi',
  'termo',
  'teror',
  'tesač',
  'tesan',
  'tesar',
  'teška',
  'teške',
  'teški',
  'tesko',
  'teško',
  'tešku',
  'tesla',
  'tesle',
  'tesli',
  'teslu',
  'tesna',
  'tesno',
  'testa',
  'teste',
  'testo',
  'testu',
  'tetak',
  'tetin',
  'tetka',
  'tetke',
  'tetki',
  'tetku',
  'tetom',
  'težak',
  'težeg',
  'težem',
  'tezga',
  'tezge',
  'tezgi',
  'tezgu',
  'težih',
  'težim',
  'težio',
  'težiš',
  'težit',
  'težǌa',
  'težǌe',
  'težǌi',
  'težǌu',
  'težoj',
  'tezom',
  'težom',
  'their',
  'there',
  'these',
  'theta',
  'thing',
  'think',
  'thora',
  'thore',
  'thori',
  'tibet',
  'tibor',
  'tican',
  'ticao',
  'tičem',
  'tifus',
  'tigaǌ',
  'tigar',
  'tiger',
  'tigra',
  'tigre',
  'tigri',
  'tigru',
  'tihan',
  'tihih',
  'tihim',
  'tihog',
  'tihoj',
  'tihom',
  'tijek',
  'tikaj',
  'tiket',
  'tikom',
  'tikva',
  'tikve',
  'tikvi',
  'tikvu',
  'tilda',
  'tilde',
  'tildi',
  'tildo',
  'tildu',
  'timar',
  'times',
  'timin',
  'timok',
  'timom',
  'tinel',
  'tinja',
  'tiǌac',
  'tiǌan',
  'tiǌao',
  'tiǌca',
  'tinta',
  'tinte',
  'tinti',
  'tinto',
  'tintu',
  'tipka',
  'tipke',
  'tipki',
  'tipku',
  'tipom',
  'tiraž',
  'tirol',
  'tisak',
  'tišeg',
  'tiših',
  'tišim',
  'tiska',
  'tisku',
  'tišma',
  'tisni',
  'tisnu',
  'tisom',
  'tišti',
  'titan',
  'titel',
  'titla',
  'title',
  'titlu',
  'titom',
  'titov',
  'titra',
  'titus',
  'tivat',
  'tjeme',
  'tjera',
  'tješi',
  'tkača',
  'tkači',
  'tkaju',
  'tkale',
  'tkali',
  'tkaǉa',
  'tkana',
  'tkane',
  'tkani',
  'tkaǌa',
  'tkaǌe',
  'tkaǌu',
  'tkati',
  'tkiva',
  'tkivo',
  'tkivu',
  'tlače',
  'tlači',
  'tlaka',
  'tlake',
  'tlaku',
  'tlima',
  'tmica',
  'tmice',
  'tmici',
  'tmicu',
  'tmina',
  'tmine',
  'tmini',
  'tobom',
  'tocak',
  'točak',
  'točan',
  'točci',
  'točio',
  'točka',
  'točke',
  'točki',
  'točku',
  'točna',
  'točne',
  'točni',
  'točno',
  'točnu',
  'todor',
  'togom',
  'tokar',
  'token',
  'tokio',
  'tokom',
  'tolik',
  'tomas',
  'tomaš',
  'tomić',
  'tomom',
  'tonem',
  'toner',
  'tonik',
  'tonom',
  'tonuo',
  'tonus',
  'topao',
  'topaz',
  'topić',
  'topim',
  'topio',
  'topit',
  'topiv',
  'topla',
  'tople',
  'topli',
  'toplo',
  'toplu',
  'topom',
  'topot',
  'topuz',
  'toraǌ',
  'torba',
  'torbe',
  'torbi',
  'torbu',
  'torij',
  'torǌa',
  'torǌu',
  'torom',
  'torso',
  'torta',
  'torte',
  'torti',
  'torto',
  'tortu',
  'torus',
  'torza',
  'torzo',
  'torzu',
  'tošić',
  'tosta',
  'toste',
  'tostu',
  'total',
  'totem',
  'tours',
  'tovar',
  'tovim',
  'tovit',
  'tovna',
  'tovne',
  'tovni',
  'tovno',
  'tovnu',
  'trača',
  'trace',
  'traće',
  'traci',
  'traći',
  'trade',
  'trafo',
  'traga',
  'tragu',
  'trail',
  'train',
  'traje',
  'traju',
  'traka',
  'trake',
  'trako',
  'trakt',
  'traku',
  'tramp',
  'trans',
  'trapa',
  'trape',
  'trapi',
  'trapu',
  'trasa',
  'trase',
  'trasi',
  'trasu',
  'trate',
  'trati',
  'trava',
  'trave',
  'travi',
  'travu',
  'traže',
  'traži',
  'trčao',
  'trčat',
  'trčim',
  'trčka',
  'trčke',
  'treba',
  'treća',
  'trece',
  'treće',
  'treći',
  'trećo',
  'treću',
  'trema',
  'treme',
  'tremu',
  'trena',
  'trend',
  'trene',
  'treni',
  'treǌa',
  'treǌe',
  'treǌu',
  'trent',
  'trenu',
  'trese',
  'tresi',
  'trest',
  'tresu',
  'trica',
  'trice',
  'trick',
  'tricu',
  'trija',
  'triju',
  'trika',
  'triko',
  'triku',
  'trima',
  'trina',
  'triom',
  'tripa',
  'tripe',
  'trǉam',
  'trǉao',
  'trǌak',
  'trǌem',
  'troga',
  'troja',
  'troje',
  'troji',
  'troju',
  'trola',
  'trole',
  'trome',
  'tromi',
  'tromo',
  'trona',
  'trone',
  'tronu',
  'tropa',
  'trope',
  'tropi',
  'troše',
  'troši',
  'truba',
  'trube',
  'trubi',
  'trubu',
  'truda',
  'trude',
  'trudi',
  'trudu',
  'truje',
  'truju',
  'trula',
  'trulo',
  'trump',
  'trune',
  'truni',
  'trunu',
  'trupa',
  'trupe',
  'trupi',
  'trupu',
  'trusi',
  'trust',
  'truta',
  'tržna',
  'tržne',
  'tržni',
  'tržno',
  'tubom',
  'tubus',
  'tučak',
  'tucao',
  'tucat',
  'tučem',
  'tučen',
  'tučeš',
  'tucet',
  'tučka',
  'tučke',
  'tučku',
  'tučom',
  'tuđeg',
  'tuđem',
  'tuđih',
  'tuđim',
  'tuđin',
  'tuđoj',
  'tuđom',
  'tugom',
  'tuguj',
  'tukac',
  'tukan',
  'tukao',
  'tukla',
  'tukli',
  'tuklo',
  'tukom',
  'tulac',
  'tulij',
  'tulio',
  'tuǉac',
  'tuǉan',
  'tuǉcu',
  'tulum',
  'tumač',
  'tumba',
  'tumor',
  'tumul',
  'tunel',
  'tunis',
  'tunja',
  'tunji',
  'tunjo',
  'tunju',
  'tunom',
  'tupan',
  'tupih',
  'tupim',
  'tupǉi',
  'tupog',
  'tupom',
  'turam',
  'turan',
  'turbe',
  'turbo',
  'turci',
  'turim',
  'turke',
  'turni',
  'turnu',
  'turom',
  'turov',
  'tušaǌ',
  'tušem',
  'tusta',
  'tusti',
  'tustu',
  'tutaǌ',
  'tutin',
  'tutǌe',
  'tutor',
  'tužan',
  'tužba',
  'tužbe',
  'tužbi',
  'tužbu',
  'tužen',
  'tužim',
  'tužio',
  'tuzla',
  'tuzle',
  'tuzli',
  'tuzlu',
  'tužna',
  'tužne',
  'tužni',
  'tužno',
  'tužnu',
  'tvari',
  'tvoga',
  'tvoja',
  'tvoje',
  'tvoji',
  'tvojo',
  'tvoju',
  'tvome',
  'tvomu',
  'tvora',
  'tvore',
  'tvori',
  'ubace',
  'ubaci',
  'ubada',
  'ubava',
  'ubere',
  'uberi',
  'uberu',
  'ubica',
  'ubice',
  'ubiće',
  'ubici',
  'ubicu',
  'ubija',
  'ubije',
  'ubiju',
  'ubila',
  'ubile',
  'ubili',
  'ubilo',
  'ubire',
  'ubiri',
  'ubiru',
  'ubiše',
  'ubiti',
  'uboda',
  'ubode',
  'ubodi',
  'ubodu',
  'uboga',
  'ubogi',
  'ubogu',
  'uboje',
  'ubola',
  'uboli',
  'ubolo',
  'ubost',
  'ubrah',
  'ubran',
  'ubrao',
  'ubrus',
  'učeći',
  'učena',
  'ucene',
  'učene',
  'učeni',
  'učeǌa',
  'učeǌe',
  'učeǌu',
  'učeno',
  'učila',
  'učile',
  'učili',
  'učilo',
  'učimo',
  'učine',
  'učini',
  'učita',
  'učite',
  'učiti',
  'učtiv',
  'udade',
  'udaha',
  'udahu',
  'udaja',
  'udaje',
  'udaji',
  'udaju',
  'udala',
  'udale',
  'udali',
  'udalj',
  'udaǉe',
  'udaǉi',
  'udana',
  'udane',
  'udani',
  'udanu',
  'udara',
  'udare',
  'udari',
  'udaru',
  'udasi',
  'udata',
  'udate',
  'udati',
  'udatu',
  'udave',
  'udavi',
  'uđemo',
  'udesa',
  'udese',
  'udesi',
  'udesu',
  'uđete',
  'udica',
  'udice',
  'udici',
  'udicu',
  'uđimo',
  'udiše',
  'udišu',
  'uđite',
  'udivi',
  'udjel',
  'udjeo',
  'udome',
  'udomi',
  'uđoše',
  'udova',
  'udove',
  'udovi',
  'udovo',
  'udovu',
  'udube',
  'udubi',
  'ufaju',
  'ufalo',
  'ufati',
  'ugalj',
  'ugaǉa',
  'ugane',
  'ugani',
  'uganu',
  'ugara',
  'ugare',
  'ugari',
  'ugase',
  'ugasi',
  'ugazi',
  'ugiba',
  'ugine',
  'uginu',
  'uglas',
  'uglat',
  'ugled',
  'ugǉar',
  'ugǉem',
  'ugǉen',
  'ugǉik',
  'uglom',
  'ugnaj',
  'ugnem',
  'ugoda',
  'ugode',
  'ugodi',
  'ugodu',
  'ugoji',
  'ugora',
  'ugori',
  'ugrij',
  'ugriz',
  'ugura',
  'uguše',
  'uguši',
  'uhiti',
  'uhǉup',
  'uhoda',
  'uhode',
  'uhodi',
  'ujače',
  'ujaci',
  'ujaka',
  'ujake',
  'ujaku',
  'ujeda',
  'ujede',
  'ujedi',
  'ujedu',
  'ujela',
  'ujeli',
  'ujelo',
  'ujina',
  'ujini',
  'ujinu',
  'ujnom',
  'ukaǉa',
  'ukapa',
  'ukaza',
  'ukaze',
  'ukaže',
  'ukazi',
  'ukaži',
  'ukazu',
  'ukažu',
  'ukida',
  'ukine',
  'ukini',
  'ukinu',
  'uklet',
  'ukoče',
  'ukoči',
  'ukopa',
  'ukope',
  'ukopi',
  'ukopu',
  'ukora',
  'ukori',
  'ukoso',
  'ukraj',
  'ukrao',
  'ukras',
  'ukrug',
  'ukuca',
  'ukuha',
  'ukusa',
  'ukuse',
  'ukusi',
  'ukusu',
  'ularu',
  'ulaza',
  'ulaze',
  'ulaže',
  'ulazi',
  'ulazu',
  'ulažu',
  'ulciǌ',
  'ulema',
  'uleme',
  'ulemi',
  'ulemu',
  'ulete',
  'uleti',
  'ulica',
  'ulice',
  'ulici',
  'ulico',
  'ulicu',
  'ulije',
  'uliju',
  'ulila',
  'ulili',
  'ulilo',
  'uliti',
  'uliva',
  'uljan',
  'uǉana',
  'uǉane',
  'uǉani',
  'uǉano',
  'uǉanu',
  'uljar',
  'uǉara',
  'uǉare',
  'uǉast',
  'uǉeći',
  'uljem',
  'uljen',
  'uǉene',
  'uǉeǌe',
  'uljez',
  'uǉeza',
  'uǉeze',
  'uǉezi',
  'uǉima',
  'uǉnih',
  'uǉnim',
  'uǉnog',
  'uǉnoj',
  'uǉnom',
  'ulkus',
  'uloga',
  'uloge',
  'ulogu',
  'ulova',
  'ulove',
  'ulovi',
  'ulovu',
  'ulože',
  'ulozi',
  'uloži',
  'ulrih',
  'uludo',
  'umače',
  'umaci',
  'umaći',
  'umaka',
  'umake',
  'umaku',
  'umalo',
  'umaǌe',
  'umaǌi',
  'umara',
  'umata',
  'umeće',
  'umeci',
  'umeću',
  'umeju',
  'umete',
  'umije',
  'umiju',
  'umile',
  'umili',
  'umine',
  'umini',
  'uminu',
  'umire',
  'umiri',
  'umiru',
  'umiti',
  'umiva',
  'umjet',
  'umnih',
  'umnik',
  'umnim',
  'umǌak',
  'umnog',
  'umnoj',
  'umnom',
  'umoli',
  'umora',
  'umore',
  'umori',
  'umoru',
  'umota',
  'umova',
  'umove',
  'umovi',
  'umrem',
  'umreš',
  'umuti',
  'uncom',
  'under',
  'unese',
  'unesi',
  'unesu',
  'unići',
  'uniđu',
  'unija',
  'unije',
  'uniji',
  'uniju',
  'union',
  'unmik',
  'unosa',
  'unose',
  'unosi',
  'unosu',
  'unuče',
  'unuci',
  'unuka',
  'unuke',
  'unuko',
  'unuku',
  'uočen',
  'uočio',
  'uočiš',
  'uopće',
  'uopći',
  'upada',
  'upade',
  'upadi',
  'upadu',
  'upala',
  'upale',
  'upali',
  'upalo',
  'upalu',
  'upare',
  'upari',
  'upere',
  'uperi',
  'upija',
  'upije',
  'upiju',
  'upila',
  'upili',
  'upiǌu',
  'upire',
  'upiru',
  'upisa',
  'upise',
  'upiše',
  'upisi',
  'upiši',
  'upisu',
  'upišu',
  'upita',
  'upite',
  'upiti',
  'upitu',
  'upleo',
  'upliv',
  'upola',
  'upora',
  'upore',
  'upori',
  'uporu',
  'uprem',
  'uprǉa',
  'upuca',
  'uputa',
  'upute',
  'uputi',
  'uputu',
  'uraci',
  'urade',
  'uradi',
  'urala',
  'urali',
  'uralo',
  'urama',
  'urana',
  'urani',
  'uraǌa',
  'uranu',
  'urara',
  'urari',
  'urate',
  'urati',
  'urban',
  'ureći',
  'ureda',
  'urede',
  'uredi',
  'uredu',
  'ureom',
  'ureza',
  'ureze',
  'ureže',
  'urezi',
  'urežu',
  'urica',
  'urici',
  'uricu',
  'urina',
  'urini',
  'urinu',
  'urlao',
  'urlik',
  'urnom',
  'uroci',
  'uroda',
  'urodu',
  'uroka',
  'uroke',
  'uroku',
  'urone',
  'uroni',
  'uroša',
  'urota',
  'urote',
  'uroti',
  'urotu',
  'uruče',
  'uruči',
  'uruše',
  'uruši',
  'usadi',
  'usame',
  'usami',
  'usana',
  'ušara',
  'ušaru',
  'ušćem',
  'usele',
  'useli',
  'usere',
  'useri',
  'useru',
  'ushit',
  'ušica',
  'ušice',
  'ušiće',
  'ušicu',
  'usije',
  'usiju',
  'ušiju',
  'usili',
  'usima',
  'ušima',
  'using',
  'usiri',
  'usisa',
  'usišu',
  'ušiti',
  'ušiva',
  'usjek',
  'usjev',
  'uskih',
  'uskim',
  'uskog',
  'uskoj',
  'uskok',
  'uskom',
  'usled',
  'usǉed',
  'uslov',
  'usmen',
  'usnat',
  'usnem',
  'usnen',
  'usnih',
  'ušnih',
  'usnik',
  'usnim',
  'ušnim',
  'usnog',
  'ušnog',
  'usnoj',
  'ušnoj',
  'usnom',
  'ušnom',
  'usnuh',
  'usnuo',
  'usnut',
  'usoli',
  'usovi',
  'uspeh',
  'uspem',
  'uspeo',
  'uspet',
  'uspio',
  'uspon',
  'usput',
  'usrah',
  'usran',
  'usred',
  'ustao',
  'uštap',
  'ustav',
  'ustuk',
  'usuda',
  'usude',
  'usudi',
  'usudu',
  'usula',
  'usule',
  'usuli',
  'ušuǉa',
  'ušuǌa',
  'usuti',
  'usuto',
  'utače',
  'utaja',
  'utaje',
  'utaji',
  'utaju',
  'utapa',
  'uteče',
  'uteći',
  'utega',
  'utege',
  'uteha',
  'uteku',
  'uteže',
  'utezi',
  'utiče',
  'utiči',
  'utiču',
  'utiha',
  'utiho',
  'utihu',
  'utire',
  'utiru',
  'utiša',
  'utkan',
  'utkao',
  'utoče',
  'utoka',
  'utoku',
  'utole',
  'utoli',
  'utone',
  'utoni',
  'utonu',
  'utope',
  'utopi',
  'utora',
  'utore',
  'utori',
  'utoru',
  'utovi',
  'utrči',
  'utrem',
  'utuče',
  'utući',
  'utura',
  'uture',
  'utuve',
  'utuvi',
  'utvom',
  'uvala',
  'uvale',
  'uvali',
  'uvalu',
  'uvaže',
  'uvaži',
  'uveća',
  'uveče',
  'uvede',
  'uvedi',
  'uvedu',
  'uvela',
  'uvele',
  'uveli',
  'uvelo',
  'uvelu',
  'uvene',
  'uveni',
  'uvenu',
  'uveri',
  'uvest',
  'uveze',
  'uveže',
  'uvezi',
  'uvezu',
  'uvežu',
  'uvida',
  'uviđa',
  'uvide',
  'uvidi',
  'uvidu',
  'uvija',
  'uvije',
  'uviju',
  'uvile',
  'uvire',
  'uviru',
  'uviše',
  'uviti',
  'uvjek',
  'uvjet',
  'uvoda',
  'uvode',
  'uvodi',
  'uvodu',
  'uvoza',
  'uvoze',
  'uvozi',
  'uvozu',
  'uvrću',
  'uvuče',
  'uvuci',
  'uvući',
  'uvuku',
  'užadi',
  'uzala',
  'uzana',
  'uzane',
  'uzani',
  'uzanu',
  'užara',
  'užare',
  'užari',
  'užasa',
  'užase',
  'užasi',
  'uzdah',
  'uzdaj',
  'uzdam',
  'uzdan',
  'uzdao',
  'uzdom',
  'uzduh',
  'uzduž',
  'uzeći',
  'užeći',
  'uzeću',
  'užega',
  'uzela',
  'uzele',
  'uzeli',
  'uzelo',
  'uzeše',
  'uzeta',
  'užeta',
  'uzete',
  'uzeti',
  'uzeto',
  'užetu',
  'užeže',
  'uzgoj',
  'uzgon',
  'uzica',
  'užica',
  'uzice',
  'užice',
  'uzici',
  'uzići',
  'užici',
  'užicu',
  'uzima',
  'uzimo',
  'užina',
  'užinu',
  'uživa',
  'užive',
  'uživi',
  'uživo',
  'uzlaz',
  'uzlet',
  'uzlom',
  'uzmak',
  'uzmem',
  'uzmeš',
  'uznik',
  'uznio',
  'uzora',
  'uzore',
  'uzori',
  'uzoru',
  'uzrok',
  'uzusa',
  'uzuse',
  'uzvik',
  'vabac',
  'vabom',
  'vađen',
  'vadim',
  'vadio',
  'vadiš',
  'vadit',
  'vagan',
  'vagat',
  'vagne',
  'vagni',
  'vagnu',
  'vagom',
  'vagon',
  'vajao',
  'vajar',
  'vajat',
  'vajda',
  'vajdi',
  'vajdu',
  'vajna',
  'vajni',
  'vajnu',
  'vakat',
  'vakif',
  'vakta',
  'vakti',
  'vaktu',
  'vakuf',
  'valić',
  'valja',
  'vaǉak',
  'vaǉam',
  'vaǉan',
  'vaǉao',
  'vaǉci',
  'vaǉda',
  'vaǉka',
  'vaǉke',
  'vaǉku',
  'valna',
  'valne',
  'valni',
  'valnu',
  'valom',
  'valov',
  'value',
  'vance',
  'vanja',
  'vapaj',
  'vapio',
  'vapit',
  'vapna',
  'vapno',
  'vapnu',
  'varaj',
  'varam',
  'varan',
  'varao',
  'varaš',
  'varat',
  'varav',
  'varci',
  'varen',
  'varga',
  'varit',
  'varka',
  'varke',
  'varki',
  'varko',
  'varku',
  'varna',
  'varne',
  'varom',
  'varoš',
  'vašar',
  'vašeg',
  'vašem',
  'vašer',
  'vasić',
  'vaših',
  'vasil',
  'vasiǉ',
  'vašim',
  'vaška',
  'vasko',
  'vašoj',
  'vašom',
  'vatom',
  'vatra',
  'vatre',
  'vatri',
  'vatro',
  'vatru',
  'vazal',
  'važan',
  'vazda',
  'važio',
  'važit',
  'važna',
  'važne',
  'važni',
  'važno',
  'važnu',
  'vazom',
  'veber',
  'većeg',
  'većem',
  'večer',
  'većih',
  'većim',
  'večna',
  'večni',
  'večno',
  'većoj',
  'većom',
  'vedar',
  'vedra',
  'vedre',
  'vedri',
  'vedro',
  'vedru',
  'vegan',
  'vegas',
  'vekna',
  'veles',
  'velik',
  'velim',
  'veliš',
  'veǉka',
  'veǉko',
  'velne',
  'velni',
  'velom',
  'velsa',
  'velsu',
  'venac',
  'venca',
  'vencu',
  'vendi',
  'venem',
  'venus',
  'veoma',
  'vepar',
  'vepra',
  'vepru',
  'veran',
  'verde',
  'verem',
  'vereš',
  'verna',
  'verne',
  'verni',
  'verom',
  'veruj',
  'veseo',
  'vesla',
  'vesli',
  'veslo',
  'veslu',
  'vesna',
  'vesta',
  'veste',
  'vesti',
  'vesto',
  'vestu',
  'vetar',
  'vetom',
  'vetra',
  'vetru',
  'vezan',
  'vezao',
  'vezat',
  'vežba',
  'vežbe',
  'vežbi',
  'vezem',
  'vežem',
  'vezen',
  'vežeš',
  'vezir',
  'vezla',
  'vezli',
  'vezlo',
  'vezna',
  'vezne',
  'vezni',
  'vezno',
  'veznu',
  'vezom',
  'vičan',
  'vicem',
  'vičem',
  'vicki',
  'vicko',
  'vična',
  'vični',
  'viđam',
  'vidan',
  'viđan',
  'viđao',
  'vidar',
  'vidaš',
  'videa',
  'viđen',
  'video',
  'videu',
  'vidić',
  'vidik',
  'vidim',
  'vidin',
  'vidio',
  'vidiš',
  'vidje',
  'vidna',
  'vidne',
  'vidni',
  'vidno',
  'vidnu',
  'vidom',
  'vidra',
  'vidre',
  'vidri',
  'vidru',
  'vigaǌ',
  'vigǌa',
  'vigǌu',
  'vigor',
  'vihor',
  'vijak',
  'vijci',
  'vijek',
  'vijem',
  'vijka',
  'vijke',
  'vijku',
  'vikah',
  'vikan',
  'vikao',
  'vikar',
  'vikat',
  'vikne',
  'vikni',
  'viknu',
  'vikom',
  'vilin',
  'vilom',
  'vinar',
  'vinca',
  'vinča',
  'vince',
  'vinci',
  'vinči',
  'vincu',
  'vinem',
  'vinil',
  'viǌak',
  'vinka',
  'vinko',
  'vinom',
  'vinov',
  'vinuo',
  'viola',
  'viole',
  'violi',
  'violu',
  'viriš',
  'virom',
  'virus',
  'visak',
  'višak',
  'višeg',
  'višem',
  'viših',
  'visim',
  'višim',
  'visio',
  'viska',
  'viška',
  'viske',
  'viski',
  'viški',
  'visku',
  'višku',
  'visle',
  'višǌa',
  'višǌa',
  'višǌi',
  'višǌu',
  'višoj',
  'visok',
  'visom',
  'višom',
  'vista',
  'vitak',
  'vitao',
  'vitez',
  'vitka',
  'vitke',
  'vitki',
  'vitko',
  'vitku',
  'vitla',
  'vitlo',
  'vitro',
  'vizir',
  'vizit',
  'vizom',
  'vjeđa',
  'vjeđe',
  'vjera',
  'vjere',
  'vjeri',
  'vjero',
  'vjeru',
  'vješa',
  'vješt',
  'vlada',
  'vlade',
  'vladi',
  'vlado',
  'vladu',
  'vlaga',
  'vlage',
  'vlago',
  'vlagu',
  'vlaha',
  'vlaho',
  'vlaji',
  'vlaka',
  'vlaku',
  'vlasi',
  'vlast',
  'vlati',
  'vlaže',
  'vlazi',
  'vlaži',
  'voćar',
  'voćem',
  'voćka',
  'voćke',
  'voćki',
  'voćku',
  'voćna',
  'voćne',
  'voćni',
  'voćno',
  'voćnu',
  'voden',
  'vođen',
  'vodič',
  'vodik',
  'vodim',
  'vođin',
  'vodio',
  'vodiš',
  'vodit',
  'vodke',
  'vodna',
  'vodne',
  'vodni',
  'vodno',
  'vodom',
  'vođom',
  'vogel',
  'vogue',
  'voice',
  'vojak',
  'vojin',
  'vojna',
  'vojne',
  'vojni',
  'vojno',
  'vojnu',
  'vokal',
  'voker',
  'volan',
  'volar',
  'volej',
  'voleo',
  'volga',
  'volge',
  'volić',
  'volim',
  'volio',
  'voliš',
  'volja',
  'voǉan',
  'voǉci',
  'volje',
  'voǉen',
  'voǉet',
  'volji',
  'voǉka',
  'voǉke',
  'voǉku',
  'voǉna',
  'voǉne',
  'voǉni',
  'voǉno',
  'voǉnu',
  'voǉom',
  'volju',
  'volta',
  'volte',
  'volti',
  'volto',
  'voltu',
  'volvo',
  'vonja',
  'voren',
  'vosak',
  'voska',
  'vosku',
  'votka',
  'votke',
  'votki',
  'votku',
  'vozač',
  'vozao',
  'vozar',
  'vozaš',
  'vožda',
  'vožen',
  'vozim',
  'vozio',
  'vozit',
  'vozna',
  'vozne',
  'vozni',
  'vožǌa',
  'vožǌe',
  'vožǌi',
  'vožǌu',
  'voznu',
  'vozom',
  'vraca',
  'vraća',
  'vrača',
  'vraču',
  'vraga',
  'vragu',
  'vrana',
  'vrane',
  'vrani',
  'vraǌa',
  'vraǌe',
  'vraǌu',
  'vranu',
  'vrata',
  'vrate',
  'vrati',
  'vratu',
  'vraže',
  'vrazi',
  'vrčem',
  'vrčić',
  'vreba',
  'vreća',
  'vreće',
  'vreći',
  'vreću',
  'vrede',
  'vredi',
  'vrela',
  'vrele',
  'vreli',
  'vrelo',
  'vrelu',
  'vreme',
  'vreǌa',
  'vreǌe',
  'vreǌu',
  'vreti',
  'vreva',
  'vreve',
  'vrevu',
  'vrije',
  'vriju',
  'vrimo',
  'vrite',
  'vriti',
  'vršac',
  'vršak',
  'vršca',
  'vršci',
  'vršcu',
  'vršen',
  'vršim',
  'vršio',
  'vršiš',
  'vršit',
  'vrška',
  'vrške',
  'vršku',
  'vršna',
  'vršne',
  'vršni',
  'vršno',
  'vršnu',
  'vruća',
  'vruće',
  'vruče',
  'vruci',
  'vrući',
  'vruću',
  'vruǉa',
  'vruǉe',
  'vučak',
  'vučem',
  'vučen',
  'vučić',
  'vučja',
  'vučje',
  'vučji',
  'vučju',
  'vučka',
  'vučko',
  'vučku',
  'vučna',
  'vučne',
  'vučni',
  'vučno',
  'vučnu',
  'vučom',
  'vudua',
  'vujić',
  'vukan',
  'vukao',
  'vukić',
  'vukla',
  'vukle',
  'vukli',
  'vuklo',
  'vukom',
  'vukov',
  'vulić',
  'vulva',
  'vulve',
  'vulvi',
  'vulvo',
  'vulvu',
  'vunen',
  'vunom',
  'zabac',
  'žabac',
  'žabaǉ',
  'žabar',
  'zabat',
  'zabih',
  'zabio',
  'zabit',
  'žabǉa',
  'žabǉe',
  'žabǉi',
  'žabǉu',
  'žabom',
  'začas',
  'začeo',
  'začet',
  'začin',
  'začne',
  'začuo',
  'zadah',
  'zadaj',
  'zadak',
  'zadan',
  'zadao',
  'zadar',
  'zadat',
  'zađem',
  'zadǌa',
  'zadǌe',
  'zadǌi',
  'zadǌu',
  'zadra',
  'zadre',
  'zadri',
  'zadro',
  'zadru',
  'zahod',
  'zajam',
  'zajeb',
  'zajeo',
  'zajma',
  'zajmi',
  'zajmu',
  'žaket',
  'zakla',
  'zakon',
  'zakri',
  'zakup',
  'žalac',
  'zalaz',
  'žalba',
  'žalbe',
  'žalbi',
  'žalbu',
  'žalci',
  'žalcu',
  'zalet',
  'zalih',
  'žalim',
  'zalio',
  'žalio',
  'žališ',
  'zalit',
  'žalit',
  'zaliv',
  'zaǉev',
  'zalog',
  'zalud',
  'zamah',
  'zamak',
  'zamci',
  'zameo',
  'zamet',
  'zamka',
  'zamke',
  'zamki',
  'zamko',
  'zamku',
  'zamor',
  'žamor',
  'zamre',
  'zamro',
  'zanat',
  'zanio',
  'žanje',
  'žaǌem',
  'žanju',
  'žanka',
  'zanos',
  'žanra',
  'žanru',
  'žaoka',
  'žaoke',
  'žaoku',
  'zaori',
  'zaova',
  'zapad',
  'zapah',
  'zapao',
  'žapca',
  'zapeo',
  'zapet',
  'zapis',
  'zapne',
  'zapni',
  'zapnu',
  'zapor',
  'zapre',
  'zapri',
  'zapru',
  'zapuh',
  'žarač',
  'zarad',
  'žaren',
  'zarez',
  'zarić',
  'zarih',
  'zarij',
  'zario',
  'žario',
  'žarka',
  'žarke',
  'žarki',
  'žarko',
  'žarku',
  'žarna',
  'žarne',
  'žarni',
  'žarnu',
  'žarom',
  'zarza',
  'zasad',
  'zašao',
  'zasij',
  'zašio',
  'zasja',
  'zašla',
  'zašle',
  'zašli',
  'zašlo',
  'zaspa',
  'zaspe',
  'zaspi',
  'zaspu',
  'zašta',
  'zasto',
  'zašto',
  'zasun',
  'zasut',
  'zatim',
  'zatka',
  'zatku',
  'zaton',
  'zator',
  'zatre',
  'zatri',
  'zatru',
  'zauze',
  'zaveo',
  'zavet',
  'zavih',
  'zavio',
  'zavod',
  'zavoj',
  'zavor',
  'zavre',
  'zazor',
  'zazva',
  'zbace',
  'zbaci',
  'žbica',
  'zbiće',
  'žbice',
  'žbici',
  'žbicu',
  'zbija',
  'zbije',
  'zbiju',
  'zbila',
  'zbile',
  'zbili',
  'zbiǉa',
  'zbiǉe',
  'zbiǉi',
  'zbiǉu',
  'zbilo',
  'zbira',
  'zbiri',
  'zbiru',
  'zbiti',
  'zbiva',
  'zbora',
  'zbore',
  'zbori',
  'zboru',
  'žbuka',
  'žbuke',
  'žbuku',
  'žbuna',
  'zbune',
  'zbuni',
  'žbuǌa',
  'žbuǌe',
  'žbuǌu',
  'žbunu',
  'zdaǌa',
  'zdaǌe',
  'zdaǌu',
  'zdere',
  'zdimi',
  'zdola',
  'ždral',
  'zebem',
  'zebǌa',
  'zebǌu',
  'zebom',
  'zebra',
  'zebre',
  'zebri',
  'zebru',
  'zečić',
  'zečja',
  'zečje',
  'zečji',
  'zečju',
  'zecom',
  'žedan',
  'zeder',
  'žedna',
  'žedne',
  'žedni',
  'žedno',
  'zefir',
  'zekan',
  'zekat',
  'zekom',
  'zelda',
  'želea',
  'zelen',
  'želeo',
  'želeu',
  'zelić',
  'želim',
  'želio',
  'želiš',
  'zelja',
  'želja',
  'žeǉan',
  'zelje',
  'želje',
  'zeǉem',
  'žeǉen',
  'želji',
  'žeǉka',
  'žeǉko',
  'žeǉna',
  'žeǉne',
  'žeǉni',
  'žeǉno',
  'žeǉnu',
  'željo',
  'žeǉom',
  'zelju',
  'želju',
  'zelot',
  'zemǉa',
  'žemǉa',
  'zemǉe',
  'žemǉe',
  'zemǉi',
  'zemǉo',
  'zemǉu',
  'zemna',
  'zemne',
  'zemni',
  'zemno',
  'zemnu',
  'zemun',
  'ženik',
  'ženim',
  'ženin',
  'ženio',
  'zenit',
  'ženka',
  'ženke',
  'ženki',
  'ženku',
  'zenom',
  'ženom',
  'zerom',
  'žešća',
  'žešće',
  'žešći',
  'žešću',
  'zetom',
  'žeton',
  'zetva',
  'žetva',
  'žetve',
  'žetvi',
  'žetvu',
  'zeusa',
  'zevsa',
  'zezaj',
  'zezam',
  'zezaš',
  'zezat',
  'žezla',
  'žezlo',
  'zgade',
  'zgadi',
  'zgazi',
  'zgoda',
  'zgode',
  'zgodi',
  'zgodu',
  'zguli',
  'zgura',
  'zgure',
  'zhang',
  'žičan',
  'zicer',
  'žične',
  'žični',
  'žicom',
  'zidah',
  'židak',
  'zidan',
  'zidao',
  'zidar',
  'zidić',
  'zidna',
  'zidne',
  'zidni',
  'zidno',
  'zidnu',
  'zidom',
  'židov',
  'žigom',
  'žigon',
  'zigot',
  'zijah',
  'zijam',
  'zijan',
  'zijev',
  'žilav',
  'zilet',
  'žilet',
  'žilni',
  'žilom',
  'zimom',
  'zimus',
  'zinem',
  'zipci',
  'zipka',
  'zipke',
  'žirom',
  'žirov',
  'žiška',
  'žiške',
  'žitak',
  'žiteǉ',
  'žitke',
  'žitki',
  'žitko',
  'žitna',
  'žitne',
  'žitni',
  'žitno',
  'žitnu',
  'žitom',
  'živac',
  'živaǉ',
  'živan',
  'živca',
  'živce',
  'živci',
  'živcu',
  'živeo',
  'živež',
  'živih',
  'živim',
  'živin',
  'živio',
  'živiš',
  'živka',
  'živko',
  'živǉa',
  'živǉe',
  'živǉi',
  'živǉu',
  'živne',
  'živog',
  'živoj',
  'živom',
  'zivot',
  'život',
  'žižak',
  'zjape',
  'zjapi',
  'zlata',
  'zlate',
  'zlati',
  'zlato',
  'zlatu',
  'žlica',
  'zlima',
  'zloba',
  'zlobe',
  'zlobi',
  'zloća',
  'zloće',
  'zloći',
  'zlota',
  'zlote',
  'zloti',
  'zmaja',
  'zmaju',
  'zmija',
  'zmije',
  'zmiji',
  'zmiju',
  'znače',
  'znaci',
  'znači',
  'znade',
  'znadu',
  'znaju',
  'znaka',
  'znake',
  'znaku',
  'znala',
  'znale',
  'znali',
  'znalo',
  'znamo',
  'znana',
  'znane',
  'znani',
  'znaǌa',
  'znaǌe',
  'znaǌu',
  'znano',
  'znanu',
  'znaše',
  'znate',
  'znati',
  'znoja',
  'znoje',
  'znoji',
  'znoju',
  'zobam',
  'zoben',
  'zobǉe',
  'zobun',
  'žohar',
  'zolja',
  'zolje',
  'zolji',
  'zoǉom',
  'zombi',
  'zonom',
  'zoran',
  'zorić',
  'zorim',
  'zorio',
  'zorka',
  'zorna',
  'zorni',
  'zorno',
  'zorom',
  'žorža',
  'zovem',
  'zoveš',
  'zovko',
  'zovne',
  'zovni',
  'zovnu',
  'zovom',
  'žozef',
  'zrače',
  'zraci',
  'zrači',
  'zraka',
  'zrake',
  'zrako',
  'zraku',
  'žreca',
  'zrela',
  'zrele',
  'zreli',
  'zrelo',
  'zrelu',
  'zreǌa',
  'zreǌe',
  'zreǌu',
  'zreti',
  'zrije',
  'zriju',
  'zrika',
  'zrimo',
  'zrite',
  'zrǌem',
  'žrvaǌ',
  'žrvǌa',
  'žrvǌu',
  'zubac',
  'zubar',
  'zubat',
  'zubić',
  'zubin',
  'zubna',
  'zubne',
  'zubni',
  'zubno',
  'zubnu',
  'zubom',
  'žubor',
  'žučna',
  'žučne',
  'žučni',
  'zucnu',
  'žučnu',
  'žudan',
  'žudim',
  'žudio',
  'žudna',
  'žudǌa',
  'žudǌe',
  'žudǌi',
  'žudǌo',
  'žudǌu',
  'zujem',
  'zujim',
  'žukov',
  'žulja',
  'žuǉan',
  'žulji',
  'zulum',
  'zumba',
  'župan',
  'zupca',
  'zupča',
  'zupce',
  'zupče',
  'zupci',
  'zupcu',
  'župna',
  'župne',
  'župni',
  'župnu',
  'župom',
  'žuran',
  'žurba',
  'žurbe',
  'žurbi',
  'žurbu',
  'žurci',
  'žurim',
  'zurio',
  'žurio',
  'žuriš',
  'žurka',
  'žurke',
  'žurku',
  'žurne',
  'žurno',
  'žutić',
  'žutih',
  'žutim',
  'žutog',
  'žutoj',
  'žutom',
  'zvaće',
  'žvače',
  'zvaću',
  'žvaču',
  'zvahu',
  'žvaka',
  'zvala',
  'žvala',
  'zvale',
  'žvale',
  'zvali',
  'zvalo',
  'zvana',
  'zvane',
  'zvani',
  'zvaǌa',
  'zvaǌe',
  'zvaǌu',
  'zvano',
  'zvanu',
  'zvaše',
  'zvati',
  'zveče',
  'zveči',
  'zveka',
  'zveri',
  'zvona',
  'zvone',
  'zvoni',
  'zvono',
  'zvonu',
  'zvuče',
  'zvuci',
  'zvuči',
  'zvuka',
  'zvuke',
  'zvuku',
]
